import * as React from 'react';
import React__default, { forwardRef, useEffect, useState, useMemo, useRef, useCallback, useReducer, useContext, memo, useLayoutEffect } from 'react';
import { colors } from '@keen.io/colors';
import styled, { css, createGlobalStyle } from 'styled-components';
import { typography, variant, layout } from 'styled-system';
import { transparentize, rgba } from 'polished';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '@keen.io/icons';
import Color$2 from 'color';
import { generateContinuousColorScale, formatValue } from '@keen.io/charts-utils';
import Sortable from 'sortablejs';
import { useOnClickOutside, useSearch, useOnParentScroll, useDynamicContentPosition, useKeypress, useTooltip } from '@keen.io/react-hooks';
import { SketchPicker } from 'react-color';
import ReactDOM, { createPortal } from 'react-dom';
import ReactSelect from 'react-select';
import { BodyText, Headline } from '@keen.io/typography';
import { useInView } from 'react-intersection-observer';
import Measure from 'react-measure';
import dayjs from 'dayjs';
import Calendar from 'react-calendar';
import { FixedSizeList } from 'react-window';
import { FixedSizeTree } from 'react-vtree';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var BaseText = styled.div.withConfig({
  displayName: "textcomponent__BaseText",
  componentId: "keen-ui-core__sc-13re0gd-0"
})(["&&&{", ";color:", ";margin:0;padding:0;", ";}"], typography, function (props) {
  return props.fontColor;
}, function (props) {
  return props.truncate && css(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
});

var Text$1 = function Text(_ref) {
  var children = _ref.children,
      _ref$truncate = _ref.truncate,
      truncate = _ref$truncate === void 0 ? false : _ref$truncate,
      _ref$htmlElement = _ref.htmlElement,
      htmlElement = _ref$htmlElement === void 0 ? 'div' : _ref$htmlElement,
      props = _objectWithoutProperties(_ref, ["children", "truncate", "htmlElement"]);

  return React__default.createElement(BaseText, Object.assign({
    as: htmlElement,
    truncate: truncate
  }, props), children);
};

var textVariants = {
  h1: {
    fontFamily: 'Gangster Grotesk',
    fontWeight: 'bold',
    fontSize: 36,
    lineHeight: '40px'
  },
  h2: {
    fontFamily: 'Gangster Grotesk',
    fontWeight: 'bold',
    fontSize: 30,
    lineHeight: '34px'
  },
  h3: {
    fontFamily: 'Gangster Grotesk',
    fontWeight: 'normal',
    fontSize: 20,
    lineHeight: '22px'
  },
  h4: {
    fontFamily: 'Lato',
    fontWeight: 'normal',
    fontSize: 16,
    lineHeight: '20px'
  },
  h5: {
    fontFamily: 'Lato',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '14px'
  },
  h6: {
    fontFamily: 'Lato',
    fontWeight: 'normal',
    fontSize: 10,
    lineHeight: '12px'
  },
  'body-normal': {
    fontFamily: 'Lato',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '16px'
  },
  'body-bold': {
    fontFamily: 'Lato',
    fontWeight: 'bold',
    fontSize: 14,
    lineHeight: '16px'
  },
  'number-xl': {
    fontFamily: 'Lato',
    fontWeight: 'lighter',
    fontSize: 55,
    lineHeight: '64px'
  },
  'number-l': {
    fontFamily: 'Lato',
    fontWeight: 'lighter',
    fontSize: 40,
    lineHeight: '50px'
  },
  'number-m': {
    fontFamily: 'Lato',
    fontWeight: 'lighter',
    fontSize: 30,
    lineHeight: '36px'
  },
  'number-s': {
    fontFamily: 'Lato',
    fontWeight: 'normal',
    fontSize: 16,
    lineHeight: '24px'
  }
};
var theme = {
  font: {
    GangsterGrotesk: 'Gangster Grotesk',
    Lato: 'Lato'
  }
};
var solidButtonVariants = {
  prop: 'variant',
  variants: {
    primary: {
      backgroundColor: colors.yellow['400'],
      borderColor: colors.yellow['400'],
      color: colors.black['500'],
      '&:focus': {
        boxShadow: "0 0 0 0.2rem rgba(218,165,80, .5)"
      },
      '&:hover': {
        color: colors.black['400'],
        backgroundColor: colors.yellow['500']
      }
    },
    secondary: {
      backgroundColor: colors.blue['500'],
      borderColor: colors.blue['500'],
      color: colors.white['500'],
      boxShadow: "0 2px 4px 0 ".concat(transparentize(0.85, colors.black['500'])),
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: colors.blue['400']
      }
    },
    danger: {
      backgroundColor: colors.red['500'],
      borderColor: colors.red['500'],
      color: colors.white['500'],
      boxShadow: "0 1px 4px 0 ".concat(transparentize(0.85, colors.black['500'])),
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: colors.red['300']
      }
    },
    success: {
      backgroundColor: colors.green['300'],
      borderColor: colors.green['300'],
      color: colors.white['500'],
      boxShadow: "0 1px 4px 0 ".concat(transparentize(0.85, colors.black['500'])),
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: colors.green['400']
      }
    },
    blank: {
      backgroundColor: colors.white['500'],
      color: colors.blue['500'],
      boxShadow: "0 1px 4px 0 ".concat(transparentize(0.85, colors.black['500'])),
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: transparentize(0.8, colors.blue['100'])
      }
    }
  }
};

var HTML_ELEMENTS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
var Title$3 = function Title(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'h1' : _ref$variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors.black['100'] : _ref$color;
  var typography = textVariants[variant];
  return React__default.createElement(BaseText, Object.assign({
    as: HTML_ELEMENTS.includes(variant) ? variant : 'div',
    fontColor: color
  }, typography), children);
};

var RefText = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$truncate = _ref.truncate,
      truncate = _ref$truncate === void 0 ? false : _ref$truncate,
      props = _objectWithoutProperties(_ref, ["children", "truncate"]);

  return React__default.createElement(BaseText, Object.assign({
    ref: ref,
    truncate: truncate
  }, props), children);
});
RefText.displayName = 'RefText';

var predefinedFonts = [theme.font.GangsterGrotesk, theme.font.Lato];

var FontLoader = /*#__PURE__*/function () {
  function FontLoader() {
    _classCallCheck(this, FontLoader);

    this.fonts = [];

    if (FontLoader.instance) {
      throw new Error('Error: Use FontLoader.getInstance() instead of new.');
    }
  }

  _createClass(FontLoader, [{
    key: "loadFont",
    value: async function loadFont(fonts) {
      var _this = this;

      var customFamilies = predefinedFonts.filter(function (font) {
        return !_this.fonts.includes(font);
      });
      var googleFamilies = fonts.filter(function (font) {
        return !_this.fonts.includes(font) && !predefinedFonts.includes(font);
      });
      var WebFont = (await import('webfontloader')).default;

      if (customFamilies.length || googleFamilies.length) {
        WebFont.load(_objectSpread2(_objectSpread2(_objectSpread2({}, googleFamilies.length && {
          google: {
            families: googleFamilies
          }
        }), customFamilies.length && {
          custom: {
            families: customFamilies
          }
        }), {}, {
          fontactive: function fontactive(familyName) {
            return _this.fonts.push(familyName);
          },
          fontinactive: function fontinactive(familyName, fvd) {
            return console.error("We're not able to load ".concat(familyName, " ").concat(fvd, " font"));
          }
        }));
      }
    }
  }, {
    key: "getActiveFonts",
    value: function getActiveFonts() {
      return this.fonts;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!FontLoader.instance) {
        FontLoader.instance = new FontLoader();
      }

      return FontLoader.instance;
    }
  }]);

  return FontLoader;
}();

var FontLoaderInstance = FontLoader.getInstance();

var useFontLoader = function useFontLoader(fontFamilies) {
  useEffect(function () {
    FontLoaderInstance.loadFont(fontFamilies);
  }, [fontFamilies]);
  return FontLoaderInstance.getActiveFonts();
};

var CDNContext = React__default.createContext({
  url: ''
});

var screenBreakpoints = ['0', '600px', '960px', '1280px', '1920px'];
screenBreakpoints.xs = screenBreakpoints[0];
screenBreakpoints.sm = screenBreakpoints[1];
screenBreakpoints.md = screenBreakpoints[2];
screenBreakpoints.lg = screenBreakpoints[3];
screenBreakpoints.xl = screenBreakpoints[4];

var alertVariants = {
  prop: 'type',
  variants: {
    success: {
      color: colors.green['500'],
      borderColor: colors.green['400'],
      background: transparentize(0.8, colors.green['100'])
    },
    error: {
      color: colors.red['500'],
      borderColor: colors.red['500'],
      background: transparentize(0.6, colors.red['100'])
    },
    info: {
      color: colors.blue['500'],
      borderColor: colors.blue['200'],
      background: transparentize(0.6, colors.lightBlue['300'])
    }
  }
};
var StyledAlert = styled.div.withConfig({
  displayName: "alertstyles__StyledAlert",
  componentId: "keen-ui-core__sc-82aa9s-0"
})(["&&&{padding:10px 20px;border-left:solid;font-family:'Lato Regular',sans-serif;font-size:14px;line-height:16px;font-weight:400;", ";", ";}"], function (_ref) {
  var contentWidth = _ref.contentWidth;
  return contentWidth && css(["display:inline-block;"]);
}, variant(alertVariants));

var Alert = function Alert(_ref) {
  var type = _ref.type,
      _ref$contentWidth = _ref.contentWidth,
      contentWidth = _ref$contentWidth === void 0 ? false : _ref$contentWidth,
      children = _ref.children;
  return React__default.createElement(StyledAlert, {
    role: "alert",
    type: type,
    contentWidth: contentWidth
  }, children);
};

var Anchor = styled.a.withConfig({
  displayName: "anchorcomponent__Anchor",
  componentId: "keen-ui-core__sc-lz5f60-0"
})(["&&&{color:", ";font-family:'Lato Bold',sans-serif;font-size:14px;line-height:16px;text-decoration:none;transition:all 0.2s linear;}&&&:hover{color:", ";}"], function (props) {
  return props.color;
}, function (props) {
  return props.hoverColor;
});
Anchor.defaultProps = {
  color: colors.blue['100'],
  hoverColor: colors.blue['200']
};

var createVariants = function createVariants(isActive) {
  var opacity = isActive ? 0.4 : 0.7;
  return {
    prop: 'variant',
    variants: {
      black: {
        color: colors.black[500],
        backgroundColor: transparentize(opacity, colors.black[100])
      },
      red: {
        color: colors.red[500],
        backgroundColor: transparentize(opacity, colors.red[100])
      },
      white: {
        color: colors.white[500],
        backgroundColor: transparentize(opacity, colors.white[200])
      },
      purple: {
        color: colors.purple[500],
        backgroundColor: transparentize(opacity, colors.purple[100])
      },
      orange: {
        color: colors.orange[500],
        backgroundColor: transparentize(opacity, colors.orange[100])
      },
      yellow: {
        color: colors.yellow[500],
        backgroundColor: transparentize(opacity, colors.yellow[100])
      },
      green: {
        color: colors.green[500],
        backgroundColor: transparentize(opacity, colors.green[100])
      },
      gray: {
        color: colors.black[100],
        backgroundColor: transparentize(opacity, colors.gray[500])
      },
      pink: {
        color: colors.pink[500],
        backgroundColor: transparentize(opacity, colors.pink[100])
      },
      lightBlue: {
        color: colors.lightBlue[500],
        backgroundColor: transparentize(opacity, colors.lightBlue[100])
      },
      blue: {
        color: colors.blue[500],
        backgroundColor: transparentize(opacity, colors.blue[100])
      }
    }
  };
};

var UI_LAYERS = {
  notification: 60,
  tooltip: 55,
  modal: 50,
  fixedBar: 40,
  dropdown: 20,
  element: 10
};
var TIME_UNITS = {
  minute: 'minutes',
  hour: 'hours',
  day: 'days',
  week: 'weeks',
  month: 'months',
  year: 'years'
};
var KEYBOARD_KEYS = {
  UP: 38,
  DOWN: 40,
  ENTER: 13,
  ESCAPE: 27
};

var Container$F = styled.div.withConfig({
  displayName: "badgestyles__Container",
  componentId: "keen-ui-core__sc-i92ibg-0"
})(["&&&{display:inline-flex;align-items:stretch;justify-content:center;position:relative;min-width:0;", ";", ";}"], function (props) {
  return props.isCSSTruncated && css(["max-width:inherit;"]);
}, function (props) {
  return props.pointer && css(["cursor:pointer;"]);
});
var TextWrapper = styled.span.withConfig({
  displayName: "badgestyles__TextWrapper",
  componentId: "keen-ui-core__sc-i92ibg-1"
})(["&&&{display:block;padding:2px 4px;font-family:'Lato Bold',sans-serif;font-size:13px;line-height:16px;white-space:nowrap;border-radius:", ";transition:background-color 0.3s ease-in-out;", ";", ";}"], function (props) {
  return props.removable ? '2px 0 0 2px' : '2px';
}, function (props) {
  return props.isTruncated && css(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
}, function (props) {
  return variant(createVariants(props.isActive));
});
var IconWrapper$1 = styled.div.withConfig({
  displayName: "badgestyles__IconWrapper",
  componentId: "keen-ui-core__sc-i92ibg-2"
})(["&&&{display:flex;align-items:center;justify-content:center;padding:2px 4px;margin-left:1px;border-radius:0 2px 2px 0;transition:background-color 0.3s ease-in-out;", ";}"], function (props) {
  return variant(createVariants(props.isActive));
});
var TooltipMotion = styled(motion.div).withConfig({
  displayName: "badgestyles__TooltipMotion",
  componentId: "keen-ui-core__sc-i92ibg-3"
})(["&&&{position:absolute;left:50%;top:10px;transform:translateX(-50%) translateY(50%);min-width:170px;z-index:", ";}"], UI_LAYERS.tooltip);

var truncate = function truncate(input) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
  if (input.length <= maxLength) return {
    value: input,
    isTruncated: false
  };
  var words = input.split(' ');
  var output = '';
  var numberOfOutputCharacters = 0;
  words.some(function (word, index) {
    var wordLength = word.length;
    numberOfOutputCharacters += wordLength;

    if (index > 0) {
      numberOfOutputCharacters += 1;
    }

    if (numberOfOutputCharacters <= maxLength) {
      output += addSpace(word, index);
    } else if (numberOfOutputCharacters > maxLength) {
      var numberOfCharactersExceeded = numberOfOutputCharacters - maxLength;
      var numberOfCharactersToShow = wordLength - numberOfCharactersExceeded;

      if (numberOfCharactersToShow < 2) {
        output += '...';
        return true;
      }

      output += addSpace(word.substring(0, numberOfCharactersToShow) + '...', index);
      return true;
    } else {
      output += '...';
      return true;
    }
  });
  return {
    value: output,
    isTruncated: true
  };
};

var addSpace = function addSpace(word, index) {
  if (index > 0) {
    return ' ' + word;
  }

  return word;
};

var calculateHypotenuseHeight = function calculateHypotenuseHeight(x, y) {
  return Math.sqrt(x * x + y * y);
};

var isElementInViewport = function isElementInViewport(element) {
  var _element$getBoundingC = element.getBoundingClientRect(),
      top = _element$getBoundingC.top;

  return top >= 0 && top < window.innerHeight;
};

var download = function download(content, fileName, fileType) {
  var a = document.createElement('a');
  var mimeType = fileType || 'application/octet-stream';

  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(new Blob([content], {
      type: mimeType
    }), fileName);
  } else if (URL && 'download' in a) {
    a.href = URL.createObjectURL(new Blob([content], {
      type: mimeType
    }));
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    location.href = 'data:application/octet-stream,' + encodeURIComponent(content);
  }
};

var FILENAME = 'code-snippet';

var exportToHtml = function exportToHtml(_ref) {
  var data = _ref.data,
      _ref$fileName = _ref.fileName,
      fileName = _ref$fileName === void 0 ? FILENAME : _ref$fileName;
  var downloadFileName = fileName;
  var hasExtension = fileName.includes('.html');

  if (!hasExtension) {
    downloadFileName = "".concat(fileName, ".html");
  }

  download(data, downloadFileName, 'text/html;charset:utf-8');
};

var mutate = function mutate(array, from, to) {
  var startIndex = to < 0 ? array.length + to : to;

  if (startIndex >= 0 && startIndex < array.length) {
    var item = array.splice(from, 1)[0];
    array.splice(startIndex, 0, item);
  }

  return array;
};

var mutateArray = function mutateArray(array, from, to) {
  array = _toConsumableArray(array);
  mutate(array, from, to);
  return array;
};

var LIGHT_MODE_BACKGROUND = Color$2(colors.white['500']).fade(0.05).rgb().toString();
var DARK_MODE_BACKGROUND = Color$2(colors.black['200']).fade(0.05).rgb().toString();
var ARROW_SIZE = 4;
var Wrapper$3 = styled.div.withConfig({
  displayName: "tooltipcomponent__Wrapper",
  componentId: "keen-ui-core__sc-tulkl6-0"
})(["&&&{", ";box-sizing:border-box;background-color:", ";border-radius:", ";font-family:", ";font-size:", ";color:", ";line-height:", ";box-shadow:", ";position:relative;", ";}&&&::after{", ";content:'';position:absolute;width:0;height:0;box-sizing:border-box;border:", "px solid ", ";box-shadow:", ";", ";}"], function (props) {
  return props.hasSpacing && css(["padding:10px 15px;"]);
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.fontFamily;
}, function (props) {
  return props.fontSize + 'px';
}, function (props) {
  return props.fontColor;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.hasShadow ? '0 10px 24px 0 rgba(29, 39, 41, 0.15)' : 'none';
}, variant({
  prop: 'mode',
  variants: {
    light: {
      backgroundColor: LIGHT_MODE_BACKGROUND,
      color: colors.black['200']
    },
    dark: {
      backgroundColor: DARK_MODE_BACKGROUND,
      color: colors.white['500']
    }
  }
}), function (props) {
  return !props.hasArrow && css(["display:none;"]);
}, ARROW_SIZE, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.hasShadow ? '-3px 3px 24px 0 rgba(29, 39, 41, 0.15)' : 'none';
}, function (props) {
  var arrowColor = props.backgroundColor;

  switch (props.mode) {
    case 'light':
      arrowColor = LIGHT_MODE_BACKGROUND;
      break;

    case 'dark':
      arrowColor = DARK_MODE_BACKGROUND;
      break;
  }

  return variant({
    prop: 'arrowDirection',
    variants: {
      left: {
        borderColor: "".concat(arrowColor, " transparent transparent ").concat(arrowColor),
        top: "".concat(props.arrowTop ? props.arrowTop : '50%'),
        bottom: 'auto',
        left: '1px',
        right: 'auto',
        transform: "rotate(-45deg) translateY(-50%) translateY(-".concat(ARROW_SIZE / 2, "px)")
      },
      right: {
        borderColor: "transparent ".concat(arrowColor, " ").concat(arrowColor, " transparent"),
        top: "".concat(props.arrowTop ? props.arrowTop : '50%'),
        bottom: 'auto',
        right: "-".concat(Math.floor(calculateHypotenuseHeight(ARROW_SIZE, ARROW_SIZE)), "px"),
        transform: "rotate(-45deg) translateY(-50%) translateX(".concat(ARROW_SIZE / 2, "px)")
      },
      top: {
        borderColor: "".concat(arrowColor, " ").concat(arrowColor, " transparent transparent"),
        top: "-".concat(Math.floor(calculateHypotenuseHeight(ARROW_SIZE, ARROW_SIZE)), "px"),
        bottom: 'auto',
        left: '50%',
        right: 'auto',
        transform: "rotate(-45deg) translateX(-50%) translateY(-".concat(ARROW_SIZE / 2, "px)")
      },
      bottom: {
        borderColor: "transparent transparent ".concat(arrowColor, " ").concat(arrowColor),
        top: 'auto',
        bottom: '1px',
        left: '50%',
        right: 'auto',
        transform: "rotate(-45deg) translateX(-50%) translateX(-".concat(ARROW_SIZE / 2, "px)")
      }
    }
  });
});

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      mode = _ref.mode,
      arrowDirection = _ref.arrowDirection,
      props = _objectWithoutProperties(_ref, ["children", "mode", "arrowDirection"]);

  return React__default.createElement(Wrapper$3, Object.assign({
    mode: mode,
    arrowDirection: arrowDirection
  }, props), children);
};

Tooltip.defaultProps = {
  backgroundColor: colors.white['500'],
  fontColor: colors.black['200'],
  fontSize: 14,
  fontFamily: "'Lato Regular',sans-serif",
  mode: 'light',
  borderRadius: '0px',
  hasShadow: true,
  hasArrow: true,
  hasSpacing: true,
  arrowDirection: 'bottom',
  lineHeight: 'initial'
};

var Badge = function Badge(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'purple' : _ref$variant,
      removable = _ref.removable,
      onClick = _ref.onClick,
      onRemove = _ref.onRemove,
      truncate$1 = _ref.truncate,
      _ref$truncateMethod = _ref.truncateMethod,
      truncateMethod = _ref$truncateMethod === void 0 ? 'programmatical' : _ref$truncateMethod;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setActive = _useState2[1];

  var tooltipMotion = {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  };
  var isCSSTruncated = truncateMethod === 'css';
  var isTruncated = truncate$1;
  var truncatedLabel = children;

  if (truncate$1 && typeof children === 'string' && truncateMethod === 'programmatical') {
    var truncateResult = truncate(children);
    isTruncated = truncateResult.isTruncated;
    truncatedLabel = truncateResult.value;
  }

  return React__default.createElement(Container$F, {
    onMouseEnter: function onMouseEnter() {
      return onClick && setActive(true);
    },
    onMouseLeave: function onMouseLeave() {
      return onClick && setActive(false);
    },
    pointer: !!onClick,
    isCSSTruncated: isCSSTruncated
  }, React__default.createElement(TextWrapper, {
    variant: variant,
    isActive: isActive,
    removable: removable,
    onClick: onClick,
    isTruncated: isCSSTruncated
  }, isTruncated ? truncatedLabel : children), removable && React__default.createElement(IconWrapper$1, {
    variant: variant,
    isActive: isActive,
    onClick: onRemove,
    "data-testid": "badge-remove"
  }, React__default.createElement(Icon, {
    type: "close",
    fill: "currentColor",
    opacity: 0.5,
    width: 8,
    height: 8
  })), isTruncated && React__default.createElement(AnimatePresence, null, isActive && React__default.createElement(TooltipMotion, Object.assign({}, tooltipMotion), React__default.createElement(Tooltip, {
    arrowDirection: "top"
  }, children))));
};

var createOutlineButton = function createOutlineButton(baseColor) {
  return {
    backgroundColor: 'transparent',
    border: "solid 1px ".concat(baseColor),
    color: baseColor,
    boxShadow: "0 2px 4px 0 ".concat(transparentize(0.85, colors.black['500'])),
    '&:hover': {
      boxShadow: 'none',
      color: colors.white['500'],
      backgroundColor: baseColor
    }
  };
};

var outlineVariants = {
  prop: 'variant',
  variants: {
    primary: createOutlineButton(colors.yellow['400']),
    success: createOutlineButton(colors.green['300']),
    secondary: createOutlineButton(colors.blue['500']),
    danger: createOutlineButton(colors.red['500'])
  }
};
var sizeVariants = {
  prop: 'size',
  variants: {
    default: {
      fontSize: '15px',
      height: '37px'
    },
    small: {
      fontSize: '14px',
      height: '27px'
    },
    large: {
      fontSize: '15px',
      height: '45px'
    }
  }
};
var activeVariants = {
  prop: 'variant',
  variants: {
    blank: {
      boxShadow: 'none',
      backgroundColor: transparentize(0.8, colors.blue['100'])
    }
  }
};
var disabledVariants = {
  prop: 'variant',
  variants: {
    secondary: {
      color: transparentize(0.5, colors.white['500']),
      backgroundColor: transparentize(0.5, colors.blue['500']),
      boxShadow: 'none',
      '&:hover': {
        color: transparentize(0.5, colors.white['500']),
        backgroundColor: transparentize(0.5, colors.blue['500']),
        boxShadow: 'none'
      }
    },
    success: {
      opacity: 0.5,
      pointerEvents: 'none'
    }
  }
};

var buttonMixin = function buttonMixin() {
  return css(["font-family:'Lato Bold',sans-serif;text-decoration:none;border-radius:25px;padding:0 25px;outline:none;border:none;cursor:pointer;align-items:center;transition:color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,-webkit-box-shadow 0.15s ease-in-out;&:hover{text-decoration:none;}&:focus-visible{outline:1px solid ", ";}"], colors.lightBlue[500]);
};

var StyledButton$2 = styled.button.withConfig({
  displayName: "buttonstyles__StyledButton",
  componentId: "keen-ui-core__sc-17t931m-0"
})(["&&&{display:flex;", ";", ";", ";", ";", ";", ";", ";", ";}"], function (props) {
  return props.fullWidth && css(["width:100%;justify-content:center;"]);
}, buttonMixin(), function (props) {
  return props.body === 'solid' && variant(solidButtonVariants);
}, function (props) {
  return props.body === 'outline' && variant(outlineVariants);
}, function (props) {
  return props.isActive && variant(activeVariants);
}, function (props) {
  return props.isDisabled && variant(disabledVariants);
}, function (props) {
  return props.isDisabled && css(["cursor:not-allowed;"]);
}, variant(sizeVariants));
var StyledAnchor = styled.a.withConfig({
  displayName: "buttonstyles__StyledAnchor",
  componentId: "keen-ui-core__sc-17t931m-1"
})(["&&&{display:inline-flex;", ";", ";", ";", ";", ";}"], function (props) {
  return props.fullWidth && css(["width:100%;justify-content:center;"]);
}, buttonMixin(), function (props) {
  return props.body === 'solid' && variant(solidButtonVariants);
}, function (props) {
  return props.body === 'outline' && variant(outlineVariants);
}, variant(sizeVariants));
var IconSocket$3 = styled.div.withConfig({
  displayName: "buttonstyles__IconSocket",
  componentId: "keen-ui-core__sc-17t931m-2"
})(["&&&{display:flex;align-items:center;margin-left:15px;}"]);

var Button = function Button(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _onClick = _ref.onClick,
      href = _ref.href,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? '_blank' : _ref$target,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$htmlType = _ref.htmlType,
      htmlType = _ref$htmlType === void 0 ? 'button' : _ref$htmlType,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? 'solid' : _ref$style,
      icon = _ref.icon,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth;

  if (href) {
    return React__default.createElement(StyledAnchor, {
      "data-testid": "button",
      isDisabled: isDisabled,
      isActive: isActive,
      variant: variant,
      size: size,
      href: href,
      body: style,
      target: target,
      fullWidth: fullWidth,
      onClick: function onClick(e) {
        return !isDisabled && _onClick && _onClick(e);
      }
    }, children, icon && React__default.createElement(IconSocket$3, null, icon));
  }

  return React__default.createElement(StyledButton$2, {
    "data-testid": "button",
    isDisabled: isDisabled,
    isActive: isActive,
    type: htmlType,
    variant: variant,
    body: style,
    size: size,
    fullWidth: fullWidth,
    onClick: function onClick(e) {
      return !isDisabled && _onClick && _onClick(e);
    }
  }, children, icon && React__default.createElement(IconSocket$3, {
    "data-testid": "button-icon-socket"
  }, icon));
};

var StyledButton$1 = styled.button.withConfig({
  displayName: "action-buttonstyles__StyledButton",
  componentId: "keen-ui-core__sc-xko9nr-0"
})(["&&&{display:flex;text-decoration:none;border-radius:", ";background-color:", ";padding:5px 11px;width:37px;height:37px;outline:none;border:none;cursor:pointer;align-items:center;justify-content:center;transition:background-color 0.15s ease-in-out;}", " &&&:hover{text-decoration:none;background-color:", ";}&&&:focus-visible{outline:1px solid ", ";}"], function (props) {
  return props.borderRadius ? props.borderRadius : '4px';
}, function (props) {
  return props.background ? props.background : transparentize(0.85, colors.blue['100']);
}, function (props) {
  return props.isDisabled && css(["opacity:0.5;pointer-events:none;"]);
}, function (props) {
  return props.backgroundHover ? props.backgroundHover : transparentize(0.75, colors.blue['100']);
}, colors.lightBlue[500]);
var StyledIcon = styled.span.withConfig({
  displayName: "action-buttonstyles__StyledIcon",
  componentId: "keen-ui-core__sc-xko9nr-1"
})(["&&&{font-family:'Lato Regular',sans-serif;font-size:25px;line-height:30px;", ";", ";}"], function (props) {
  return props.action === 'create' && css(["color:", ";"], colors.green['500']);
}, function (props) {
  return props.action === 'remove' && css(["color:", ";"], colors.red['200']);
});

var ActionButton = function ActionButton(_ref) {
  var _onClick = _ref.onClick,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      action = _ref.action,
      borderRadius = _ref.borderRadius,
      background = _ref.background,
      backgroundHover = _ref.backgroundHover,
      className = _ref.className;
  return React__default.createElement(StyledButton$1, {
    "data-testid": "action-button",
    className: className,
    isDisabled: isDisabled,
    borderRadius: borderRadius,
    background: background,
    backgroundHover: backgroundHover,
    type: "button",
    onClick: function onClick(e) {
      return !isDisabled && _onClick && _onClick(e, action);
    }
  }, React__default.createElement(StyledIcon, {
    "data-testid": "action-icon",
    action: action
  }, action === 'create' ? '+' : '×'));
};

var StyledButton = styled.button.withConfig({
  displayName: "circle-buttonstyles__StyledButton",
  componentId: "keen-ui-core__sc-67vj46-0"
})(["&&&{display:flex;text-decoration:none;border-radius:50%;padding:0;width:37px;height:37px;outline:none;border:none;cursor:pointer;align-items:center;justify-content:center;transition:color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,-webkit-box-shadow 0.15s ease-in-out;", ";", ";}&&&:hover{text-decoration:none;}"], function (props) {
  return props.isDisabled && css(["opacity:0.85;pointer-events:none;"]);
}, variant(solidButtonVariants));
var IconSocket$2 = styled.div.withConfig({
  displayName: "circle-buttonstyles__IconSocket",
  componentId: "keen-ui-core__sc-67vj46-1"
})(["&&&{display:flex;align-items:center;line-height:1;}"]);

var CircleButton = function CircleButton(_ref) {
  var icon = _ref.icon,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _onClick = _ref.onClick,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant;
  return React__default.createElement(StyledButton, {
    "data-testid": "circle-button",
    isDisabled: isDisabled,
    type: "button",
    variant: variant,
    onClick: function onClick(e) {
      return !isDisabled && _onClick && _onClick(e);
    }
  }, React__default.createElement(IconSocket$2, null, icon));
};

var StyledBulletList = styled.ul.withConfig({
  displayName: "bullet-liststyles__StyledBulletList",
  componentId: "keen-ui-core__sc-1gw8lkh-0"
})(["&&&{margin:0;padding:0;list-style:none;}"]);
var StyledBulletItem = styled.li.withConfig({
  displayName: "bullet-liststyles__StyledBulletItem",
  componentId: "keen-ui-core__sc-1gw8lkh-1"
})(["&&&{display:flex;flex-wrap:nowrap;white-space:nowrap;align-items:center;}&&& ~ &&&{margin-top:11px;}"]);
var BulletPoint = styled.div.withConfig({
  displayName: "bullet-liststyles__BulletPoint",
  componentId: "keen-ui-core__sc-1gw8lkh-2"
})(["&&&{width:8px;height:8px;margin-right:6px;border-radius:50%;background-color:", ";flex-shrink:0;}"], function (props) {
  return props.color;
});

var BulletList = function BulletList(_ref) {
  var items = _ref.items,
      renderItem = _ref.renderItem;
  return React__default.createElement(StyledBulletList, null, items.map(function (item, idx) {
    return React__default.createElement(StyledBulletItem, {
      key: "".concat(item.color, ".").concat(idx)
    }, React__default.createElement(BulletPoint, {
      color: item.color
    }), renderItem(idx, item));
  }));
};

var Card = styled.div.withConfig({
  displayName: "cardcomponent__Card",
  componentId: "keen-ui-core__sc-1tt2tf2-0"
})(["&&&{display:flex;flex-direction:column;height:100%;box-sizing:border-box;padding:", "px;border:", ";", ";", ";}"], function (props) {
  return props.padding;
}, function (props) {
  return "".concat(props.borderWidth, "px solid transparent");
}, function (props) {
  return props.hideOverflow && css(["overflow:hidden;"]);
}, function (props) {
  return props.enabled && css(["background:", ";border:", ";border-radius:", "px;box-shadow:", ";"], function (props) {
    return props.backgroundColor;
  }, function (props) {
    return "".concat(props.borderWidth, "px solid ").concat(props.borderColor);
  }, function (props) {
    return props.borderRadius;
  }, function (props) {
    return props.hasShadow ? '0px 2px 4px 0px rgba(29,39,41,0.15)' : 'none';
  });
});
Card.defaultProps = {
  enabled: true,
  backgroundColor: colors.white['500'],
  hasShadow: true,
  padding: 20,
  borderWidth: 0,
  borderColor: 'initial',
  borderRadius: 0
};

var Container$E = styled.div.withConfig({
  displayName: "checkboxstyles__Container",
  componentId: "keen-ui-core__sc-m98fwk-0"
})(["&&&{", ";vertical-align:middle;line-height:1;}&&&:focus-visible{outline:1px solid ", ";}"], layout, colors.lightBlue[500]);
var iconSocketVariants = {
  prop: 'type',
  variants: {
    primary: {
      bottom: '0'
    },
    secondary: {
      left: '1px',
      bottom: '0'
    },
    highlight: {
      left: '1px',
      bottom: '0'
    }
  }
};
var IconSocket$1 = styled(motion.div).withConfig({
  displayName: "checkboxstyles__IconSocket",
  componentId: "keen-ui-core__sc-m98fwk-1"
})(["&&&{position:absolute;height:15px;line-height:1;box-sizing:content-box;", ";}"], variant(iconSocketVariants));
var checkboxVariants = {
  prop: 'type',
  variants: {
    primary: {
      border: "solid 1px ".concat(colors.blue['500']),
      borderRadius: '2px',
      width: '12px',
      height: '12px'
    },
    secondary: {
      border: "solid 1px ".concat(transparentize(0.8, colors.blue['500'])),
      background: transparentize(0.95, colors.blue['100']),
      borderRadius: '4px',
      width: '15px',
      height: '15px'
    },
    highlight: {
      border: "solid 1px ".concat(transparentize(0.8, colors.gray['100'])),
      background: transparentize(0.8, colors.white['400']),
      borderRadius: '4px',
      width: '15px',
      height: '15px'
    }
  }
};
var activeCheckboxVariants = {
  prop: 'type',
  variants: {
    primary: {},
    secondary: {},
    highlight: {
      border: "solid 1px ".concat(transparentize(0.7, colors.gray['100'])),
      background: transparentize(0.25, colors.white['400'])
    }
  }
};
var StyledCheckbox = styled.div.withConfig({
  displayName: "checkboxstyles__StyledCheckbox",
  componentId: "keen-ui-core__sc-m98fwk-2"
})(["&&&{position:relative;display:inline-block;box-sizing:content-box;", ";", ";}"], variant(checkboxVariants), function (props) {
  return props.checked && variant(activeCheckboxVariants);
});
var HiddenInput = styled.input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "checkboxstyles__HiddenInput",
  componentId: "keen-ui-core__sc-m98fwk-3"
})(["&&&{border:0;clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px;}"]);

var checkMotion = {
  initial: {
    opacity: 0
  },
  transition: {
    duration: 0.2
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
};
var Checkbox = function Checkbox(_ref) {
  var id = _ref.id,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'primary' : _ref$type,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? 'inline-block' : _ref$display,
      _onChange = _ref.onChange,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return React__default.createElement(Container$E, {
    role: "checkbox",
    display: display,
    tabIndex: 0,
    onKeyPress: function onKeyPress(e) {
      return _onChange && _onChange(e);
    }
  }, React__default.createElement(HiddenInput, {
    id: id,
    checked: checked,
    disabled: disabled,
    onChange: function onChange(e) {
      return _onChange && _onChange(e);
    }
  }), React__default.createElement(StyledCheckbox, {
    checked: checked,
    type: type
  }, React__default.createElement(AnimatePresence, null, checked && React__default.createElement(IconSocket$1, Object.assign({
    type: type
  }, checkMotion), React__default.createElement(Icon, {
    type: "check",
    width: type === 'primary' ? 15 : 13,
    height: type === 'primary' ? 15 : 13,
    fill: colors.green['400']
  })))));
};

var Container$D = styled.div.withConfig({
  displayName: "radiostyles__Container",
  componentId: "keen-ui-core__sc-1js3bxa-0"
})(["&&&{border-radius:8.5px;border:solid 1px ", ";background:", ";width:17px;height:17px;display:flex;justify-content:center;align-items:center;cursor:pointer;}"], transparentize(0.8, colors.blue[500]), transparentize(0.95, colors.blue[100]));
var ActiveDot = styled(motion.div).withConfig({
  displayName: "radiostyles__ActiveDot",
  componentId: "keen-ui-core__sc-1js3bxa-1"
})(["&&&{height:9px;width:9px;border-radius:50%;background:", ";}"], colors.green[300]);

var activeMotion = {
  initial: {
    scale: 0
  },
  animate: {
    scale: 1
  },
  exit: {
    scale: 0
  }
};

var Radio = function Radio(_ref) {
  var isActive = _ref.isActive,
      onClick = _ref.onClick;
  return React__default.createElement(Container$D, {
    onClick: onClick,
    role: "radio",
    "aria-checked": isActive
  }, React__default.createElement(AnimatePresence, null, isActive && React__default.createElement(ActiveDot, Object.assign({
    "data-testid": "radio-active"
  }, activeMotion))));
};

var THRESHOLD = {
  LIGHT: 75,
  DARK: 25
};
var ColorAdjuster = function ColorAdjuster(_ref) {
  var children = _ref.children,
      baseColor = _ref.baseColor;
  var adjustedColor = useMemo(function () {
    var color = Color$2(baseColor);

    var _color$hsl$array = color.hsl().array(),
        _color$hsl$array2 = _slicedToArray(_color$hsl$array, 3),
        hue = _color$hsl$array2[0],
        saturation = _color$hsl$array2[1],
        lightness = _color$hsl$array2[2];

    var lightnessModifier = 0;

    if (color.isLight()) {
      lightnessModifier = lightness > THRESHOLD.LIGHT ? 20 : 15;
    } else {
      lightnessModifier = lightness > THRESHOLD.DARK ? 85 : 80;
    }

    return Color$2.hsl([hue, saturation, lightnessModifier]).toString();
  }, [baseColor]);
  return React__default.createElement(React__default.Fragment, null, children(adjustedColor));
};

var stringifyColors = function stringifyColors(colors$1, zeroPoint) {
  var newColors = colors$1.map(function (color) {
    if (color === colors.white[500]) return "".concat(color, " ").concat(zeroPoint, "%");
    return color;
  });
  return newColors.join(', ');
};

var calculateIntervalValue = function calculateIntervalValue(_ref) {
  var controlPosition = _ref.controlPosition,
      currentIndex = _ref.currentIndex,
      stepDimension = _ref.stepDimension,
      interval = _ref.interval;
  var dimensionOffset = currentIndex * stepDimension;
  var absoluteIntervalPosition = (controlPosition - dimensionOffset) / stepDimension * 100;
  var minimum = interval.minimum,
      maximum = interval.maximum,
      step = interval.step;
  var stepsInInterval = (maximum - minimum) / step;
  var intervalValue = Math.round(absoluteIntervalPosition * stepsInInterval / 100);
  return intervalValue * step + minimum;
};
var getIndex = function getIndex(x, stepDimension) {
  var index = Math.floor(x / stepDimension);

  if (x !== 0 && x % stepDimension === 0) {
    index -= 1;
  }

  return index;
};
var getInitialOffset = function getInitialOffset(initialValue, stepDimension, intervals) {
  var offset = initialValue;
  var index = 0;
  intervals.forEach(function (interval, idx) {
    if (initialValue > interval.minimum && initialValue <= interval.maximum) {
      offset = initialValue * stepDimension / interval.maximum + stepDimension * idx;
      index = idx;
    }
  });
  return {
    offset: offset,
    index: index
  };
};

var arrowReverse = function arrowReverse(position) {
  switch (position) {
    case 'top':
      return 'bottom';

    case 'left':
      return 'right';

    case 'right':
      return 'left';

    case 'bottom':
      return 'top';

    default:
      return position;
  }
};

var Rail = function Rail(_ref) {
  var type = _ref.type,
      colors = _ref.colors,
      zeroPoint = _ref.zeroPoint,
      borderRadius = _ref.borderRadius,
      size = _ref.size;
  var gradientAngle = type === 'horizontal' ? 90 : 180;
  var layoutStyles = type === 'horizontal' ? {
    width: '100%',
    height: "".concat(size, "px"),
    top: '50%',
    transform: 'translateY(-50%)'
  } : {
    height: '100%',
    width: "".concat(size, "px"),
    left: '50%',
    transform: 'translateX(-50%)'
  };
  var background = colors.length > 1 ? "linear-gradient(".concat(gradientAngle, "deg, ").concat(stringifyColors(colors, zeroPoint)) : colors[0];
  return React__default.createElement("div", {
    "data-testid": "slider-rail",
    style: _objectSpread2({
      position: 'absolute',
      borderRadius: borderRadius,
      background: background
    }, layoutStyles)
  });
};

var Circle = styled.div.withConfig({
  displayName: "markstyles__Circle",
  componentId: "keen-ui-core__sc-16y8ju3-0"
})(["&&&{box-sizing:border-box;width:", "px;height:", "px;border-radius:50%;background:", ";border:solid 2px ", ";}"], function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.borderColor;
});

var Mark = function Mark(_ref) {
  var size = _ref.size,
      borderColor = _ref.borderColor,
      backgroundColor = _ref.backgroundColor,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;
  return React__default.createElement(Circle, {
    "data-testid": "mark-circle",
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    borderColor: borderColor,
    backgroundColor: backgroundColor,
    size: size
  });
};

var Container$C = styled.div.withConfig({
  displayName: "off-rangestyles__Container",
  componentId: "keen-ui-core__sc-13rnz7z-0"
})(["&&&{border-radius:", "px;background:", ";}"], function (props) {
  return props.borderRadius;
}, colors.gray['400']);

var OffRange = function OffRange(_ref) {
  var styles = _ref.styles,
      borderRadius = _ref.borderRadius;
  return React__default.createElement(Container$C, {
    borderRadius: borderRadius,
    style: styles
  });
};

var Container$B = styled.div.withConfig({
  displayName: "controlstyles__Container",
  componentId: "keen-ui-core__sc-18lo1ec-0"
})(["&&&{", ";", ";}"], function (props) {
  return props.dragDirection === 'x' && css(["transform:translateX(-50%);"]);
}, function (props) {
  return props.dragDirection === 'y' && css(["transform:translateY(-50%);"]);
});

var Control = function Control(_ref) {
  var dragDirection = _ref.dragDirection,
      dragConstraints = _ref.dragConstraints,
      onDragStart = _ref.onDragStart,
      onDragEnd = _ref.onDragEnd,
      onDrag = _ref.onDrag,
      controlStyles = _ref.controlStyles,
      children = _ref.children;

  var styles = _objectSpread2({
    display: 'block',
    position: 'absolute',
    zIndex: 1
  }, controlStyles);

  return React__default.createElement(motion.div, {
    "data-testid": "slider-control",
    drag: dragDirection,
    dragConstraints: dragConstraints,
    onDrag: onDrag,
    onDragStart: onDragStart,
    onDragEnd: onDragEnd,
    dragElastic: 0,
    dragMomentum: false,
    style: styles,
    onMouseDown: function onMouseDown(event) {
      event.stopPropagation();
    },
    onTouchStart: function onTouchStart(event) {
      event.stopPropagation();
    }
  }, React__default.createElement(Container$B, {
    dragDirection: dragDirection
  }, children));
};

var SET_DIMENSION = 'SET_DIMENSION';
var SET_VALUE = 'SET_VALUE';
var SET_DRAG_POSITION = 'SET_DRAG_POSITION';
var SET_DRAG_STATE = 'SET_DRAG_STATE';
var SET_DRAG_MOVING = 'SET_DRAG_MOVING';
var DRAG_CONTROL_ID = '@keen-drag-control';
var TOOLTIP_CONTENT_MAX_WIDTH = 200;

var TooltipContent$1 = function TooltipContent(_ref) {
  var children = _ref.children;
  return React__default.createElement("div", {
    style: {
      maxWidth: TOOLTIP_CONTENT_MAX_WIDTH,
      overflowWrap: 'break-word',
      width: 'max-content'
    }
  }, children);
};

var ARROW_OFFSET = 4;
var TOOLTIP_ARROW_SIZE = ARROW_SIZE + ARROW_OFFSET;
var tooltipMotion$1 = {
  transition: {
    duration: 0.3
  },
  animate: {
    opacity: 1
  },
  initial: {
    opacity: 0
  },
  exit: {
    opacity: 0
  }
};
var PositionContainer$1 = styled.div.withConfig({
  displayName: "tooltip-positioncomponent__PositionContainer",
  componentId: "keen-ui-core__sc-1kvt7kh-0"
})(["&&&{position:absolute;top:0;left:0;", ";", ";", ";", ";}"], function (props) {
  return props.position === 'left' && css(["transform:translateX(-50%) translateX(-", "px) translateY(-50%) translateY(", "px);"], props.width / 2 + TOOLTIP_ARROW_SIZE, props.containerSize / 2);
}, function (props) {
  return props.position === 'right' && css(["transform:translateX(-50%) translateX( ", "px ) translateY(-50%) translateY(", "px);"], props.width / 2 + props.containerSize + TOOLTIP_ARROW_SIZE, props.containerSize / 2);
}, function (props) {
  return props.position === 'bottom' && css(["transform:translateX(-50%) translateX(", "px) translateY(-50%) translateY( ", "px );"], props.containerSize / 2, props.containerSize + props.height / 2 + TOOLTIP_ARROW_SIZE);
}, function (props) {
  return props.position === 'top' && css(["transform:translateX(-50%) translateX(", "px) translateY(-50%) translateY(-", "px);"], props.containerSize / 2, props.height / 2 + TOOLTIP_ARROW_SIZE);
});

var TooltipPosition = function TooltipPosition(_ref) {
  var children = _ref.children,
      x = _ref.x,
      y = _ref.y,
      containerSize = _ref.containerSize,
      visible = _ref.visible,
      position = _ref.position;
  var element = useRef(null);

  var _useState = useState({
    width: 0,
    height: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    var _element$current$getB = element.current.getBoundingClientRect(),
        width = _element$current$getB.width,
        height = _element$current$getB.height;

    setState({
      width: width,
      height: height
    });
  }, [element.current, visible, position, x, y]);
  return React__default.createElement(PositionContainer$1, {
    ref: element,
    position: position,
    containerSize: containerSize,
    width: state.width,
    height: state.height
  }, children);
};

var setDimension = function setDimension(dimension) {
  return {
    type: SET_DIMENSION,
    payload: {
      dimension: dimension
    }
  };
};

var setValue$1 = function setValue(value) {
  return {
    type: SET_VALUE,
    payload: {
      value: value
    }
  };
};

var setControlPosition = function setControlPosition(id, position) {
  return {
    type: SET_DRAG_POSITION,
    payload: {
      id: id,
      position: position
    }
  };
};

var setControlDrag = function setControlDrag(id, moving) {
  return {
    type: SET_DRAG_MOVING,
    payload: {
      id: id,
      moving: moving
    }
  };
};

var setControlState = function setControlState(id, active) {
  return {
    type: SET_DRAG_STATE,
    payload: {
      id: id,
      active: active
    }
  };
};

var sliderActions = {
  setValue: setValue$1,
  setDimension: setDimension,
  setControlState: setControlState,
  setControlPosition: setControlPosition,
  setControlDrag: setControlDrag
};

var initialState$1 = {
  value: 0,
  dimension: 0,
  dragControls: _defineProperty({}, DRAG_CONTROL_ID, {
    moving: false,
    active: false,
    position: 0
  })
};
var sliderReducer = function sliderReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_DRAG_STATE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        dragControls: _objectSpread2(_objectSpread2({}, state.dragControls), {}, _defineProperty({}, action.payload.id, _objectSpread2(_objectSpread2({}, state.dragControls[action.payload.id]), {}, {
          active: action.payload.active
        })))
      });

    case SET_DRAG_POSITION:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        dragControls: _objectSpread2(_objectSpread2({}, state.dragControls), {}, _defineProperty({}, action.payload.id, _objectSpread2(_objectSpread2({}, state.dragControls[action.payload.id]), {}, {
          position: action.payload.position
        })))
      });

    case SET_DRAG_MOVING:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        dragControls: _objectSpread2(_objectSpread2({}, state.dragControls), {}, _defineProperty({}, action.payload.id, _objectSpread2(_objectSpread2({}, state.dragControls[action.payload.id]), {}, {
          moving: action.payload.moving
        })))
      });

    case SET_DIMENSION:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        dimension: action.payload.dimension
      });

    case SET_VALUE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        value: action.payload.value
      });

    default:
      return state;
  }
};

var sliderControlSettings = {
  size: 15,
  borderColor: colors.yellow['400'],
  backgroundColor: colors.white['500']
};
var tooltipTypography = {
  fontSize: 12,
  fontFamily: 'Lato Regular, sans-serif',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontColor: colors.white['500']
};

var initialDragControlsState = {
  minimum: {
    active: false,
    moving: false,
    position: 0
  },
  maximum: {
    active: false,
    moving: false,
    position: 0
  }
};
var RangeSlider = function RangeSlider(_ref) {
  var _controlStyles;

  var _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 'horizontal' : _ref$layout,
      _ref$controlSettings = _ref.controlSettings,
      controlSettings = _ref$controlSettings === void 0 ? sliderControlSettings : _ref$controlSettings,
      colors = _ref.colors,
      onChange = _ref.onChange,
      _ref$colorSteps = _ref.colorSteps,
      colorSteps = _ref$colorSteps === void 0 ? 2 : _ref$colorSteps,
      _ref$tooltipSettings = _ref.tooltipSettings,
      tooltipSettings = _ref$tooltipSettings === void 0 ? {
    enabled: true,
    position: 'bottom',
    typography: undefined,
    theme: 'dark'
  } : _ref$tooltipSettings,
      _ref$railSettings = _ref.railSettings,
      railSettings = _ref$railSettings === void 0 ? {
    size: 4,
    borderRadius: 3
  } : _ref$railSettings,
      minValue = _ref.minimum,
      maxValue = _ref.maximum;
  var slider = useRef(null);
  var isHorizontal = layout === 'horizontal';
  var dragDirection = isHorizontal ? 'x' : 'y';
  var minimum = isHorizontal ? minValue : maxValue;
  var maximum = isHorizontal ? maxValue : minValue;

  var _useState = useState({
    visible: null,
    x: 0,
    y: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      tooltip = _useState2[0],
      setTooltip = _useState2[1];

  var showTooltip = useCallback(function (dragTooltip) {
    if (tooltipSettings.enabled) {
      setTooltip(function (state) {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          visible: dragTooltip
        });
      });
    }
  }, [tooltipSettings.enabled]);
  var hideTooltip = useCallback(function () {
    if (tooltipSettings.enabled) {
      setTooltip(function (state) {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          visible: null
        });
      });
    }
  }, [tooltipSettings.enabled]);

  var _useReducer = useReducer(sliderReducer, _objectSpread2(_objectSpread2({}, initialState$1), {}, {
    dragControls: initialDragControlsState,
    value: [minimum, maximum]
  })),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      value = _useReducer2$.value,
      dimension = _useReducer2$.dimension,
      dragControls = _useReducer2$.dragControls,
      dispatch = _useReducer2[1];

  var calculateControlValue = useCallback(function (position) {
    if (!dimension) return maximum;
    var percent = position / dimension * 100;
    return Math.round((maximum - minimum) * (percent / 100)) + minimum;
  }, [dimension, minimum, maximum]);
  useEffect(function () {
    var _slider$current$getBo = slider.current.getBoundingClientRect(),
        width = _slider$current$getBo.width,
        height = _slider$current$getBo.height;

    var sliderDimension = isHorizontal ? width : height;
    dispatch(sliderActions.setControlPosition('maximum', sliderDimension));
    dispatch(sliderActions.setDimension(sliderDimension));
  }, [slider.current, isHorizontal]);
  var layoutStyle = isHorizontal ? {
    width: '100%',
    height: "".concat(controlSettings.size, "px")
  } : {
    width: "".concat(controlSettings.size, "px"),
    height: '100%'
  };

  var _value = _slicedToArray(value, 2),
      currentMinimum = _value[0],
      currentMaximum = _value[1];

  var colorScale = useMemo(function () {
    return generateContinuousColorScale(minValue, maxValue, colorSteps, colors);
  }, [minValue, maxValue, colorSteps, colors]);
  var colorScaleRange = isHorizontal ? colorScale.range() : colorScale.range().reverse();
  var absoluteMinimum = Math.abs(minValue);
  var zeroPointPercentage = absoluteMinimum * 100 / (absoluteMinimum + maxValue);
  var zeroPoint = isHorizontal ? zeroPointPercentage : 100 - zeroPointPercentage;
  return React__default.createElement("div", {
    ref: slider,
    style: _objectSpread2({
      position: 'relative'
    }, layoutStyle)
  }, React__default.createElement(Rail, {
    type: layout,
    size: railSettings.size,
    borderRadius: railSettings.borderRadius,
    colors: colorScaleRange,
    zeroPoint: zeroPoint
  }), dimension !== null && React__default.createElement(React__default.Fragment, null, React__default.createElement(OffRange, {
    borderRadius: railSettings.borderRadius,
    styles: isHorizontal ? {
      width: "".concat(dragControls.minimum.position, "px"),
      height: "".concat(railSettings.size, "px"),
      left: 0,
      position: 'absolute',
      top: '50%',
      transform: "translateY(-50%)"
    } : {
      width: "".concat(railSettings.size, "px"),
      height: "".concat(dragControls.minimum.position, "px"),
      top: 0,
      position: 'absolute',
      left: '50%',
      transform: "translateX(-50%)"
    }
  }), React__default.createElement(OffRange, {
    borderRadius: railSettings.borderRadius,
    styles: isHorizontal ? {
      width: "calc(100% - ".concat(dragControls.maximum.position, "px)"),
      height: "".concat(railSettings.size, "px"),
      left: "".concat(dragControls.maximum.position, "px"),
      position: 'absolute',
      top: '50%',
      transform: "translateY(-50%)"
    } : {
      width: "".concat(railSettings.size, "px"),
      height: "calc(100% - ".concat(dragControls.maximum.position, "px)"),
      top: "".concat(dragControls.maximum.position, "px"),
      position: 'absolute',
      left: '50%',
      transform: "translateX(-50%)"
    }
  }), React__default.createElement(Control, {
    onDragStart: function onDragStart() {
      dispatch(sliderActions.setControlDrag('minimum', true));
      showTooltip('minimum');
    },
    onDragEnd: function onDragEnd() {
      dispatch(sliderActions.setControlDrag('minimum', false));
      if (!dragControls.minimum.active) hideTooltip();
    },
    onDrag: function onDrag(_event, dragInfo) {
      var _dragInfo$point = dragInfo.point,
          x = _dragInfo$point.x,
          y = _dragInfo$point.y;
      var position = isHorizontal ? x : y;
      var minimumValue = calculateControlValue(position);

      var _value2 = _slicedToArray(value, 2),
          maximumValue = _value2[1];

      dispatch(sliderActions.setValue([minimumValue, maximumValue]));
      dispatch(sliderActions.setControlPosition('minimum', position));
      var minimum = isHorizontal ? minimumValue : maximumValue;
      var maximum = isHorizontal ? maximumValue : minimumValue;
      onChange && onChange(minimum, maximum);

      if (tooltipSettings.enabled) {
        setTooltip(function (state) {
          return isHorizontal ? _objectSpread2(_objectSpread2({}, state), {}, {
            y: 0,
            x: x
          }) : _objectSpread2(_objectSpread2({}, state), {}, {
            x: 0,
            y: y
          });
        });
      }
    },
    dragDirection: dragDirection,
    dragConstraints: isHorizontal ? {
      top: 0,
      bottom: 0,
      left: 0,
      right: dragControls.maximum.position
    } : {
      top: 0,
      bottom: dragControls.maximum.position,
      left: 0,
      right: 0
    },
    controlStyles: {
      zIndex: 2
    }
  }, React__default.createElement(React__default.Fragment, null, React__default.createElement(Mark, Object.assign({}, controlSettings, {
    onMouseEnter: function onMouseEnter() {
      dispatch(sliderActions.setControlState('minimum', true));
      showTooltip('minimum');
    },
    onMouseLeave: function onMouseLeave() {
      dispatch(sliderActions.setControlState('minimum', false));
      if (!dragControls.minimum.moving) hideTooltip();
    }
  })), tooltipSettings.enabled && React__default.createElement(TooltipPosition, {
    x: tooltip.x,
    y: tooltip.y,
    visible: tooltip.visible === 'minimum',
    containerSize: controlSettings.size,
    position: tooltipSettings.position
  }, React__default.createElement(AnimatePresence, null, tooltip.visible === 'minimum' && React__default.createElement(motion.div, Object.assign({}, tooltipMotion$1), React__default.createElement(Tooltip, {
    arrowDirection: arrowReverse(tooltipSettings.position),
    mode: tooltipSettings.theme
  }, React__default.createElement(TooltipContent$1, null, React__default.createElement(Text$1, Object.assign({}, tooltipSettings.typography ? tooltipSettings.typography : tooltipTypography), tooltipSettings.formatValue ? formatValue(currentMinimum, tooltipSettings.formatValue) : currentMinimum)))))))), React__default.createElement(Control, {
    onDragStart: function onDragStart() {
      dispatch(sliderActions.setControlDrag('maximum', true));
      showTooltip('maximum');
    },
    onDragEnd: function onDragEnd() {
      dispatch(sliderActions.setControlDrag('maximum', false));
      if (!dragControls.minimum.active) hideTooltip();
    },
    onDrag: function onDrag(_event, dragInfo) {
      var _dragInfo$point2 = dragInfo.point,
          x = _dragInfo$point2.x,
          y = _dragInfo$point2.y;
      var position = isHorizontal ? x : y;
      var maximumValue = calculateControlValue(position);

      var _value3 = _slicedToArray(value, 1),
          minimumValue = _value3[0];

      dispatch(sliderActions.setValue([minimumValue, maximumValue]));
      dispatch(sliderActions.setControlPosition('maximum', position));
      var minimum = isHorizontal ? minimumValue : maximumValue;
      var maximum = isHorizontal ? maximumValue : minimumValue;
      onChange && onChange(minimum, maximum);

      if (tooltipSettings.enabled) {
        setTooltip(function (state) {
          return isHorizontal ? _objectSpread2(_objectSpread2({}, state), {}, {
            y: 0,
            x: x
          }) : _objectSpread2(_objectSpread2({}, state), {}, {
            x: 0,
            y: y
          });
        });
      }
    },
    dragDirection: dragDirection,
    dragConstraints: isHorizontal ? {
      top: 0,
      bottom: 0,
      left: dragControls.minimum.position,
      right: dimension
    } : {
      top: dragControls.minimum.position,
      bottom: dimension,
      left: 0,
      right: 0
    },
    controlStyles: (_controlStyles = {}, _defineProperty(_controlStyles, isHorizontal ? 'x' : 'y', dimension), _defineProperty(_controlStyles, isHorizontal ? 'y' : 'x', 0), _defineProperty(_controlStyles, "zIndex", currentMinimum === maximum ? 1 : 3), _controlStyles)
  }, React__default.createElement(React__default.Fragment, null, React__default.createElement(Mark, Object.assign({}, controlSettings, {
    onMouseEnter: function onMouseEnter() {
      dispatch(sliderActions.setControlState('maximum', true));
      showTooltip('maximum');
    },
    onMouseLeave: function onMouseLeave() {
      dispatch(sliderActions.setControlState('maximum', false));
      if (!dragControls.maximum.moving) hideTooltip();
    }
  })), tooltipSettings.enabled && React__default.createElement(TooltipPosition, {
    x: tooltip.x,
    y: tooltip.y,
    visible: tooltip.visible === 'maximum',
    containerSize: controlSettings.size,
    position: tooltipSettings.position
  }, React__default.createElement(AnimatePresence, null, tooltip.visible === 'maximum' && React__default.createElement(motion.div, Object.assign({}, tooltipMotion$1), React__default.createElement(Tooltip, {
    arrowDirection: arrowReverse(tooltipSettings.position),
    mode: tooltipSettings.theme
  }, React__default.createElement(TooltipContent$1, null, React__default.createElement(Text$1, Object.assign({}, tooltipSettings.typography ? tooltipSettings.typography : tooltipTypography), tooltipSettings.formatValue ? formatValue(currentMaximum, tooltipSettings.formatValue) : currentMaximum))))))))));
};

var IntervalSlider = function IntervalSlider(_ref) {
  var intervals = _ref.intervals,
      onChange = _ref.onChange,
      colors = _ref.colors,
      _ref$tooltipSettings = _ref.tooltipSettings,
      tooltipSettings = _ref$tooltipSettings === void 0 ? {
    enabled: true,
    position: 'bottom',
    typography: undefined
  } : _ref$tooltipSettings,
      _ref$controlSettings = _ref.controlSettings,
      controlSettings = _ref$controlSettings === void 0 ? sliderControlSettings : _ref$controlSettings,
      _ref$railSettings = _ref.railSettings,
      railSettings = _ref$railSettings === void 0 ? {
    size: 4,
    borderRadius: 3
  } : _ref$railSettings,
      initialValue = _ref.initialValue;
  var slider = useRef(null);

  var _useReducer = useReducer(sliderReducer, initialState$1),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      value = _useReducer2$.value,
      dimension = _useReducer2$.dimension,
      dragControls = _useReducer2$.dragControls,
      dispatch = _useReducer2[1];

  var dragControl = dragControls[DRAG_CONTROL_ID];

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentIndex = _useState2[0],
      setIndex = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      xOffset = _useState4[0],
      setXOffset = _useState4[1];

  var _useState5 = useState({
    visible: false,
    x: 0,
    y: 0
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      tooltip = _useState6[0],
      setTooltip = _useState6[1];

  var stepDimension = dimension / intervals.length;
  useEffect(function () {
    var _slider$current$getBo = slider.current.getBoundingClientRect(),
        width = _slider$current$getBo.width;

    dispatch(sliderActions.setDimension(width));
  }, [slider.current]);
  useEffect(function () {
    if (typeof dimension === 'number' && typeof initialValue === 'number' && initialValue !== value) {
      var _getInitialOffset = getInitialOffset(initialValue, stepDimension, intervals),
          index = _getInitialOffset.index,
          offset = _getInitialOffset.offset;

      setIndex(index);
      setXOffset(offset);
      dispatch(sliderActions.setValue(initialValue));
      dispatch(sliderActions.setControlPosition(DRAG_CONTROL_ID, offset));
    }
  }, [initialValue, dimension]);
  var showTooltip = useCallback(function () {
    if (tooltipSettings.enabled) {
      setTooltip(function (state) {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          visible: true
        });
      });
    }
  }, [tooltipSettings.enabled]);
  var hideTooltip = useCallback(function () {
    if (tooltipSettings.enabled) {
      setTooltip(function (state) {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          visible: false
        });
      });
    }
  }, [tooltipSettings.enabled]);
  var handleClick = useCallback(function (e) {
    var _e$currentTarget$getB = e.currentTarget.getBoundingClientRect(),
        left = _e$currentTarget$getB.left;

    var offset = e.clientX - left;
    var x = offset;
    if (offset < 0) x = 0;
    if (offset > dimension) x = dimension;
    var index = getIndex(x, stepDimension);
    setIndex(index);
    var value = calculateIntervalValue({
      controlPosition: x,
      interval: intervals[index],
      currentIndex: index,
      stepDimension: stepDimension
    });
    dispatch(sliderActions.setValue(value));
    dispatch(sliderActions.setControlPosition(DRAG_CONTROL_ID, x));
    setXOffset(x);
    onChange && onChange(value);

    if (tooltipSettings.enabled) {
      setTooltip(function (state) {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          visible: true,
          y: 0,
          x: x
        });
      });
    }
  }, [dimension, stepDimension, tooltipSettings.enabled, onChange]);
  return React__default.createElement("div", {
    ref: slider,
    style: {
      height: "".concat(controlSettings.size, "px"),
      position: 'relative',
      cursor: 'pointer'
    },
    onClick: handleClick
  }, React__default.createElement(Rail, {
    type: "horizontal",
    size: railSettings.size,
    borderRadius: railSettings.borderRadius,
    colors: colors
  }), React__default.createElement(OffRange, {
    borderRadius: railSettings.borderRadius,
    styles: {
      width: "calc(100% - ".concat(dragControl.position, "px)"),
      height: "".concat(railSettings.size, "px"),
      left: "".concat(dragControl.position, "px"),
      position: 'absolute',
      top: '50%',
      transform: "translateY(-50%)"
    }
  }), React__default.createElement(Control, {
    controlStyles: {
      x: xOffset
    },
    onDragStart: function onDragStart() {
      dispatch(sliderActions.setControlDrag(DRAG_CONTROL_ID, true));
      showTooltip();
    },
    onDragEnd: function onDragEnd() {
      dispatch(sliderActions.setControlDrag(DRAG_CONTROL_ID, false));
      if (!dragControl.active) hideTooltip();
    },
    onDrag: function onDrag(_event, dragInfo) {
      var x = dragInfo.point.x;
      var nextIndex = currentIndex + 1;

      if (x > nextIndex * stepDimension) {
        setIndex(nextIndex);
      } else if (x < currentIndex * stepDimension) {
        setIndex(currentIndex - 1);
      }

      var value = calculateIntervalValue({
        controlPosition: x,
        interval: intervals[currentIndex],
        currentIndex: currentIndex,
        stepDimension: stepDimension
      });
      dispatch(sliderActions.setValue(value));
      dispatch(sliderActions.setControlPosition(DRAG_CONTROL_ID, x));
      onChange && onChange(value);

      if (tooltipSettings.enabled) {
        setTooltip(function (state) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            y: 0,
            x: x
          });
        });
      }
    },
    dragDirection: "x",
    dragConstraints: {
      top: 0,
      bottom: 0,
      left: 0,
      right: dimension
    }
  }, React__default.createElement(React__default.Fragment, null, React__default.createElement(Mark, Object.assign({}, controlSettings, {
    onMouseEnter: function onMouseEnter() {
      dispatch(sliderActions.setControlState(DRAG_CONTROL_ID, true));
      showTooltip();
    },
    onMouseLeave: function onMouseLeave() {
      dispatch(sliderActions.setControlState(DRAG_CONTROL_ID, false));
      if (!dragControl.moving) hideTooltip();
    }
  })), tooltipSettings.enabled && React__default.createElement(TooltipPosition, {
    x: tooltip.x,
    y: tooltip.y,
    visible: tooltip.visible,
    containerSize: controlSettings.size,
    position: tooltipSettings.position
  }, React__default.createElement(AnimatePresence, null, tooltip.visible && React__default.createElement(motion.div, Object.assign({}, tooltipMotion$1), React__default.createElement(Tooltip, {
    arrowDirection: arrowReverse(tooltipSettings.position),
    mode: "dark"
  }, React__default.createElement(Text$1, Object.assign({}, tooltipSettings.typography ? tooltipSettings.typography : tooltipTypography), tooltipSettings.renderText ? tooltipSettings.renderText(value) : value))))))));
};

var ColorCard = styled.div.withConfig({
  displayName: "color-scalestyles__ColorCard",
  componentId: "keen-ui-core__sc-rbnotm-0"
})(["&&&{width:100%;height:6px;background:", ";display:flex;justify-content:center;align-items:center;font-size:13px;}"], function (props) {
  return props.background;
});

var ColorScale = function ColorScale(_ref) {
  var _ref$colors = _ref.colors,
      colors$1 = _ref$colors === void 0 ? [colors.lightBlue[500], colors.orange[500], colors.yellow[500], colors.green[500], colors.pink[500]] : _ref$colors,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'continuous' : _ref$mode;
  return React__default.createElement(React__default.Fragment, null, mode === 'continuous' ? React__default.createElement(RangeSlider, {
    colors: colors$1,
    minimum: 0,
    maximum: 100
  }) : colors$1.map(function (el) {
    return React__default.createElement(ColorCard, {
      key: el,
      background: el
    });
  }));
};

var Wrapper$2 = styled.div.withConfig({
  displayName: "dropdownstyles__Wrapper",
  componentId: "keen-ui-core__sc-1k05xa4-0"
})(["&&&{", ";}"], function (props) {
  return props.isRelative && css(["position:relative;"]);
});
var Container$A = styled(motion.div).withConfig({
  displayName: "dropdownstyles__Container",
  componentId: "keen-ui-core__sc-1k05xa4-1"
})(["&&&{position:absolute;background:", ";border:solid 1px ", ";box-shadow:0 10px 24px 0 rgba(29,39,41,0.15);z-index:", ";will-change:top;", ";}"], colors.white[500], colors.gray[200], UI_LAYERS.dropdown, function (props) {
  return props.fullWidth && css(["width:100%;"]);
});

var dropdownMotion$1 = {
  initial: {
    opacity: 0,
    top: 20
  },
  animate: {
    opacity: 1,
    top: 2
  },
  exit: {
    opacity: 0,
    top: 30
  }
};
var Dropdown = forwardRef(function (_ref, ref) {
  var isOpen = _ref.isOpen,
      children = _ref.children,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      _ref$motion = _ref.motion,
      motion = _ref$motion === void 0 ? dropdownMotion$1 : _ref$motion,
      _ref$positionRelative = _ref.positionRelativeToDocument,
      positionRelativeToDocument = _ref$positionRelative === void 0 ? false : _ref$positionRelative;
  return React__default.createElement(Wrapper$2, {
    isRelative: !positionRelativeToDocument
  }, React__default.createElement(AnimatePresence, null, isOpen && React__default.createElement(Container$A, Object.assign({
    ref: ref
  }, motion, {
    fullWidth: fullWidth
  }), children)));
});
Dropdown.displayName = 'Dropdown';

var StyledColorPicker = styled.div.withConfig({
  displayName: "color-pickerstyles__StyledColorPicker",
  componentId: "keen-ui-core__sc-1wm42hl-0"
})(["&&&{width:220px;}&&& .sketch-picker{box-shadow:none !important;font-family:Lato,sans-serif;}"]);
var Buttons = styled.div.withConfig({
  displayName: "color-pickerstyles__Buttons",
  componentId: "keen-ui-core__sc-1wm42hl-1"
})(["&&&{border-top:1px solid ", ";padding:8px;display:flex;justify-content:space-between;}"], colors.gray[300]);

var ColorPicker = function ColorPicker(_ref) {
  var color = _ref.color,
      onClosePicker = _ref.onClosePicker,
      onColorChange = _ref.onColorChange,
      colorSuggestions = _ref.colorSuggestions;

  var _useState = useState(color),
      _useState2 = _slicedToArray(_useState, 2),
      selectedColor = _useState2[0],
      setColor = _useState2[1];

  return React.createElement(StyledColorPicker, {
    "data-testid": "color-picker"
  }, React.createElement(SketchPicker, {
    disableAlpha: true,
    color: selectedColor,
    onChange: function onChange(colorResult) {
      return setColor(colorResult.hex);
    },
    presetColors: colorSuggestions
  }), React.createElement(Buttons, null, React.createElement(Button, {
    onClick: function onClick() {
      return onColorChange(selectedColor);
    },
    variant: "secondary",
    size: "small"
  }, "Save"), React.createElement(Button, {
    onClick: onClosePicker,
    variant: "secondary",
    size: "small",
    style: "outline"
  }, "Cancel")));
};

styled.div.withConfig({
  displayName: "color-palettestyles__StyledColorPalette",
  componentId: "keen-ui-core__sc-tuezmu-0"
})(["&&&{display:flex;flex-wrap:wrap;gap:3px;}"]);
var SortableContainer = styled.div.withConfig({
  displayName: "color-palettestyles__SortableContainer",
  componentId: "keen-ui-core__sc-tuezmu-1"
})(["&&&{display:flex;flex-wrap:wrap;gap:3px;}"]);
var AddColorButton = styled.div.withConfig({
  displayName: "color-palettestyles__AddColorButton",
  componentId: "keen-ui-core__sc-tuezmu-2"
})(["&&&{width:70px;height:37px;position:relative;cursor:pointer;border:1px solid ", ";background-color:", ";box-sizing:border-box;display:flex;align-items:center;justify-content:center;}"], colors.gray[300], colors.gray[200]);
var StyledContainer = styled.div.withConfig({
  displayName: "color-palettestyles__StyledContainer",
  componentId: "keen-ui-core__sc-tuezmu-3"
})(["&&&{position:absolute;top:", "px;left:", "px;}"], function (props) {
  return props.y;
}, function (props) {
  return props.x;
});

var StyledColor = styled.div.withConfig({
  displayName: "colorstyles__StyledColor",
  componentId: "keen-ui-core__sc-16gd2xx-0"
})(["&&&{background-color:", ";width:70px;height:37px;position:relative;box-shadow:0 2px 4px 0 ", ";}"], function (props) {
  return props.color;
}, transparentize(0.85, colors.black[500]));
var DragHandle = styled.div.withConfig({
  displayName: "colorstyles__DragHandle",
  componentId: "keen-ui-core__sc-16gd2xx-1"
})(["&&&{position:absolute;height:100%;width:18px;justify-content:center;cursor:grab;display:flex;align-items:center;background:", ";}"], transparentize(0.4, colors.white[400]));
var DeleteButton = styled.div.withConfig({
  displayName: "colorstyles__DeleteButton",
  componentId: "keen-ui-core__sc-16gd2xx-2"
})(["&&&{position:absolute;width:16px;height:16px;top:0;right:0;display:flex;align-items:center;justify-content:center;border-bottom-left-radius:2px;cursor:pointer;background:", ";}"], transparentize(0.4, colors.white[400]));
styled.div.withConfig({
  displayName: "colorstyles__StyledContainer",
  componentId: "keen-ui-core__sc-16gd2xx-3"
})(["&&&{position:absolute;top:", "px;left:", "px;}"], function (props) {
  return props.y;
}, function (props) {
  return props.x;
});

var DynamicPortal = function DynamicPortal(_ref) {
  var children = _ref.children,
      zIndex = _ref.zIndex;
  var el = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      setIsBootstrapped = _useState2[1];

  useEffect(function () {
    el.current = document.createElement('div');
    el.current.style.cssText = "z-index: ".concat(zIndex || UI_LAYERS.tooltip, ";\n                                position: absolute;\n                                top: 0;\n                                left: 0;\n                                width: 100%;\n                                ");
    el.current.setAttribute('data-testid', 'dynamic-portal');
    document.body.appendChild(el.current);
    setIsBootstrapped(true);
    return function () {
      document.body.removeChild(el.current);
    };
  }, [zIndex]);
  return el.current ? createPortal(children, el.current) : null;
};

var Color$1 = function Color(_ref) {
  var color = _ref.color,
      isDragged = _ref.isDragged,
      onDelete = _ref.onDelete,
      toggleColorPicker = _ref.toggleColorPicker,
      activeColorPicker = _ref.activeColorPicker,
      onColorChange = _ref.onColorChange,
      colorSuggestions = _ref.colorSuggestions,
      scrollableParentRef = _ref.scrollableParentRef;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var colorPickerContainerRef = useRef(null);

  var _useState3 = useState({
    x: 0,
    y: 0
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      colorPickerPosition = _useState4[0],
      setColorPickerPosition = _useState4[1];

  var colorButtonRef = useRef(null);
  var onClickOutside = useCallback(function () {
    if (activeColorPicker === color) {
      toggleColorPicker(null);
    }
  }, [colorPickerContainerRef, activeColorPicker]);
  useOnClickOutside(colorPickerContainerRef, onClickOutside);

  var setPickerPosition = function setPickerPosition() {
    var colorButtonRect = colorButtonRef.current.getBoundingClientRect();
    setColorPickerPosition({
      x: colorButtonRect.x,
      y: colorButtonRect.y + window.scrollY + colorButtonRect.height
    });
  };

  var hideColorPicker = useCallback(function () {
    toggleColorPicker(null);
  }, [toggleColorPicker]);
  useEffect(function () {
    var scrollableRef = scrollableParentRef === null || scrollableParentRef === void 0 ? void 0 : scrollableParentRef.current;
    scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.addEventListener('scroll', hideColorPicker);
    return function () {
      scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.removeEventListener('scroll', hideColorPicker);
    };
  }, [scrollableParentRef, hideColorPicker]);
  return React.createElement("div", null, React.createElement(StyledColor, {
    "data-testid": "color",
    color: color,
    onClick: function onClick() {
      setPickerPosition();
      toggleColorPicker(color);
    },
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    ref: colorButtonRef
  }, isHovered && !isDragged && React.createElement("div", null, React.createElement(DragHandle, {
    className: "drag-handle",
    "data-testid": "drag-handle"
  }, React.createElement(Icon, {
    type: "drag",
    fill: colors.black[100],
    width: 10
  })), React.createElement(DeleteButton, {
    onClick: function onClick() {
      return onDelete(color);
    },
    "data-testid": "delete-button"
  }, React.createElement(Icon, {
    type: "close",
    fill: colors.black[100],
    width: 8
  })))), activeColorPicker === color && React.createElement(DynamicPortal, null, React.createElement(StyledContainer, {
    x: colorPickerPosition.x,
    y: colorPickerPosition.y,
    ref: colorPickerContainerRef
  }, React.createElement(Dropdown, {
    isOpen: activeColorPicker === color,
    fullWidth: false
  }, React.createElement(ColorPicker, {
    color: color,
    colorSuggestions: colorSuggestions,
    onClosePicker: function onClosePicker() {
      return toggleColorPicker(color);
    },
    onColorChange: onColorChange
  })))));
};

var SET_IS_DRAGGED = 'SET_IS_DRAGGED';
var SET_COLORS = 'SET_COLORS';
var SET_ACTIVE_COLOR = 'SET_ACTIVE_COLOR';
var SET_ADD_COLOR_PICKER_OPEN = 'SET_ADD_COLOR_PICKER_OPEN';
var SET_COLOR_PICKER_POSITION = 'SET_COLOR_PICKER_POSITION';

var setIsDragged = function setIsDragged(isDragged) {
  return {
    type: SET_IS_DRAGGED,
    payload: {
      isDragged: isDragged
    }
  };
};

var setColors = function setColors(colors) {
  return {
    type: SET_COLORS,
    payload: {
      colors: colors
    }
  };
};

var setActiveColor = function setActiveColor(color) {
  return {
    type: SET_ACTIVE_COLOR,
    payload: {
      color: color
    }
  };
};

var setAddColorPickerOpen = function setAddColorPickerOpen(addColorPickerOpen) {
  return {
    type: SET_ADD_COLOR_PICKER_OPEN,
    payload: {
      addColorPickerOpen: addColorPickerOpen
    }
  };
};

var setColorPickerPosition = function setColorPickerPosition(colorPickerPosition) {
  return {
    type: SET_COLOR_PICKER_POSITION,
    payload: {
      colorPickerPosition: colorPickerPosition
    }
  };
};

var colorPaletteActions = {
  setIsDragged: setIsDragged,
  setColors: setColors,
  setActiveColor: setActiveColor,
  setAddColorPickerOpen: setAddColorPickerOpen,
  setColorPickerPosition: setColorPickerPosition
};

var initialState = {
  isDragged: false,
  colors: [],
  activeColor: '',
  addColorPickerOpen: false,
  colorPickerPosition: {
    x: 0,
    y: 0
  }
};
var colorPaletteReducer = function colorPaletteReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_IS_DRAGGED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isDragged: action.payload.isDragged
      });

    case SET_COLORS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        colors: action.payload.colors
      });

    case SET_ACTIVE_COLOR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        activeColor: action.payload.color
      });

    case SET_ADD_COLOR_PICKER_OPEN:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        addColorPickerOpen: action.payload.addColorPickerOpen
      });

    case SET_COLOR_PICKER_POSITION:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        colorPickerPosition: action.payload.colorPickerPosition
      });

    default:
      return state;
  }
};

var ColorPalette = function ColorPalette(_ref) {
  var palette = _ref.colors,
      onColorsChange = _ref.onColorsChange,
      colorSuggestions = _ref.colorSuggestions,
      _ref$initialPickerCol = _ref.initialPickerColor,
      initialPickerColor = _ref$initialPickerCol === void 0 ? '#00FF00' : _ref$initialPickerCol,
      _ref$maxNumberOfColor = _ref.maxNumberOfColors,
      maxNumberOfColors = _ref$maxNumberOfColor === void 0 ? 14 : _ref$maxNumberOfColor,
      scrollableParentRef = _ref.scrollableParentRef;

  var _useReducer = useReducer(colorPaletteReducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      isDragged = _useReducer2$.isDragged,
      colors$1 = _useReducer2$.colors,
      activeColor = _useReducer2$.activeColor,
      addColorPickerOpen = _useReducer2$.addColorPickerOpen,
      colorPickerPosition = _useReducer2$.colorPickerPosition,
      dispatch = _useReducer2[1];

  var colorsOrderRef = useRef(colors$1);
  var sortableContainerRef = useRef(null);
  var colorPickerDropdownRef = useRef(null);
  var addColorButtonRef = useRef(null);
  var onColorPickerClickOutside = useCallback(function () {
    if (addColorPickerOpen) {
      dispatch(colorPaletteActions.setAddColorPickerOpen(false));
    }
  }, [colorPickerDropdownRef, addColorPickerOpen]);
  useOnClickOutside(colorPickerDropdownRef, onColorPickerClickOutside);

  var onColorDelete = function onColorDelete(deletedColor) {
    var filteredColors = colorsOrderRef.current.filter(function (color) {
      return color !== deletedColor;
    });
    colorsOrderRef.current = filteredColors;
    dispatch(colorPaletteActions.setColors(filteredColors));
    onColorsChange(filteredColors);
  };

  var _toggleColorPicker = function toggleColorPicker(color) {
    if (color === activeColor) {
      return dispatch(colorPaletteActions.setActiveColor(null));
    }

    dispatch(colorPaletteActions.setActiveColor(color));
  };

  var _onColorChange = function onColorChange(color) {
    var colorToChangeIndex = colorsOrderRef.current.indexOf(activeColor);
    colorsOrderRef.current[colorToChangeIndex] = color;
    dispatch(colorPaletteActions.setColors(colorsOrderRef.current));

    _toggleColorPicker(null);

    onColorsChange(colorsOrderRef.current);
  };

  var addColor = function addColor(color) {
    colorsOrderRef.current.push(color);
    dispatch(colorPaletteActions.setColors(colorsOrderRef.current));

    _toggleColorPicker(null);

    onColorsChange(colorsOrderRef.current);
  };

  useEffect(function () {
    colorsOrderRef.current = _toConsumableArray(palette);
    dispatch(colorPaletteActions.setColors(_toConsumableArray(palette)));
  }, [palette]);
  var hideColorPicker = useCallback(function () {
    dispatch(colorPaletteActions.setAddColorPickerOpen(false));
  }, [colorPaletteActions.setAddColorPickerOpen]);
  useEffect(function () {
    var scrollableRef = scrollableParentRef === null || scrollableParentRef === void 0 ? void 0 : scrollableParentRef.current;
    scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.addEventListener('scroll', hideColorPicker);
    return function () {
      scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.removeEventListener('scroll', hideColorPicker);
    };
  }, [scrollableParentRef, hideColorPicker]);
  useEffect(function () {
    new Sortable(sortableContainerRef.current, {
      animation: 200,
      handle: '.drag-handle',
      onStart: function onStart() {
      },
      onMove: function onMove(event) {
        return !event.related.classList.contains('add-color-button-wrapper');
      },
      onEnd: function onEnd(evt) {
        colorsOrderRef.current = mutateArray(colorsOrderRef.current, evt.oldIndex, evt.newIndex);
        onColorsChange(colorsOrderRef.current);
        dispatch(colorPaletteActions.setColors(colorsOrderRef.current));
        dispatch(colorPaletteActions.setIsDragged(false));
      }
    });
  }, [colors$1]);

  var setPickerPosition = function setPickerPosition() {
    var addColorButtonRect = addColorButtonRef.current.getBoundingClientRect();
    dispatch(colorPaletteActions.setColorPickerPosition({
      x: addColorButtonRect.x,
      y: addColorButtonRect.y + window.scrollY + addColorButtonRect.height
    }));
  };

  return React.createElement(SortableContainer, {
    ref: sortableContainerRef
  }, colors$1.map(function (color, id) {
    return React.createElement(Color$1, {
      color: color,
      key: color + id,
      isDragged: isDragged,
      toggleColorPicker: function toggleColorPicker(color) {
        return _toggleColorPicker(color);
      },
      onColorChange: function onColorChange(color) {
        return _onColorChange(color);
      },
      activeColorPicker: activeColor,
      colorSuggestions: colorSuggestions,
      onDelete: function onDelete(color) {
        return onColorDelete(color);
      },
      scrollableParentRef: scrollableParentRef
    });
  }), colors$1.length < maxNumberOfColors && React.createElement("div", {
    className: "add-color-button-wrapper"
  }, React.createElement(AddColorButton, {
    onClick: function onClick() {
      setPickerPosition();
      dispatch(colorPaletteActions.setAddColorPickerOpen(true));
    },
    "data-testid": "add-color-button",
    ref: addColorButtonRef
  }, React.createElement(Icon, {
    type: "plus",
    fill: colors.gray[500],
    width: 18
  })), addColorPickerOpen && React.createElement(DynamicPortal, null, React.createElement(StyledContainer, {
    x: colorPickerPosition.x,
    y: colorPickerPosition.y,
    ref: colorPickerDropdownRef
  }, React.createElement(Dropdown, {
    isOpen: true,
    fullWidth: false
  }, React.createElement(ColorPicker, {
    color: initialPickerColor,
    colorSuggestions: colorSuggestions,
    onClosePicker: function onClosePicker() {
      return dispatch(colorPaletteActions.setAddColorPickerOpen(false));
    },
    onColorChange: function onColorChange(color) {
      addColor(color);
      dispatch(colorPaletteActions.setAddColorPickerOpen(false));
    }
  }))))));
};

var Container$z = styled.div.withConfig({
  displayName: "content-separatorstyles__Container",
  componentId: "keen-ui-core__sc-xh8nks-0"
})(["&&&{display:flex;align-items:center;padding:20px 0;}"]);
var Line = styled.div.withConfig({
  displayName: "content-separatorstyles__Line",
  componentId: "keen-ui-core__sc-xh8nks-1"
})(["&&&{flex-basis:100%;flex-shrink:1;height:1px;background:", ";}"], transparentize(0.2, colors.black['100']));
var Content$2 = styled.div.withConfig({
  displayName: "content-separatorstyles__Content",
  componentId: "keen-ui-core__sc-xh8nks-2"
})(["&&&{padding:0 15px;font-size:16px;font-family:'Lato Bold',sans-serif;line-height:20px;flex-shrink:0;color:", ";}"], transparentize(0.2, colors.black['100']));

var ContentSeparator = function ContentSeparator(_ref) {
  var children = _ref.children;
  return React__default.createElement(Container$z, null, React__default.createElement(Line, null), React__default.createElement(Content$2, null, children), React__default.createElement(Line, null));
};

var Container$y = styled.div.withConfig({
  displayName: "dropdown-menustyles__Container",
  componentId: "keen-ui-core__sc-1ep44d6-0"
})(["&&&{font-family:'Lato regular',sans-serif;font-size:14px;}"]);

var DropdownMenu$1 = function DropdownMenu(_ref) {
  var children = _ref.children;
  return React__default.createElement(Container$y, {
    role: "list"
  }, children);
};

var Container$x = styled.div.withConfig({
  displayName: "itemstyles__Container",
  componentId: "keen-ui-core__sc-1pzfw8b-0"
})(["&&&{padding:5px 15px;color:", ";font-family:'Lato Regular',sans-serif;font-size:14px;cursor:pointer;transition:background 0.2s linear;}&&&:hover{background:", ";}"], colors.blue[500], transparentize(0.8, colors.green[100]));

var Item$3 = function Item(_ref) {
  var children = _ref.children,
      _onClick = _ref.onClick;
  return React__default.createElement(Container$x, {
    onClick: function onClick(e) {
      return _onClick && _onClick(e);
    },
    role: "listitem",
    "data-testid": "dropdown-menu-item"
  }, children);
};

var Container$w = styled.div.withConfig({
  displayName: "headerstyles__Container",
  componentId: "keen-ui-core__sc-1b71kk9-0"
})(["&&&{padding:5px 15px;color:", ";}"], transparentize(0.4, colors.blue[500]));

var DropdownMenuHeader = function DropdownMenuHeader(_ref) {
  var children = _ref.children;
  return React__default.createElement(Container$w, null, children);
};

var Separator$2 = styled.div.withConfig({
  displayName: "dividerstyles__Separator",
  componentId: "keen-ui-core__sc-lpyg6l-0"
})(["&&&{margin:10px 0;height:1px;background:", ";}"], colors.gray[300]);

var DropdownMenuSeparator = function DropdownMenuSeparator() {
  return React__default.createElement(Separator$2, null);
};

var DropdownMenu = {
  Container: DropdownMenu$1,
  Header: DropdownMenuHeader,
  Divider: DropdownMenuSeparator,
  Item: Item$3
};

var ListContainer = styled.ul.withConfig({
  displayName: "dropdown-liststyles__ListContainer",
  componentId: "keen-ui-core__sc-14tqhit-0"
})(["&&&{list-style:none;margin:0;padding:", ";overflow-y:auto;}"], function (props) {
  return props.padding;
});
var ListItem$2 = styled.li.withConfig({
  displayName: "dropdown-liststyles__ListItem",
  componentId: "keen-ui-core__sc-14tqhit-1"
})(["&&&{padding:9px 14px;display:flex;align-items:center;justify-content:space-between;font-size:14px;font-family:'Lato Regular',sans-serif;color:", ";cursor:pointer;transition:background 0.2s linear;", ";}&&&:hover{background:", ";}"], colors.blue[500], function (props) {
  return props.isActive && css(["background:", ";"], transparentize(0.8, colors.green[100]));
}, transparentize(0.8, colors.green[100]));

var defaultItemRender = function defaultItemRender(_ref) {
  var label = _ref.label;
  return React__default.createElement(React__default.Fragment, null, label);
};

var defaultSetActive = function defaultSetActive() {
  return false;
};

var DropdownList = forwardRef(function (_ref2, ref) {
  var items = _ref2.items,
      _onClick = _ref2.onClick,
      _ref2$renderItem = _ref2.renderItem,
      renderItem = _ref2$renderItem === void 0 ? defaultItemRender : _ref2$renderItem,
      _ref2$setActiveItem = _ref2.setActiveItem,
      setActiveItem = _ref2$setActiveItem === void 0 ? defaultSetActive : _ref2$setActiveItem,
      _ref2$debounce = _ref2.debounce,
      debounce = _ref2$debounce === void 0 ? 0 : _ref2$debounce,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? '10px 0' : _ref2$padding;
  var debounceRef = useRef(null);
  var scrollItem = useCallback(function () {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(function () {
      if (ref === null || ref === void 0 ? void 0 : ref.current) {
        ref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }, debounce);
  }, [ref === null || ref === void 0 ? void 0 : ref.current, setActiveItem]);
  return React__default.createElement(ListContainer, {
    padding: padding
  }, items.map(function (item, idx) {
    var isActive = setActiveItem(item, idx);
    if (isActive) scrollItem();
    return React__default.createElement(ListItem$2, {
      isActive: isActive,
      ref: isActive ? ref : null,
      key: idx,
      onClick: function onClick(e) {
        return _onClick(e, item);
      }
    }, renderItem(item, isActive));
  }));
});
DropdownList.displayName = 'DropdownList';

var DefaultGroup = styled.div.withConfig({
  displayName: "groupcomponent__DefaultGroup",
  componentId: "keen-ui-core__sc-1nltn8z-0"
})(["&&&{}"]);

var Group = function Group(_ref) {
  var children = _ref.children,
      _ref$groupNode = _ref.groupNode,
      groupNode = _ref$groupNode === void 0 ? DefaultGroup : _ref$groupNode,
      _ref$chunks = _ref.chunks,
      chunks = _ref$chunks === void 0 ? 2 : _ref$chunks;
  var elements = React__default.Children.toArray(children);
  var childrenGroups = [];
  var temporary;

  for (var i = 0, j = elements.length; i < j; i += chunks) {
    temporary = elements.slice(i, i + chunks);
    childrenGroups.push(temporary);
  }

  return React__default.createElement(React__default.Fragment, null, childrenGroups.map(function (group, idx) {
    return React__default.createElement(groupNode, {
      key: idx,
      children: group
    });
  }));
};

var FadeMask = styled.div.withConfig({
  displayName: "modalstyles__FadeMask",
  componentId: "keen-ui-core__sc-bmi9ad-0"
})(["&&&{position:fixed;top:0;left:0;width:100%;height:100%;z-index:", ";transition:background 250ms ease-in-out;background:", ";}"], UI_LAYERS.modal - 5, function (props) {
  return props.isMaskTransparent ? 'transparent' : transparentize(0.7, colors.black['500']);
});
var MotionContainer = styled(motion.div).withConfig({
  displayName: "modalstyles__MotionContainer",
  componentId: "keen-ui-core__sc-bmi9ad-1"
})(["&&&{position:absolute;left:50%;top:", "px;z-index:", ";display:flex;flex-direction:column;}"], function (props) {
  return 60 + props.scrollY;
}, UI_LAYERS.modal);

var KEYS_ARRAY = [33, 34, 38, 40];

var modalMotion = {
  initial: {
    y: 20,
    x: '-50%',
    opacity: 0
  },
  animate: {
    y: 0,
    opacity: 1
  },
  exit: {
    opacity: 0
  }
};
var Modal = function Modal(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      isOpen = _ref.isOpen,
      _ref$useMask = _ref.useMask,
      useMask = _ref$useMask === void 0 ? true : _ref$useMask,
      _ref$adjustPositionTo = _ref.adjustPositionToScroll,
      adjustPositionToScroll = _ref$adjustPositionTo === void 0 ? true : _ref$adjustPositionTo,
      _ref$closeOnFadeMaskC = _ref.closeOnFadeMaskClick,
      closeOnFadeMaskClick = _ref$closeOnFadeMaskC === void 0 ? true : _ref$closeOnFadeMaskC,
      _ref$blockScrollOnOpe = _ref.blockScrollOnOpen,
      blockScrollOnOpen = _ref$blockScrollOnOpe === void 0 ? false : _ref$blockScrollOnOpe,
      _ref$isMaskTransparen = _ref.isMaskTransparent,
      isMaskTransparent = _ref$isMaskTransparen === void 0 ? false : _ref$isMaskTransparen;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      closeable = _useState2[0],
      setClosable = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      scrollY = _useState4[0],
      setScrollY = _useState4[1];

  var closableIndicator = useCallback(function (isClosable) {
    return setClosable(isClosable);
  }, []);
  var closeHandler = useCallback(function () {
    if (closeable && onClose) onClose();
  }, [closeable, onClose]);
  var keyboardHandler = useCallback(function (keyEvent) {
    if (KEYS_ARRAY.includes(keyEvent.charCode) || KEYS_ARRAY.includes(keyEvent.keyCode)) {
      keyEvent.preventDefault();
    }

    if ((keyEvent.charCode || keyEvent.keyCode) === 27) {
      closeHandler();
    }
  }, [onClose]);
  var preventDefault = useCallback(function (e) {
    e.preventDefault();
  }, []);
  useEffect(function () {
    if (blockScrollOnOpen && isOpen) {
      document.addEventListener('wheel', preventDefault, {
        passive: false
      });
      document.addEventListener('mousewheel', preventDefault, {
        passive: false
      });
      document.addEventListener('DOMMouseScroll', preventDefault, {
        passive: false
      });
      document.addEventListener('keydown', keyboardHandler, false);
    }

    return function () {
      document.removeEventListener('wheel', preventDefault, false);
      document.removeEventListener('mousewheel', preventDefault, false);
      document.removeEventListener('DOMMouseScroll', preventDefault, false);
      document.removeEventListener('keydown', keyboardHandler, false);
    };
  }, [isOpen]);
  useEffect(function () {
    if (adjustPositionToScroll) {
      setScrollY(window.scrollY);
    }
  }, [isOpen]);
  var showMask = useMask && isOpen;
  return React__default.createElement(React__default.Fragment, null, showMask && React__default.createElement(FadeMask, {
    onClick: closeOnFadeMaskClick ? closeHandler : null,
    "data-testid": "fade-mask",
    isMaskTransparent: isMaskTransparent
  }), React__default.createElement(AnimatePresence, null, isOpen && React__default.createElement(MotionContainer, Object.assign({}, modalMotion, {
    scrollY: scrollY,
    "data-testid": "modal-container"
  }), React__default.createElement(Card, {
    padding: 0
  }, children(closableIndicator, closeHandler)))));
};

var transition = {
  default: {
    duration: 1.7,
    ease: 'easeInOut',
    yoyo: Infinity
  },
  fill: {
    duration: 1.7,
    ease: [1, 0, 0.8, 1],
    yoyo: Infinity,
    delay: 0.25
  }
};

var createMotion = function createMotion(color) {
  var _Color$rgb$array = Color$2(color).rgb().array(),
      _Color$rgb$array2 = _slicedToArray(_Color$rgb$array, 3),
      r = _Color$rgb$array2[0],
      g = _Color$rgb$array2[1],
      b = _Color$rgb$array2[2];

  return {
    hidden: {
      opacity: 0,
      pathLength: 0,
      fill: "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", 0)")
    },
    visible: {
      opacity: 1,
      pathLength: 1,
      fill: color
    }
  };
};

var Loader = function Loader(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 80 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 80 : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? colors.blue['500'] : _ref$fill;
  return React__default.createElement(motion.svg, {
    width: width,
    height: height,
    viewBox: "0 0 143 120",
    style: {
      stroke: fill,
      strokeWidth: 2,
      strokeLinejoin: 'round',
      strokeLinecap: 'round'
    }
  }, React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement(motion.path, {
    d: "M57.6 69 64.385 80.349 47.423 108.72 135.485 108.72 142.2 120 27 120z",
    variants: createMotion(fill),
    initial: "hidden",
    animate: "visible",
    transition: transition
  }), React__default.createElement(motion.path, {
    d: "M0 120 13.462 120 57.667 45.297 74.599 74.013 88.2 74.013 57.737 22.2z",
    variants: createMotion(fill),
    initial: "hidden",
    animate: "visible",
    transition: transition
  }), React__default.createElement(motion.path, {
    d: "M64.2 11.383 108.083 86.278 74.289 86.278 67.518 97.8 128.4 97.8 70.904 0z",
    variants: createMotion(fill),
    initial: "hidden",
    animate: "visible",
    transition: transition
  })));
};

var FadeLoader = function FadeLoader(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors.white['500'] : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 23 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 18 : _ref$height;
  return React__default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 30 25"
  }, React__default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M393.901855,24.0625 L395.3282,26.4963137 L391.762338,32.5808479 L410.27571,32.5808479 L411.6875,35 L387.46875,35 L393.901855,24.0625 Z M394.273948,14.6875 L400.75,25.4488032 L397.858576,25.4488032 L394.259048,19.4847074 L384.86192,35 L382,35 L394.273948,14.6875 Z M396.668118,10 L408.5625,30.3125 L395.967607,30.3125 L397.368485,27.9195292 L404.359437,27.9195292 L395.28125,12.3642822 L396.667975,10 L396.668118,10 Z",
    transform: "translate(-382 -10)"
  }, React__default.createElement("animate", {
    id: "animation1",
    attributeName: "opacity",
    from: "0.1",
    to: "1",
    dur: "1.2s",
    begin: "0s;animation2.end"
  }), React__default.createElement("animate", {
    id: "animation2",
    attributeName: "opacity",
    from: "1",
    to: "0.1",
    dur: "1.2s",
    begin: "animation1.end"
  })));
};

var ToggleWrapper = styled.div.withConfig({
  displayName: "togglecomponentstyles__ToggleWrapper",
  componentId: "keen-ui-core__sc-156q5xz-0"
})(["&&&{width:60px;height:22px;position:relative;cursor:pointer;", ";}&&&:focus-visible{outline:1px solid ", ";}"], function (props) {
  return props.isDisabled && css(["opacity:0.5;pointer-events:none;"]);
}, colors.lightBlue[500]);
var Track = styled.div.withConfig({
  displayName: "togglecomponentstyles__Track",
  componentId: "keen-ui-core__sc-156q5xz-1"
})(["&&&{position:absolute;top:0;left:0;width:60px;height:22px;border-radius:22px;overflow:hidden;", ";", ";", ";}"], function (props) {
  return props.variant === 'primary' && css(["background-color:", ";"], transparentize(0.3, colors.gray['400']));
}, function (props) {
  return props.variant === 'secondary' && css(["background-color:", ";"], colors.gray['500']);
}, function (props) {
  return props.variant === 'darkBlue' && css(["background-color:", ";"], transparentize(0.4, colors.blue['200']));
});
var TrackMotion = styled(motion.div).withConfig({
  displayName: "togglecomponentstyles__TrackMotion",
  componentId: "keen-ui-core__sc-156q5xz-2"
})(["&&&{position:absolute;top:0;left:0;width:60px;height:22px;border-radius:22px;box-sizing:border-box;transform-origin:left center;", ";", ";", ";}"], function (props) {
  return props.variant === 'primary' && css(["background-color:", ";"], colors.green['300']);
}, function (props) {
  return props.variant === 'secondary' && css(["background-color:", ";"], colors.lightBlue['500']);
}, function (props) {
  return props.variant === 'darkBlue' && css(["background-color:", ";"], colors.lightBlue['500']);
});
var LabelMotion = styled(motion.div).withConfig({
  displayName: "togglecomponentstyles__LabelMotion",
  componentId: "keen-ui-core__sc-156q5xz-3"
})(["&&&{position:relative;width:60px;height:22px;padding:4px 10px;border-radius:22px;display:flex;align-items:center;font-family:'Lato Regular',sans-serif;font-size:11px;text-transform:uppercase;box-sizing:border-box;}"]);
var SwitcherMotion = styled(motion.div).withConfig({
  displayName: "togglecomponentstyles__SwitcherMotion",
  componentId: "keen-ui-core__sc-156q5xz-4"
})(["&&&{position:absolute;top:0;left:0;height:22px;width:22px;border-radius:50%;box-sizing:border-box;", ";", ";", ";}"], function (props) {
  return props.variant === 'primary' && css(["background-color:", ";border:2px solid ", ";"], colors.white['500'], colors.green['500']);
}, function (props) {
  return props.variant === 'secondary' && css(["background-color:", ";border:2px solid ", ";"], colors.gray['100'], colors.blue['300']);
}, function (props) {
  return props.variant === 'darkBlue' && css(["background-color:", ";border:2px solid ", ";"], colors.white['500'], colors.white['500']);
});

var Toggle = function Toggle(_ref) {
  var _ref$isOn = _ref.isOn,
      isOn = _ref$isOn === void 0 ? false : _ref$isOn,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      onChange = _ref.onChange;
  var switcherVariants = {
    on: {
      x: 39
    },
    off: {
      x: -1
    }
  };
  var trackVariants = {
    on: {
      scaleX: 1
    },
    off: {
      scaleX: 0
    }
  };

  var labelColor = function labelColor(variant) {
    if (variant === 'primary') return colors.black['100'];
    if (variant === 'secondary') return colors.black['300'];
    if (variant === 'darkBlue') return colors.white['500'];
  };

  var labelVariants = {
    on: {
      justifyContent: 'flex-start',
      color: variant === 'darkBlue' ? colors.blue['500'] : colors.white['500']
    },
    off: {
      justifyContent: 'flex-end',
      color: labelColor(variant)
    }
  };
  var switcherTransition = {
    ease: [0.69, -0.55, 0.27, 1.55],
    duration: 0.3
  };
  var labelTransition = {
    type: 'tween',
    duration: 0.3
  };
  return React__default.createElement(ToggleWrapper, {
    isDisabled: isDisabled,
    onClick: function onClick() {
      return onChange(!isOn);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === KEYBOARD_KEYS.ENTER) {
        onChange(!isOn);
      }
    },
    "data-testid": "toggle",
    role: "switch",
    "aria-checked": isOn,
    tabIndex: 0
  }, React__default.createElement(Track, {
    variant: variant
  }, React__default.createElement(TrackMotion, {
    variant: variant,
    variants: trackVariants,
    initial: isOn ? 'on' : 'off',
    animate: isOn ? 'on' : 'off',
    transition: switcherTransition
  })), React__default.createElement(LabelMotion, {
    variants: labelVariants,
    initial: isOn ? 'on' : 'off',
    animate: isOn ? 'on' : 'off',
    transition: labelTransition
  }, isOn ? 'on' : 'off'), React__default.createElement(SwitcherMotion, {
    variant: variant,
    variants: switcherVariants,
    initial: isOn ? 'on' : 'off',
    animate: isOn ? 'on' : 'off',
    transition: switcherTransition
  }));
};

var POSITION_ALIGN = '0.5px';
var Container$v = styled.div.withConfig({
  displayName: "rulerstyles__Container",
  componentId: "keen-ui-core__sc-q3u2qu-0"
})(["&&&{position:relative;", ";", ";}"], function (props) {
  return props.layout === 'horizontal' && css(["width:100%;"]);
}, function (props) {
  return props.layout === 'vertical' && css(["height:100%;"]);
});
var PositionContainer = styled.div.withConfig({
  displayName: "rulerstyles__PositionContainer",
  componentId: "keen-ui-core__sc-q3u2qu-1"
})(["&&&{position:absolute;cursor:", ";", ";", ";}"], function (props) {
  return props.pointer && 'pointer';
}, function (props) {
  return props.type === 'horizontal' && css(["left:", ";transform:translateX(-50%);"], props.position);
}, function (props) {
  return props.type === 'vertical' && css(["top:", ";transform:translateY(-50%);"], props.position);
});
var Tick = styled.div.withConfig({
  displayName: "rulerstyles__Tick",
  componentId: "keen-ui-core__sc-q3u2qu-2"
})(["&&&{position:absolute;background:", ";", ";", ";}"], colors.black['100'], function (props) {
  return props.type === 'horizontal' && css(["top:0;left:calc(", " - ", ");width:1px;height:5px;"], props.position, POSITION_ALIGN);
}, function (props) {
  return props.type === 'vertical' && css(["top:calc(", " - ", ");left:0;width:5px;height:1px;"], props.position, POSITION_ALIGN);
});
var Label$4 = styled.div.withConfig({
  displayName: "rulerstyles__Label",
  componentId: "keen-ui-core__sc-q3u2qu-3"
})(["&&&{font-size:12px;font-family:'Lato Regular',sans-serif;color:", ";", ";", ";}"], colors.black['100'], function (props) {
  return props.type === 'horizontal' && css(["text-align:center;margin-top:10px;"]);
}, function (props) {
  return props.type === 'vertical' && css(["text-align:left;margin-left:10px;"]);
});

var defaultRenderer = function defaultRenderer(label, layout) {
  return React__default.createElement(Label$4, {
    type: layout
  }, label);
};

var Ruler = function Ruler(_ref) {
  var layout = _ref.layout,
      ticks = _ref.ticks,
      _ref$renderLabel = _ref.renderLabel,
      renderLabel = _ref$renderLabel === void 0 ? defaultRenderer : _ref$renderLabel,
      _onClick = _ref.onClick;
  return React__default.createElement(Container$v, {
    layout: layout
  }, ticks.map(function (_ref2, idx) {
    var position = _ref2.position,
        label = _ref2.label;
    return React__default.createElement(React__default.Fragment, {
      key: "".concat(idx, "-").concat(position)
    }, React__default.createElement(Tick, {
      type: layout,
      position: position
    }), React__default.createElement(PositionContainer, {
      type: layout,
      position: position,
      onClick: function onClick() {
        return _onClick && _onClick(position);
      },
      pointer: !!_onClick
    }, renderLabel(label, layout)));
  }));
};

var labelVariants = {
  prop: 'variant',
  variants: {
    primary: {
      color: colors.blue[500],
      fontFamily: 'Lato Regular, sans-serif',
      lineHeight: '16px'
    },
    secondary: {
      display: 'inline-block',
      color: colors.black[100],
      fontFamily: 'Lato Bold, sans-serif',
      lineHeight: '17px',
      marginBottom: '3px'
    }
  }
};
var StyledLabel = styled.label.withConfig({
  displayName: "labelstyles__StyledLabel",
  componentId: "keen-ui-core__sc-18mqd88-0"
})(["&&&{font-size:14px;", ";", ";", ";", ";}"], variant(labelVariants), function (props) {
  return props.disabled && props.variant === 'secondary' && css(["color:", ";cursor:not-allowed;"], transparentize(0.5, colors.black[100]));
}, function (props) {
  return props.disabled && props.variant === 'primary' && css(["opacity:0.5;cursor:not-allowed;"]);
}, function (props) {
  return props.hasError && css(["color:", ";"], colors.red[500]);
});
var Asterisk = styled.span.withConfig({
  displayName: "labelstyles__Asterisk",
  componentId: "keen-ui-core__sc-18mqd88-1"
})(["&&&{color:", ";}"], colors.red[500]);

var Label$3 = function Label(_ref) {
  var htmlFor = _ref.htmlFor,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      showAsterisk = _ref.showAsterisk,
      children = _ref.children;
  return React__default.createElement(StyledLabel, {
    hasError: hasError,
    variant: variant,
    disabled: disabled,
    htmlFor: htmlFor
  }, React__default.createElement(React__default.Fragment, null, children, showAsterisk && React__default.createElement(Asterisk, null, " *")));
};

var FakeInput = styled.div.withConfig({
  displayName: "fake-inputcomponent__FakeInput",
  componentId: "keen-ui-core__sc-1wum5jw-0"
})(["&&&{height:42px;border-bottom:solid 1px ", ";box-sizing:border-box;", ";}"], colors.blue['400'], function (props) {
  return props.hasError && css(["border-bottom:solid 2px ", ";"], colors.red[500]);
});

var inputVariants = {
  prop: 'variant',
  variants: {
    solid: {
      padding: '10px 14px',
      height: '37px',
      border: "1px solid ".concat(transparentize(0.5, colors.black[500])),
      borderRadius: '4px',
      color: colors.blue[500],
      '&:focus': {
        boxShadow: '0 0 3px 1px rgba(119, 163, 187, 0.5)'
      },
      '&:disabled': {
        border: "1px solid ".concat(transparentize(0.5, colors.blue[500])),
        background: colors.white[500]
      },
      '&:disabled::placeholder': {
        color: "".concat(transparentize(0.6, colors.black[400]))
      }
    },
    outline: {
      height: '40px',
      padding: '0 16px',
      border: 'none',
      fontSize: '16px',
      lineHeight: '20px',
      borderBottom: "solid 1px ".concat(colors.blue[400]),
      '&:focus': {
        background: transparentize(0.9, colors.blue[100])
      },
      '&:disabled': {
        borderBottom: "solid 1px ".concat(colors.gray[500])
      }
    }
  }
};
var Container$u = styled.div.withConfig({
  displayName: "inputstyles__Container",
  componentId: "keen-ui-core__sc-9xdn3s-0"
})(["&&&{box-sizing:border-box;margin:0;min-width:0;grid-template-columns:auto 1fr auto;display:grid;}"]);
var Suffix = styled.div.withConfig({
  displayName: "inputstyles__Suffix",
  componentId: "keen-ui-core__sc-9xdn3s-1"
})(["&&&{display:flex;padding-right:10px;align-self:center;box-sizing:border-box;margin:0;min-width:0;grid-area:input;grid-column:3;}"]);
var Prefix = styled.div.withConfig({
  displayName: "inputstyles__Prefix",
  componentId: "keen-ui-core__sc-9xdn3s-2"
})(["&&&{display:flex;padding-left:10px;align-self:center;box-sizing:border-box;margin:0;min-width:0;grid-area:input;grid-column:1;}"]);
var StyledInput$1 = styled.input.withConfig({
  displayName: "inputstyles__StyledInput",
  componentId: "keen-ui-core__sc-9xdn3s-3"
})(["&&&{width:100%;box-sizing:border-box;grid-area:input;grid-column:1 / span 3;font-family:'Lato Regular',sans-serif;outline:none;font-weight:normal;", ";", ";", ";", ";", ";", ";transition:background 0.1s linear;}&&&::-webkit-credentials-auto-fill-button{display:none !important;}"], variant(inputVariants), function (props) {
  return props.hasPrefix && css(["padding-left:35px;"]);
}, function (props) {
  return props.hasSuffix && css(["padding-right:35px;"]);
}, function (props) {
  return props.borderRadius && css(["border-radius:", ";"], props.borderRadius);
}, function (props) {
  return props.hasError && props.variant === 'outline' && css(["border-bottom:solid 2px ", ";color:", ";"], colors.red[500], colors.red[500]);
}, function (props) {
  return props.hasError && props.variant === 'solid' && css(["border-color:", ";color:", ";"], colors.red[500], colors.red[500]);
});

var Input$1 = forwardRef(function (_ref, ref) {
  var _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'outline' : _ref$variant,
      borderRadius = _ref.borderRadius,
      renderPrefix = _ref.renderPrefix,
      renderSuffix = _ref.renderSuffix,
      props = _objectWithoutProperties(_ref, ["hasError", "variant", "borderRadius", "renderPrefix", "renderSuffix"]);

  return React__default.createElement(Container$u, null, React__default.createElement(StyledInput$1, Object.assign({
    ref: ref,
    hasError: hasError,
    hasPrefix: !!renderPrefix,
    hasSuffix: !!renderSuffix,
    variant: variant,
    borderRadius: borderRadius
  }, props)), renderPrefix && React__default.createElement(Prefix, {
    "data-testid": "input-prefix"
  }, renderPrefix()), renderSuffix && React__default.createElement(Suffix, {
    "data-testid": "input-suffix"
  }, renderSuffix()));
});
Input$1.displayName = 'Input';

var Indicator = styled.div.withConfig({
  displayName: "selectstyles__Indicator",
  componentId: "keen-ui-core__sc-bnaj0q-0"
})(["&&&{padding:8px 16px 0 0;}"]);
var commonStyles = {
  noOptionsMessage: function noOptionsMessage(provided) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      fontFamily: "'Lato Regular', sans-serif"
    });
  },
  option: function option(provided) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      fontSize: '16px',
      fontFamily: "'Lato Regular', sans-serif"
    });
  },
  singleValue: function singleValue(provided) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      fontSize: '16px',
      padding: '0 8px',
      fontFamily: "'Lato Regular', sans-serif"
    });
  },
  placeholder: function placeholder(provided) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      fontSize: '16px',
      padding: '0 8px',
      color: '#ccc',
      fontFamily: "'Lato Regular', sans-serif"
    });
  },
  input: function input(provided) {
    return _objectSpread2(_objectSpread2({}, provided), {}, {
      margin: '0 8px',
      fontFamily: "'Lato Regular', sans-serif"
    });
  }
};
var createStyles = function createStyles(variant, hasError) {
  return variant === 'outline' ? _objectSpread2({
    control: function control(provided, _ref) {
      var isFocused = _ref.isFocused;
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        minHeight: '40px',
        borderRadius: '0px',
        border: 'none',
        boxShadow: 'none',
        borderBottom: hasError ? "solid 2px ".concat(colors.red['500']) : "solid 1px ".concat(colors.blue['400']),
        borderColor: "".concat(hasError ? colors.red['500'] : colors.blue['400'], "!important"),
        background: isFocused ? transparentize(0.9, colors.blue['100']) : colors.white['500']
      });
    }
  }, commonStyles) : _objectSpread2({
    control: function control(provided, _ref2) {
      var isFocused = _ref2.isFocused;
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        minHeight: '40px',
        borderRadius: '4px',
        boxShadow: 'none',
        border: hasError ? "solid 1px ".concat(colors.red['100']) : "solid 1px ".concat(transparentize(0.85, colors.blue['100'])),
        background: isFocused ? transparentize(0.9, colors.blue['100']) : transparentize(0.95, colors.blue['100'])
      });
    }
  }, commonStyles);
};

var Select = function Select(_ref) {
  var options = _ref.options,
      placeholder = _ref.placeholder,
      value = _ref.value,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      hasError = _ref.hasError,
      name = _ref.name,
      inputId = _ref.inputId,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'outline' : _ref$variant;
  return React__default.createElement(ReactSelect, {
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      IndicatorsContainer: function IndicatorsContainer() {
        return React__default.createElement(Indicator, null, React__default.createElement(Icon, {
          type: "caret-down",
          fill: variant === 'outline' ? colors.blue['200'] : colors.blue['500']
        }));
      }
    },
    placeholder: placeholder,
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    options: options,
    name: name,
    inputId: inputId,
    styles: createStyles(variant, hasError)
  });
};

var Container$t = styled.div.withConfig({
  displayName: "radio-groupstyles__Container",
  componentId: "keen-ui-core__sc-1c5bt9w-0"
})(["&&&{display:inline-flex;align-items:center;background:", ";border-radius:4px;height:37px;}"], transparentize(0.85, colors.blue[100]));
var Item$2 = styled.div.withConfig({
  displayName: "radio-groupstyles__Item",
  componentId: "keen-ui-core__sc-1c5bt9w-1"
})(["&&&{height:35px;padding:0 15px;border-radius:4px;display:inline-flex;align-items:center;font-size:14px;font-family:'Lato Regular',sans-serif;color:", ";cursor:pointer;transition:all 0.2s ease-in;", ";}"], colors.blue[500], function (props) {
  return props.isActive && css(["box-shadow:0 2px 4px 0 ", ";background:", ";"], transparentize(0.85, colors.black[500]), transparentize(0.08, colors.green[100]));
});

var RadioGroup$1 = function RadioGroup(_ref) {
  var items = _ref.items,
      _onClick = _ref.onClick,
      activeItem = _ref.activeItem;
  return React__default.createElement(Container$t, null, items.map(function (item) {
    return React__default.createElement(Item$2, {
      key: item.id,
      isActive: item.id === activeItem,
      onClick: function onClick() {
        return _onClick(item);
      }
    }, item.label);
  }));
};

var Container$s = styled.div.withConfig({
  displayName: "radio-selectstyles__Container",
  componentId: "keen-ui-core__sc-17mfye3-0"
})(["&&&{display:flex;align-items:stretch;background:", ";border-radius:4px;height:37px;}"], transparentize(0.85, colors.blue[100]));
var Divider = styled.div.withConfig({
  displayName: "radio-selectstyles__Divider",
  componentId: "keen-ui-core__sc-17mfye3-1"
})(["&&&{width:1px;background:", ";flex-shrink:0;}"], transparentize(0.7, colors.blue[500]));
var Item$1 = styled.div.withConfig({
  displayName: "radio-selectstyles__Item",
  componentId: "keen-ui-core__sc-17mfye3-2"
})(["&&&{padding:0 10px;display:inline-flex;align-items:center;justify-content:center;flex:1;min-width:0;cursor:pointer;transition:all 0.2s ease-in;", ";}&&&:first-child{border-radius:4px 0 0 4px;}&&&:last-child{border-radius:0 4px 4px 0;}&&&:focus-visible{outline:1px solid ", ";}"], function (props) {
  return props.isActive && css(["background:", ";"], transparentize(0.5, colors.blue[100]));
}, colors.lightBlue[500]);

var RadioGroup = function RadioGroup(_ref) {
  var items = _ref.items,
      activeItem = _ref.activeItem,
      _onClick = _ref.onClick;
  return React__default.createElement(Container$s, {
    role: "tablist"
  }, items.map(function (item, idx, arr) {
    return React__default.createElement(React__default.Fragment, {
      key: item.id
    }, React__default.createElement(Item$1, {
      isActive: item.id === activeItem,
      onClick: function onClick() {
        return _onClick(item);
      },
      role: "tab",
      tabIndex: 0,
      onKeyDown: function onKeyDown(e) {
        if (e.keyCode === KEYBOARD_KEYS.ENTER) {
          _onClick(item);
        }
      }
    }, React__default.createElement(BodyText, {
      variant: "body2",
      color: colors.blue[500]
    }, item.label)), idx < arr.length - 1 && React__default.createElement(Divider, null));
  }));
};

var Image = function Image(_ref) {
  var name = _ref.name,
      src = _ref.src,
      alt = _ref.alt,
      _ref$initialHeight = _ref.initialHeight,
      initialHeight = _ref$initialHeight === void 0 ? 22 : _ref$initialHeight,
      useLoader = _ref.useLoader;

  var _useContext = useContext(CDNContext),
      url = _useContext.url;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      imageLoaded = _useState2[0],
      setImageLoaded = _useState2[1];

  var imageUrl = src ? src : "".concat(url, "/").concat(name);
  return React__default.createElement(React__default.Fragment, null, useLoader && !imageLoaded && React__default.createElement(Loader, {
    width: initialHeight,
    height: initialHeight
  }), React__default.createElement("img", {
    src: imageUrl,
    alt: alt,
    onLoad: function onLoad() {
      return setImageLoaded(true);
    }
  }));
};

var Wrapper$1 = styled.div.withConfig({
  displayName: "password-inputstyles__Wrapper",
  componentId: "keen-ui-core__sc-x4rq4i-0"
})(["&&&{display:flex;align-items:center;cursor:pointer;}"]);
var Hint = styled.div.withConfig({
  displayName: "password-inputstyles__Hint",
  componentId: "keen-ui-core__sc-x4rq4i-1"
})(["&&&{margin-left:8px;font-size:14px;font-family:Lato Regular,sans-serif;color:", ";}"], colors.blue['500']);

var PasswordInput = function PasswordInput(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisibility = _useState2[1];

  var inputType = visible ? 'text' : 'password';
  return React__default.createElement(Input$1, Object.assign({}, props, {
    type: inputType,
    renderSuffix: function renderSuffix() {
      return React__default.createElement(Wrapper$1, {
        onClick: function onClick() {
          return setVisibility(!visible);
        }
      }, React__default.createElement(Icon, {
        height: 22,
        width: 22,
        type: visible ? 'eye-slash-solid' : 'eye-solid',
        fill: colors.blue['500']
      }), React__default.createElement(Hint, null, visible ? 'Hide' : 'Show'));
    }
  }));
};

var List$1 = styled.ul.withConfig({
  displayName: "password-validatorstyles__List",
  componentId: "keen-ui-core__sc-5ju04l-0"
})(["&&&{padding:0;margin:0;display:flex;flex-wrap:wrap;list-style:none;}"]);
var IconSocket = styled.div.withConfig({
  displayName: "password-validatorstyles__IconSocket",
  componentId: "keen-ui-core__sc-5ju04l-1"
})(["&&&{margin-right:7px;display:flex;align-items:center;overflow:hidden;}"]);
var Item = styled.li.withConfig({
  displayName: "password-validatorstyles__Item",
  componentId: "keen-ui-core__sc-5ju04l-2"
})(["&&&{display:flex;align-items:center;flex-basis:50%;margin-bottom:10px;font-family:'Lato Regular',sans-serif;color:", ";font-size:12px;line-height:14px;transition:color 0.1s linear;}"], function (props) {
  return props.color;
});

var passwordValidators = [{
  description: 'One lowercase letter',
  validate: new RegExp('[a-z]')
}, {
  description: 'One number or special character',
  validate: new RegExp('(?=.*[!@#$%^&*])|(?=.*[0-9])')
}, {
  description: 'One uppercase letter',
  validate: new RegExp('[A-Z]')
}, {
  description: '8 characters minimum',
  validate: new RegExp('(?=.{8,})')
}];

var PasswordValidator = function PasswordValidator(_ref) {
  var password = _ref.password,
      touched = _ref.touched;
  return React__default.createElement(List$1, null, passwordValidators.map(function (_ref2, idx) {
    var description = _ref2.description,
        validate = _ref2.validate;
    var active = validate.test(password);
    var color = active ? transparentize(0.5, colors.black['300']) : colors.black['300'];
    return React__default.createElement(Item, {
      key: idx,
      color: touched && !active ? colors.red['500'] : color
    }, React__default.createElement(IconSocket, null, active ? React__default.createElement(Icon, {
      type: "check",
      width: 12,
      height: 12,
      fill: colors.green['400']
    }) : React__default.createElement(Icon, {
      type: "line",
      width: 12,
      height: 3,
      fill: colors.lightBlue['500']
    })), description);
  }));
};

var Tag$1 = styled.div.withConfig({
  displayName: "tag-managerstyles__Tag",
  componentId: "keen-ui-core__sc-k3j43r-0"
})(["&&&{background:", ";border-radius:13px;height:26px;padding:0 10px;margin-top:5px;font-family:'Lato Regular',sans-serif;font-size:14px;line-height:16px;color:", ";display:flex;justify-content:space-between;align-items:center;}"], colors.white['300'], colors.blue['500']);
var Text = styled.div.withConfig({
  displayName: "tag-managerstyles__Text",
  componentId: "keen-ui-core__sc-k3j43r-1"
})(["&&&{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:140px;}"]);
var IconWrapper = styled.div.withConfig({
  displayName: "tag-managerstyles__IconWrapper",
  componentId: "keen-ui-core__sc-k3j43r-2"
})(["&&&{margin-left:10px;cursor:pointer;}"]);
var StyledInput = styled.input.withConfig({
  displayName: "tag-managerstyles__StyledInput",
  componentId: "keen-ui-core__sc-k3j43r-3"
})(["&&&{outline:none;border:none;font-family:'Lato Regular',sans-serif;font-size:16px;line-height:20px;font-weight:normal;height:40px;padding:0;width:100%;margin-left:10px;}&&&::placeholder{color:#ccc;}"]);
var Container$r = styled.div.withConfig({
  displayName: "tag-managerstyles__Container",
  componentId: "keen-ui-core__sc-k3j43r-4"
})(["&&&{width:100%;padding:0 16px 0 6px;box-sizing:border-box;border-bottom:solid 1px ", ";display:flex;flex-wrap:wrap;align-items:center;}&&& ", " ", "{margin-right:5px;}"], colors.blue['400'], function (props) {
  return props.hasError && css(["border-bottom:solid 2px ", ";"], colors.orange['300']);
}, Tag$1);

var KeyCodes;

(function (KeyCodes) {
  KeyCodes[KeyCodes["COMMA"] = 44] = "COMMA";
  KeyCodes[KeyCodes["ENTER"] = 13] = "ENTER";
})(KeyCodes || (KeyCodes = {}));

var Opacity;

(function (Opacity) {
  Opacity[Opacity["VISIBLE"] = 1] = "VISIBLE";
  Opacity[Opacity["HIDDEN"] = 0] = "HIDDEN";
})(Opacity || (Opacity = {}));

var TagManager = function TagManager(_ref) {
  var tags = _ref.tags,
      onCreate = _ref.onCreate,
      onRemove = _ref.onRemove,
      onError = _ref.onError,
      validator = _ref.validator,
      placeholder = _ref.placeholder,
      hasError = _ref.hasError,
      _ref$blinkTime = _ref.blinkTime,
      blinkTime = _ref$blinkTime === void 0 ? 100 : _ref$blinkTime;
  var inputElement = useRef(null);

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      opacity = _useState2[0],
      setOpacity = _useState2[1];

  return React__default.createElement(Container$r, {
    hasError: hasError
  }, tags.map(function (tag, idx) {
    return React__default.createElement(Tag$1, {
      key: idx
    }, React__default.createElement(Text, {
      title: tag
    }, tag), React__default.createElement(IconWrapper, {
      onClick: function onClick() {
        return onRemove(tag, idx);
      },
      role: "button"
    }, React__default.createElement(Icon, {
      type: "close",
      fill: colors.blue['500'],
      width: 10,
      height: 10
    })));
  }), React__default.createElement(motion.div, {
    animate: {
      opacity: opacity
    },
    transition: {
      duration: 0.1
    }
  }, React__default.createElement(StyledInput, {
    ref: inputElement,
    placeholder: placeholder,
    onBlur: function onBlur(e) {
      var tag = e.currentTarget.value;

      if (validator(tag) && !tags.includes(tag)) {
        onCreate(tag);
        inputElement.current.value = '';
      }
    },
    onKeyPress: function onKeyPress(e) {
      if (e.charCode === KeyCodes.COMMA || e.charCode === KeyCodes.ENTER) {
        e.preventDefault();
        var tag = e.currentTarget.value;

        if (validator(tag) && !tags.includes(tag)) {
          onCreate(tag);
          inputElement.current.value = '';
        } else {
          if (onError) onError();
          setOpacity(Opacity.HIDDEN);
          setTimeout(function () {
            return setOpacity(Opacity.VISIBLE);
          }, blinkTime);
        }
      }
    }
  })));
};

var TagsContainer = styled.div.withConfig({
  displayName: "tag-managementstyles__TagsContainer",
  componentId: "keen-ui-core__sc-xavvsa-0"
})(["&&&{display:flex;flex-wrap:wrap;margin-top:10px;}"]);
var DropdownContainer = styled.div.withConfig({
  displayName: "tag-managementstyles__DropdownContainer",
  componentId: "keen-ui-core__sc-xavvsa-1"
})(["&&&{position:relative;}"]);
var Tag = styled.div.withConfig({
  displayName: "tag-managementstyles__Tag",
  componentId: "keen-ui-core__sc-xavvsa-2"
})(["&&&{margin-bottom:10px;margin-right:10px;}"]);

var TagManagement = function TagManagement(_ref) {
  var tags = _ref.tags,
      _ref$tagsPool = _ref.tagsPool,
      tagsPool = _ref$tagsPool === void 0 ? [] : _ref$tagsPool,
      newTagLabel = _ref.newTagLabel,
      tagsLabel = _ref.tagsLabel,
      placeholderLabel = _ref.placeholderLabel,
      onAddTag = _ref.onAddTag,
      onRemoveTag = _ref.onRemoveTag;
  var containerRef = useRef(null);
  var inputRef = useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectionIndex = _useState2[0],
      setIndex = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      dropdownVisible = _useState4[0],
      setDropdownVisibility = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      tagsHints = _useState6[0],
      setTagsHint = _useState6[1];

  var indexRef = useRef(selectionIndex);
  var tagsRef = useRef(tagsHints);
  indexRef.current = selectionIndex;
  tagsRef.current = tagsHints;

  var _useSearch = useSearch(tagsPool, function (searchResults, phrase) {
    var newTag = {
      label: "".concat(phrase, " ").concat(newTagLabel),
      value: phrase
    };
    var hints = [];

    if (searchResults.length) {
      if (!searchResults.includes(phrase)) {
        hints.push(newTag);
      }

      hints = [].concat(_toConsumableArray(hints), _toConsumableArray(searchResults.map(function (tag) {
        return {
          label: tag,
          value: tag
        };
      })));
    } else {
      hints.push(newTag);
    }

    setTagsHint(hints);
    setIndex(0);
    setDropdownVisibility(!!phrase);
  }, {
    threshold: 0.1
  }),
      searchHandler = _useSearch.searchHandler;

  var outsideClick = useCallback(function (e) {
    if (containerRef.current && !containerRef.current.contains(e.target)) {
      setDropdownVisibility(false);
    }
  }, [containerRef]);
  var keyboardHandler = useCallback(function (e) {
    var _a;

    if (!((_a = tagsRef.current) === null || _a === void 0 ? void 0 : _a.length)) return;

    switch (e.keyCode) {
      case KEYBOARD_KEYS.ENTER:
        var value = tagsRef.current[indexRef.current].value;

        if (value && !tags.includes(value)) {
          onAddTag(value);
        }

        inputRef.current.value = '';
        setDropdownVisibility(false);
        setTagsHint(null);
        break;

      case KEYBOARD_KEYS.UP:
        if (indexRef.current > 0) {
          setIndex(indexRef.current - 1);
        }

        break;

      case KEYBOARD_KEYS.DOWN:
        if (indexRef.current < tagsRef.current.length - 1) {
          setIndex(indexRef.current + 1);
        }

        break;
    }
  }, [tags]);
  useEffect(function () {
    document.addEventListener('click', outsideClick);
    return function () {
      return document.removeEventListener('click', outsideClick);
    };
  }, [containerRef]);
  useEffect(function () {
    document.addEventListener('keydown', keyboardHandler);
    return function () {
      document.removeEventListener('keydown', keyboardHandler);
    };
  }, [dropdownVisible, tags]);
  return React__default.createElement("div", null, React__default.createElement(Label$3, {
    htmlFor: "managementLabels",
    variant: "secondary"
  }, tagsLabel), React__default.createElement("div", {
    ref: containerRef
  }, React__default.createElement(DropdownContainer, null, React__default.createElement(Input$1, {
    "data-testid": "management-labels-input",
    ref: inputRef,
    type: "text",
    variant: "solid",
    id: "managementLabels",
    autoComplete: "off",
    placeholder: placeholderLabel,
    onChange: searchHandler
  }), React__default.createElement(Dropdown, {
    isOpen: dropdownVisible
  }, React__default.createElement(DropdownListContainer, {
    scrollToActive: true,
    maxHeight: 120
  }, function (activeItemRef) {
    return React__default.createElement(DropdownList, {
      ref: activeItemRef,
      setActiveItem: function setActiveItem(_item, idx) {
        return selectionIndex === idx;
      },
      items: tagsHints,
      onClick: function onClick(_e, _ref2) {
        var value = _ref2.value;

        if (value && !tags.includes(value)) {
          onAddTag(value);
        }

        inputRef.current.value = '';
        setDropdownVisibility(false);
        setTagsHint(null);
      }
    });
  }))), React__default.createElement(TagsContainer, null, tags.map(function (tag) {
    return React__default.createElement(Tag, {
      key: tag
    }, React__default.createElement(Badge, {
      onRemove: function onRemove() {
        return onRemoveTag(tag);
      },
      removable: true,
      variant: "purple",
      truncate: true
    }, tag));
  }))));
};

var Error$1 = styled.div.withConfig({
  displayName: "errorcomponent__Error",
  componentId: "keen-ui-core__sc-12jpnql-0"
})(["&&&{font-family:'Lato Regular',sans-serif;font-size:12px;line-height:14px;color:", ";}"], colors.red['500']);

var Container$q = styled.label.withConfig({
  displayName: "filter-itemstyles__Container",
  componentId: "keen-ui-core__sc-1l4v33i-0"
})(["&&&{display:flex;padding:7px 14px;cursor:pointer;}"]);
var Label$2 = styled.div.withConfig({
  displayName: "filter-itemstyles__Label",
  componentId: "keen-ui-core__sc-1l4v33i-1"
})(["&&&{margin-left:4px;min-width:0;}"]);

var FilterItem = function FilterItem(_ref) {
  var label = _ref.label,
      id = _ref.id,
      _onChange = _ref.onChange,
      isActive = _ref.isActive;
  var containerRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      labelTruncated = _useState2[0],
      setLabelTruncated = _useState2[1];

  useEffect(function () {
    if (containerRef.current.offsetWidth < containerRef.current.scrollWidth) {
      setLabelTruncated(true);
    }
  }, []);
  return React__default.createElement(MousePositionedTooltip, {
    isActive: labelTruncated,
    renderContent: function renderContent() {
      return React__default.createElement(BodyText, {
        variant: "body2",
        fontWeight: "normal",
        color: colors.black[500]
      }, label);
    },
    tooltipTheme: "light"
  }, React__default.createElement(Container$q, {
    htmlFor: id
  }, React__default.createElement(Checkbox, {
    id: id,
    type: "secondary",
    checked: isActive,
    onChange: function onChange() {
      return _onChange(!isActive);
    }
  }), React__default.createElement(Label$2, null, React__default.createElement(BodyText, {
    variant: "body2",
    enableTextEllipsis: true,
    ref: containerRef
  }, label))));
};

var PlaceholderContainer = styled.div.withConfig({
  displayName: "search-filtersstyles__PlaceholderContainer",
  componentId: "keen-ui-core__sc-1g00cy0-0"
})(["&&&{height:37px;display:flex;align-items:center;cursor:pointer;", ";}"], function (props) {
  return props.isActive && css(["display:none;"]);
});
var InputContainer = styled.div.withConfig({
  displayName: "search-filtersstyles__InputContainer",
  componentId: "keen-ui-core__sc-1g00cy0-1"
})(["&&&{display:none;", ";}"], function (props) {
  return props.isActive && css(["display:block;"]);
});
var Container$p = styled.div.withConfig({
  displayName: "search-filtersstyles__Container",
  componentId: "keen-ui-core__sc-1g00cy0-2"
})(["&&&{padding:5px 14px;}"]);
var Label$1 = styled.div.withConfig({
  displayName: "search-filtersstyles__Label",
  componentId: "keen-ui-core__sc-1g00cy0-3"
})(["&&&{margin-right:5px;}"]);

var SearchFilters = function SearchFilters(_ref) {
  var isActive = _ref.isActive,
      searchPhrase = _ref.searchPhrase,
      searchLabel = _ref.searchLabel,
      inputPlaceholder = _ref.inputPlaceholder,
      onClearPhrase = _ref.onClearPhrase,
      onChangePhrase = _ref.onChangePhrase,
      onActiveSearch = _ref.onActiveSearch;
  var inputRef = useRef(null);
  useEffect(function () {
    if (isActive && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isActive]);
  return React__default.createElement(Container$p, null, React__default.createElement(InputContainer, {
    isActive: isActive
  }, React__default.createElement(Input$1, {
    ref: inputRef,
    variant: "solid",
    placeholder: inputPlaceholder,
    onChange: function onChange(e) {
      return onChangePhrase(e.currentTarget.value);
    },
    value: searchPhrase,
    renderSuffix: function renderSuffix() {
      return React__default.createElement("div", {
        "data-testid": "clear-search",
        onClick: onClearPhrase
      }, React__default.createElement(Icon, {
        type: "close",
        width: 10,
        height: 10,
        fill: colors.gray[500]
      }));
    }
  })), React__default.createElement(PlaceholderContainer, {
    isActive: isActive,
    onClick: onActiveSearch
  }, React__default.createElement(Label$1, null, React__default.createElement(BodyText, {
    variant: "body2",
    color: colors.black[100],
    fontWeight: "bold"
  }, searchLabel)), React__default.createElement(Icon, {
    type: "search",
    fill: transparentize(0.5, colors.black[100])
  })));
};

var Container$o = styled.div.withConfig({
  displayName: "filtersstyles__Container",
  componentId: "keen-ui-core__sc-1awx58e-0"
})(["&&&{position:relative;}"]);
var DropdownContent = styled.div.withConfig({
  displayName: "filtersstyles__DropdownContent",
  componentId: "keen-ui-core__sc-1awx58e-1"
})(["&&&{padding:10px 0 0 0;width:200px;box-sizing:border-box;}"]);
var FiltersContainer = styled.div.withConfig({
  displayName: "filtersstyles__FiltersContainer",
  componentId: "keen-ui-core__sc-1awx58e-2"
})(["&&&{max-height:200px;overflow-y:auto;", ";}"], function (_ref) {
  var overflowTop = _ref.overflowTop,
      overflowBottom = _ref.overflowBottom;
  var boxShadow = "";
  if (overflowTop) boxShadow += "inset 0px 6px 4px -4px ".concat(transparentize(0.85, colors.black[500]));
  if (overflowTop && overflowBottom) boxShadow += ',';
  if (overflowBottom) boxShadow += "inset 0 -6px 4px -4px ".concat(transparentize(0.85, colors.black[500]));
  return css(["box-shadow:", ";"], boxShadow);
});
var ClearFilters = styled.div.withConfig({
  displayName: "filtersstyles__ClearFilters",
  componentId: "keen-ui-core__sc-1awx58e-3"
})(["&&&{padding:10px 14px;border-top:solid 1px ", ";cursor:pointer;}"], function (_ref2) {
  var enableBorder = _ref2.enableBorder;
  return enableBorder ? colors.gray[300] : 'transparent';
});
var EmptySearch$1 = styled.div.withConfig({
  displayName: "filtersstyles__EmptySearch",
  componentId: "keen-ui-core__sc-1awx58e-4"
})(["&&&{padding:10px 14px;text-align:center;}"]);

var DefaultLabels = {
  searchLabel: 'Search filters',
  searchInputPlaceholder: 'Search filters',
  clearFilters: 'Clear filters',
  noFiltersFound: 'No filters'
};

var Filters = function Filters(_ref) {
  var activeFilters = _ref.activeFilters,
      onUpdateFilters = _ref.onUpdateFilters,
      onClearFilters = _ref.onClearFilters,
      filters = _ref.filters,
      specialFilters = _ref.specialFilters,
      isOpen = _ref.isOpen,
      setOpen = _ref.setOpen,
      children = _ref.children,
      _ref$labels = _ref.labels,
      labels = _ref$labels === void 0 ? DefaultLabels : _ref$labels;
  var containerRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      searchMode = _useState2[0],
      setSearchMode = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      searchPhrase = _useState4[0],
      setSearchPhrase = _useState4[1];

  var _useInView = useInView(),
      _useInView2 = _slicedToArray(_useInView, 2),
      inViewRefTop = _useInView2[0],
      inViewTop = _useInView2[1];

  var _useInView3 = useInView(),
      _useInView4 = _slicedToArray(_useInView3, 2),
      inViewRefBottom = _useInView4[0],
      inViewBottom = _useInView4[1];

  var filteredItems = useMemo(function () {
    if (searchPhrase) {
      var phrase = searchPhrase.toLowerCase();
      return filters.filter(function (filters) {
        return filters.toLowerCase().includes(phrase);
      });
    }

    return filters;
  }, [searchPhrase, filters]);
  var updateFilters = useCallback(function (isActive, filter) {
    var updatedFilters = isActive ? [].concat(_toConsumableArray(activeFilters), [filter]) : activeFilters.filter(function (t) {
      return t !== filter;
    });
    onUpdateFilters(updatedFilters);
  }, [activeFilters, onUpdateFilters]);
  var isEmptySearch = searchPhrase && !filteredItems.length;
  useOnClickOutside(containerRef, function () {
    if (isOpen) {
      setOpen(false);
      setSearchPhrase('');
      setSearchMode(false);
    }
  });
  return React__default.createElement(Container$o, {
    "data-testid": "filter-queries",
    ref: containerRef
  }, children, React__default.createElement(Dropdown, {
    isOpen: isOpen,
    fullWidth: false
  }, React__default.createElement(DropdownContent, null, specialFilters && specialFilters.map(function (filter) {
    return React__default.createElement(FilterItem, {
      id: filter,
      key: filter,
      label: filter,
      isActive: activeFilters.includes(filter),
      onChange: function onChange(isActive) {
        return updateFilters(isActive, filter);
      }
    });
  }), React__default.createElement(SearchFilters, {
    isActive: searchMode,
    searchPhrase: searchPhrase,
    inputPlaceholder: labels.searchInputPlaceholder,
    searchLabel: labels.searchLabel,
    onChangePhrase: function onChangePhrase(phrase) {
      return setSearchPhrase(phrase);
    },
    onClearPhrase: function onClearPhrase() {
      setSearchPhrase('');
      setSearchMode(false);
    },
    onActiveSearch: function onActiveSearch() {
      return setSearchMode(true);
    }
  }), React__default.createElement(FiltersContainer, {
    overflowTop: !inViewTop,
    overflowBottom: !inViewBottom
  }, React__default.createElement("div", {
    ref: inViewRefTop
  }), filteredItems.map(function (filter) {
    return React__default.createElement(FilterItem, {
      key: filter,
      id: filter,
      isActive: activeFilters.includes(filter),
      label: filter,
      onChange: function onChange(isActive) {
        return updateFilters(isActive, filter);
      }
    });
  }), React__default.createElement("div", {
    ref: inViewRefBottom
  })), isEmptySearch && React__default.createElement(EmptySearch$1, null, React__default.createElement(BodyText, {
    variant: "body3",
    color: transparentize(0.2, colors.black[100]),
    fontWeight: 400
  }, labels.noFiltersFound))), React__default.createElement(ClearFilters, {
    onClick: onClearFilters,
    enableBorder: inViewBottom
  }, React__default.createElement(BodyText, {
    variant: "body2",
    color: colors.blue[200],
    fontWeight: "bold"
  }, labels.clearFilters))));
};

var TextOption = styled.div.withConfig({
  displayName: "typography-settingsstyles__TextOption",
  componentId: "keen-ui-core__sc-5d91ac-0"
})(["&&&{padding:0 14px;display:inline-flex;align-items:center;height:37px;background:", ";border-radius:4px;box-sizing:border-box;cursor:pointer;", ";}"], transparentize(0.85, colors.blue[100]), function (props) {
  return props.isActive && css(["background:", ";"], transparentize(0.5, colors.blue[100]));
});
styled.div.withConfig({
  displayName: "typography-settingsstyles__PickerContainer",
  componentId: "keen-ui-core__sc-5d91ac-1"
})(["&&&{margin:0 5px;}"]);
var Container$n = styled.div.withConfig({
  displayName: "typography-settingsstyles__Container",
  componentId: "keen-ui-core__sc-5d91ac-2"
})(["&&&{display:flex;align-items:center;column-gap:5px;}"]);
var Separator$1 = styled.div.withConfig({
  displayName: "typography-settingsstyles__Separator",
  componentId: "keen-ui-core__sc-5d91ac-3"
})(["&&&{margin:0 8px;width:1px;height:33px;background:", ";}"], transparentize(0.5, colors.black[100]));

var Header$2 = styled.div.withConfig({
  displayName: "text-alignmentstyles__Header",
  componentId: "keen-ui-core__sc-vmqpwx-0"
})(["&&&{display:flex;align-items:center;cursor:pointer;}"]);
var CaretDown$1 = styled.div.withConfig({
  displayName: "text-alignmentstyles__CaretDown",
  componentId: "keen-ui-core__sc-vmqpwx-1"
})(["&&&{margin-left:10px;}"]);

var OptionHeader = styled.div.withConfig({
  displayName: "option-headercomponent__OptionHeader",
  componentId: "keen-ui-core__sc-3gtxyf-0"
})(["&&&{padding:0 14px;display:flex;align-items:center;height:37px;background:", ";border-radius:4px;box-sizing:border-box;}"], transparentize(0.85, colors.blue[100]));

var Container$m = styled.div.withConfig({
  displayName: "attribute-dropdownstyles__Container",
  componentId: "keen-ui-core__sc-135d70j-0"
})(["&&&{width:66px;}"]);
var DropdownWrapper$1 = styled.div.withConfig({
  displayName: "attribute-dropdownstyles__DropdownWrapper",
  componentId: "keen-ui-core__sc-135d70j-1"
})(["&&&{position:absolute;top:", "px;left:", "px;width:66px;}"], function (props) {
  return props.y;
}, function (props) {
  return props.x;
});

var AttributeDropdown = function AttributeDropdown(_ref) {
  var scrollableContainerRef = _ref.scrollableContainerRef,
      children = _ref.children,
      renderHeader = _ref.renderHeader;
  var containerRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  useOnClickOutside(containerRef, function () {
    return setOpen(false);
  });
  useOnParentScroll(scrollableContainerRef, function () {
    return setOpen(false);
  });

  var _useDynamicContentPos = useDynamicContentPosition(containerRef),
      setPosition = _useDynamicContentPos.setPosition,
      contentPosition = _useDynamicContentPos.contentPosition;

  return React__default.createElement(Container$m, {
    ref: containerRef
  }, React__default.createElement(OptionHeader, {
    "data-testid": "rich-utils-header",
    onClick: function onClick() {
      setPosition();
      setOpen(!isOpen);
    }
  }, renderHeader()), React__default.createElement(DynamicPortal, null, React__default.createElement(DropdownWrapper$1, {
    x: contentPosition.x,
    y: contentPosition.y
  }, React__default.createElement(Dropdown, {
    isOpen: isOpen
  }, children))));
};

var Option = styled.div.withConfig({
  displayName: "optioncomponent__Option",
  componentId: "keen-ui-core__sc-w8cagp-0"
})(["&&&{padding:5px 14px;cursor:pointer;", ";}&&&:hover{background:", ";}"], function (props) {
  return props.isActive && css(["background:", ";"], transparentize(0.8, colors.green[100]));
}, transparentize(0.8, colors.green[100]));

var ICON = {
  left: 'align-left',
  center: 'align-center',
  right: 'align-right'
};
var OPTIONS = [{
  id: 'left',
  icon: 'align-left',
  style: 'left'
}, {
  id: 'center',
  icon: 'align-center',
  style: 'center'
}, {
  id: 'right',
  icon: 'align-right',
  style: 'right'
}];

var TextAlignment = function TextAlignment(_ref) {
  var currentAlignment = _ref.currentAlignment,
      onUpdateTextAlignment = _ref.onUpdateTextAlignment,
      scrollableContainerRef = _ref.scrollableContainerRef;
  return React__default.createElement(AttributeDropdown, {
    scrollableContainerRef: scrollableContainerRef,
    renderHeader: function renderHeader() {
      return React__default.createElement(Header$2, {
        "data-testid": "text-alignment-header"
      }, React__default.createElement(Icon, {
        type: ICON[currentAlignment],
        fill: colors.black[100],
        width: 13,
        height: 13
      }), React__default.createElement(CaretDown$1, null, React__default.createElement(Icon, {
        type: "caret-down",
        width: 10,
        height: 10,
        fill: transparentize(0.3, colors.blue[500])
      })));
    }
  }, OPTIONS.map(function (_ref2) {
    var id = _ref2.id,
        icon = _ref2.icon,
        style = _ref2.style;
    return React__default.createElement(Option, {
      key: id,
      "data-testid": "option-".concat(style),
      onClick: function onClick() {
        return onUpdateTextAlignment(style);
      },
      isActive: currentAlignment === style
    }, React__default.createElement(Icon, {
      type: icon,
      fill: colors.black[100],
      width: 13,
      height: 13
    }));
  }));
};

var Header$1 = styled.div.withConfig({
  displayName: "font-sizestyles__Header",
  componentId: "keen-ui-core__sc-1xnx6iq-0"
})(["&&&{display:flex;align-items:center;cursor:pointer;}"]);
var CaretDown = styled.div.withConfig({
  displayName: "font-sizestyles__CaretDown",
  componentId: "keen-ui-core__sc-1xnx6iq-1"
})(["&&&{margin-left:10px;}"]);

var FontSize = function FontSize(_ref) {
  var currentFontSize = _ref.currentFontSize,
      onUpdateFontSize = _ref.onUpdateFontSize,
      fontSizeSuggestions = _ref.fontSizeSuggestions,
      scrollableContainerRef = _ref.scrollableContainerRef;
  return React__default.createElement(AttributeDropdown, {
    scrollableContainerRef: scrollableContainerRef,
    renderHeader: function renderHeader() {
      return React__default.createElement(Header$1, {
        "data-testid": "font-size-header"
      }, React__default.createElement(BodyText, {
        variant: "body2",
        color: colors.blue[500]
      }, currentFontSize), React__default.createElement(CaretDown, null, React__default.createElement(Icon, {
        type: "caret-down",
        width: 10,
        height: 10,
        fill: transparentize(0.3, colors.blue[500])
      })));
    }
  }, fontSizeSuggestions.map(function (fontSize) {
    return React__default.createElement(Option, {
      key: fontSize,
      isActive: currentFontSize === fontSize,
      onClick: function onClick() {
        return onUpdateFontSize(fontSize);
      }
    }, React__default.createElement(BodyText, {
      variant: "body2"
    }, fontSize));
  }));
};

var ColorBox = styled.div.withConfig({
  displayName: "colorstyles__ColorBox",
  componentId: "keen-ui-core__sc-17hhaj9-0"
})(["&&&{width:37px;height:37px;cursor:pointer;background:", ";box-shadow:0 2px 4px 0 rgba(29,39,41,0.15);}"], function (props) {
  return props.background;
});
var DropdownWrapper = styled.div.withConfig({
  displayName: "colorstyles__DropdownWrapper",
  componentId: "keen-ui-core__sc-17hhaj9-1"
})(["&&&{position:absolute;top:", "px;left:", "px;width:220px;}"], function (props) {
  return props.y;
}, function (props) {
  return props.x;
});
var ColorWrapper = styled.div.withConfig({
  displayName: "colorstyles__ColorWrapper",
  componentId: "keen-ui-core__sc-17hhaj9-2"
})(["&&&{display:inline-block;width:37px;}"]);

var Color = function Color(_ref) {
  var initialColor = _ref.color,
      onColorChange = _ref.onColorChange,
      colorSuggestions = _ref.colorSuggestions,
      scrollableContainerRef = _ref.scrollableContainerRef;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      colorPickerVisible = _useState2[0],
      setColorPickerVisible = _useState2[1];

  var _useState3 = useState(initialColor),
      _useState4 = _slicedToArray(_useState3, 2),
      color = _useState4[0],
      setColor = _useState4[1];

  var dropdownRef = useRef(null);
  var pickerRef = useRef(null);

  var onClickOutsideColorPicker = function onClickOutsideColorPicker() {
    if (colorPickerVisible) {
      setColorPickerVisible(false);
    }
  };

  useOnClickOutside(pickerRef, onClickOutsideColorPicker);
  useOnParentScroll(scrollableContainerRef, function () {
    return setColorPickerVisible(false);
  });

  var _useDynamicContentPos = useDynamicContentPosition(dropdownRef),
      setPosition = _useDynamicContentPos.setPosition,
      contentPosition = _useDynamicContentPos.contentPosition;

  var changeColor = function changeColor(color) {
    setColor(color);
    onColorChange(color);
    setColorPickerVisible(false);
  };

  return React__default.createElement(ColorWrapper, {
    ref: dropdownRef,
    onMouseEnter: function onMouseEnter() {
      setPosition();
    }
  }, React__default.createElement(ColorBox, {
    "data-testid": "color-selector",
    background: color,
    onClick: function onClick() {
      setPosition();
      setColorPickerVisible(true);
    }
  }), React__default.createElement(DynamicPortal, null, React__default.createElement(DropdownWrapper, {
    x: contentPosition.x,
    y: contentPosition.y,
    ref: pickerRef
  }, React__default.createElement(Dropdown, {
    isOpen: colorPickerVisible
  }, React__default.createElement(ColorPicker, {
    color: color,
    colorSuggestions: colorSuggestions,
    onColorChange: function onColorChange(color) {
      return changeColor(color);
    },
    onClosePicker: function onClosePicker() {
      return setColorPickerVisible(false);
    }
  })))));
};

var DEFAULT_FONT_SIZES = [10, 12, 14, 18, 20, 24, 30, 36];
var FONT_STYLES = [{
  icon: 'bold-text',
  name: 'bold'
}, {
  icon: 'italic-text',
  name: 'italic'
}, {
  icon: 'underline-text',
  name: 'underline'
}];
var DEFAULT_AVAILABLE_SETTINGS = {
  color: true,
  fontSize: true,
  bold: true,
  italic: true,
  underline: true,
  alignment: true
};

var TypographySettings = function TypographySettings(_ref) {
  var settings = _ref.settings,
      onChange = _ref.onChange,
      _ref$colorSuggestions = _ref.colorSuggestions,
      colorSuggestions = _ref$colorSuggestions === void 0 ? [] : _ref$colorSuggestions,
      _ref$fontSizeSuggesti = _ref.fontSizeSuggestions,
      fontSizeSuggestions = _ref$fontSizeSuggesti === void 0 ? DEFAULT_FONT_SIZES : _ref$fontSizeSuggesti,
      scrollableContainerRef = _ref.scrollableContainerRef,
      _ref$availableSetting = _ref.availableSettings,
      availableSettings = _ref$availableSetting === void 0 ? DEFAULT_AVAILABLE_SETTINGS : _ref$availableSetting;

  var onSettingsChange = function onSettingsChange(name, value) {
    var newSettings = _objectSpread2(_objectSpread2({}, settings), {}, _defineProperty({}, name, value));

    onChange(newSettings);
  };

  return React__default.createElement(Container$n, null, availableSettings.color && React__default.createElement(Color, {
    color: settings.color,
    colorSuggestions: colorSuggestions,
    scrollableContainerRef: scrollableContainerRef,
    onColorChange: function onColorChange(color) {
      return onSettingsChange('color', color);
    }
  }), availableSettings.fontSize && React__default.createElement(FontSize, {
    currentFontSize: settings.size,
    fontSizeSuggestions: fontSizeSuggestions,
    scrollableContainerRef: scrollableContainerRef,
    onUpdateFontSize: function onUpdateFontSize(size) {
      return onSettingsChange('size', size);
    }
  }), FONT_STYLES.filter(function (_ref2) {
    var name = _ref2.name;
    return !!availableSettings[name];
  }).map(function (_ref3) {
    var name = _ref3.name,
        icon = _ref3.icon;
    return React__default.createElement(TextOption, {
      "data-testid": "".concat(name, "-font-style"),
      key: name,
      isActive: settings[name],
      onClick: function onClick() {
        onSettingsChange(name, !settings[name]);
      }
    }, React__default.createElement(Icon, {
      type: icon,
      width: 15,
      height: 15,
      fill: colors.black[100]
    }));
  }), availableSettings.alignment && React__default.createElement(React__default.Fragment, null, React__default.createElement(Separator$1, null), React__default.createElement(TextAlignment, {
    currentAlignment: settings.alignment,
    scrollableContainerRef: scrollableContainerRef,
    onUpdateTextAlignment: function onUpdateTextAlignment(alignment) {
      return onSettingsChange('alignment', alignment);
    }
  })));
};

var Container$l = styled.div.withConfig({
  displayName: "table-headerstyles__Container",
  componentId: "keen-ui-core__sc-heskr8-0"
})(["&&&{display:flex;text-align:left;background:inherit;background:", ";justify-content:", ";}"], function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.textAlignment === 'left' ? 'flex-start' : 'flex-end';
});
var Content$1 = styled.div.withConfig({
  displayName: "table-headerstyles__Content",
  componentId: "keen-ui-core__sc-heskr8-1"
})(["&&&{display:flex;align-items:center;gap:5px;box-sizing:border-box;min-height:20px;padding:20px;flex-direction:", ";}"], function (_ref) {
  var textAlignment = _ref.textAlignment;
  return textAlignment === 'left' ? 'row' : 'row-reverse';
});

var Container$k = styled.div.withConfig({
  displayName: "sort-indicatorsstyles__Container",
  componentId: "keen-ui-core__sc-4yfqt9-0"
})(["&&&{display:flex;flex-wrap:no-wrap;position:relative;}"]);
var DownArrow = styled(motion.div).withConfig({
  displayName: "sort-indicatorsstyles__DownArrow",
  componentId: "keen-ui-core__sc-4yfqt9-1"
})(["&&&{position:relative;top:5px;left:-1px;}"]);

var SortIndicators = function SortIndicators(_ref) {
  var _ref$sortMode = _ref.sortMode,
      sortMode = _ref$sortMode === void 0 ? 'ascending' : _ref$sortMode;
  return React__default.createElement(Container$k, {
    "data-testid": "sort-indicators"
  }, React__default.createElement(motion.div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: sortMode === 'descending' ? 1 : 0.3
    }
  }, React__default.createElement(Icon, {
    type: "arrow-up",
    fill: colors.white[500],
    width: 10
  })), React__default.createElement(DownArrow, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: sortMode === 'ascending' ? 1 : 0.3
    }
  }, React__default.createElement(Icon, {
    type: "arrow-down",
    fill: colors.white[500],
    width: 10
  })));
};

var TableHeader = function TableHeader(_ref) {
  var children = _ref.children,
      backgroundColor = _ref.backgroundColor,
      propertyName = _ref.propertyName,
      onSort = _ref.onSort,
      sortOptions = _ref.sortOptions,
      textAlignment = _ref.textAlignment;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setHover = _useState2[1];

  var _useState3 = useState({
    sortMode: null
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      columnMeta = _useState4[0],
      setState = _useState4[1];

  var sortMode = columnMeta.sortMode;
  var sortHandler = useCallback(function () {
    onSort({
      propertyName: propertyName,
      sortMode: sortMode ? sortMode : 'ascending'
    });
    var updatedSortMode = sortMode === 'descending' ? 'ascending' : 'descending';
    setState(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        sortMode: updatedSortMode
      });
    });
  }, [propertyName, sortMode, onSort]);
  var sortApplied = sortOptions && sortOptions.property === propertyName;
  var showColumnActions = sortApplied || isHovered && onSort;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Container$l, {
    backgroundColor: backgroundColor,
    textAlignment: textAlignment,
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onClick: function onClick() {
      return onSort && sortHandler();
    }
  }, React__default.createElement(Content$1, {
    textAlignment: textAlignment
  }, children, React__default.createElement(motion.div, {
    animate: showColumnActions ? {
      opacity: 1
    } : {
      opacity: 0
    },
    style: showColumnActions ? {
      visibility: 'visible'
    } : {
      visibility: 'hidden'
    },
    transition: {
      delay: 0.1,
      duration: 0.2
    }
  }, React__default.createElement(SortIndicators, {
    sortMode: sortMode
  })))));
};

var Container$j = styled(motion.tr).withConfig({
  displayName: "table-rowstyles__Container",
  componentId: "keen-ui-core__sc-ibd7gi-0"
})(["&&&{position:relative;", ";", ";}&&&:nth-child(odd){background:", ";}"], function (props) {
  return !props.disableHover && css(["&:hover{box-shadow:0 10px 24px rgba(29,39,41,0.15);}"]);
}, function (_ref) {
  var disableHover = _ref.disableHover,
      mainColor = _ref.mainColor;
  return !disableHover && css(["&:hover{td:first-of-type:before{content:'';display:block;position:absolute;top:0;bottom:0;left:0;width:4px;background-color:", ";}}"], mainColor);
}, function (props) {
  return rgba(props.mainColor, 0.05);
});

var StyledCell = styled.td.withConfig({
  displayName: "table-cellstyles__StyledCell",
  componentId: "keen-ui-core__sc-tzjc27-0"
})(["&&&{padding:0;border-right:1px solid ", ";position:relative;", ";}&&&:last-of-type{border-right:none;}"], colors.gray[200], function (_ref) {
  var disableBorder = _ref.disableBorder;
  return disableBorder && css(["border:0;"]);
});
var Container$i = styled.div.withConfig({
  displayName: "table-cellstyles__Container",
  componentId: "keen-ui-core__sc-tzjc27-1"
})(["&&&{padding:15px;text-align:", ";}"], function (props) {
  return props.textAlignment;
});

var VALUE_DELIMETER = ', ';

var TableCell = function TableCell(_ref) {
  var typography = _ref.typography,
      value = _ref.value,
      _ref$textAlignment = _ref.textAlignment,
      textAlignment = _ref$textAlignment === void 0 ? 'left' : _ref$textAlignment,
      index = _ref.index,
      disableBorder = _ref.disableBorder,
      _onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;

  var _useMemo = useMemo(function () {
    var cellValue;

    if (Array.isArray(value)) {
      cellValue = value.join(VALUE_DELIMETER);
    } else {
      cellValue = value;
    }

    return {
      cellValue: cellValue
    };
  }, [value]),
      cellValue = _useMemo.cellValue;

  return React__default.createElement(StyledCell, {
    "data-testid": "table-cell",
    onClick: function onClick(e) {
      return _onClick(e, value, index);
    },
    disableBorder: disableBorder,
    onMouseEnter: onMouseEnter ? function (e) {
      e.persist();
      onMouseEnter(e, index);
    } : null,
    onMouseLeave: onMouseLeave ? function (e) {
      e.persist();
      onMouseLeave(e, index);
    } : null
  }, React__default.createElement(Container$i, {
    textAlignment: textAlignment
  }, React__default.createElement(Text$1, Object.assign({}, typography), "".concat(cellValue))));
};

var TableRow = function TableRow(_ref) {
  var data = _ref.data,
      typography = _ref.typography,
      backgroundColor = _ref.backgroundColor,
      activeColumn = _ref.activeColumn,
      enableEditMode = _ref.enableEditMode,
      onCellClick = _ref.onCellClick,
      onCellMouseEnter = _ref.onCellMouseEnter,
      onCellMouseLeave = _ref.onCellMouseLeave;
  var rgbaBackground = useMemo(function () {
    return rgba(backgroundColor, 0.3);
  }, [backgroundColor]);
  return React__default.createElement(Container$j, {
    mainColor: backgroundColor,
    disableHover: enableEditMode,
    whileHover: enableEditMode ? {} : {
      backgroundColor: rgbaBackground
    }
  }, Object.keys(data).map(function (key, idx) {
    return React__default.createElement(TableCell, {
      key: key,
      index: idx,
      onClick: function onClick(e, value, idx) {
        return onCellClick(e, key, value, idx);
      },
      onMouseEnter: onCellMouseEnter,
      onMouseLeave: onCellMouseLeave,
      disableBorder: activeColumn !== undefined,
      typography: typography,
      value: data[key].value,
      textAlignment: data[key].alignment
    });
  }));
};

var Label = styled.div.withConfig({
  displayName: "items-per-pagestyles__Label",
  componentId: "keen-ui-core__sc-1hoaiph-0"
})(["&&&{display:flex;align-items:center;gap:5px;white-space:nowrap;padding:5px 10px;background-color:", ";border-radius:4px;cursor:pointer;", ";}"], transparentize(0.85, colors.blue[100]), function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen && css(["box-shadow:0px 0px 3px 1px ", ";"], transparentize(0.85, colors.black[500]));
});
var IconContainer$4 = styled(motion.div).withConfig({
  displayName: "items-per-pagestyles__IconContainer",
  componentId: "keen-ui-core__sc-1hoaiph-1"
})(["&&&{display:flex;}"]);
var Container$h = styled.div.withConfig({
  displayName: "items-per-pagestyles__Container",
  componentId: "keen-ui-core__sc-1hoaiph-2"
})(["&&&{position:relative;}&&&:focus-visible{outline:1px solid ", ";}"], colors.lightBlue[500]);
var List = styled(motion.ul).withConfig({
  displayName: "items-per-pagestyles__List",
  componentId: "keen-ui-core__sc-1hoaiph-3"
})(["&&&{position:absolute;width:", "px;min-width:min-content;top:", "px;left:", "px;margin:0;padding:0;list-style:none;background-color:", ";box-shadow:0px 10px 24px 0px ", ";}"], function (_ref2) {
  var width = _ref2.width;
  return width;
}, function (_ref3) {
  var y = _ref3.y;
  return y;
}, function (_ref4) {
  var x = _ref4.x;
  return x;
}, colors.white[500], transparentize(0.85, colors.black[500]));
var ListItem$1 = styled(motion.li).withConfig({
  displayName: "items-per-pagestyles__ListItem",
  componentId: "keen-ui-core__sc-1hoaiph-4"
})(["&&&{padding:10px;cursor:pointer;", ";}"], function (_ref5) {
  var isActive = _ref5.isActive;
  return isActive && css(["background-color:", ";"], transparentize(0.85, colors.blue[100]));
});

var PER_PAGE_OPTIONS = [15, 20, 30, 50, 100, 200];
var COMPACT_VIEW = 620;

var listMotion = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 2
  },
  exit: {
    opacity: 0,
    y: 30
  }
};

var ItemsPerPage = function ItemsPerPage(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? PER_PAGE_OPTIONS[0] : _ref$value,
      onChange = _ref.onChange;
  var containerRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectionIndex = _useState4[0],
      setIndex = _useState4[1];

  useOnClickOutside(containerRef, function () {
    return setOpen(false);
  });

  var _useDynamicContentPos = useDynamicContentPosition(containerRef),
      setPosition = _useDynamicContentPos.setPosition,
      contentPosition = _useDynamicContentPos.contentPosition;

  var x = contentPosition.x,
      y = contentPosition.y,
      width = contentPosition.width;
  useEffect(function () {
    if (isOpen) {
      var index = PER_PAGE_OPTIONS.findIndex(function (option) {
        return value === option;
      });
      setIndex(index);
    }

    return function () {
      setIndex(null);
    };
  }, [isOpen, value]);
  var keyboardHandler = useCallback(function (_e, keyCode) {
    switch (keyCode) {
      case KEYBOARD_KEYS.ENTER:
        var _value = PER_PAGE_OPTIONS[selectionIndex];
        onChange(_value);
        setOpen(false);
        break;

      case KEYBOARD_KEYS.UP:
        if (selectionIndex > 0) {
          setIndex(selectionIndex - 1);
        }

        break;

      case KEYBOARD_KEYS.DOWN:
        if (selectionIndex === null) {
          setIndex(0);
        } else if (selectionIndex < PER_PAGE_OPTIONS.length - 1) {
          setIndex(selectionIndex + 1);
        }

        break;

      case KEYBOARD_KEYS.ESCAPE:
        setOpen(false);
        break;
    }
  }, [selectionIndex, onChange]);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ENTER, KEYBOARD_KEYS.ESCAPE, KEYBOARD_KEYS.UP, KEYBOARD_KEYS.DOWN],
    addEventListenerCondition: isOpen,
    eventListenerDependencies: [selectionIndex, isOpen]
  });
  return React__default.createElement(Container$h, {
    ref: containerRef,
    role: "button",
    tabIndex: 0,
    onMouseEnter: function onMouseEnter() {
      setPosition();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === KEYBOARD_KEYS.ENTER) {
        setOpen(!isOpen);
      }
    }
  }, React__default.createElement(Label, {
    onClick: function onClick() {
      return setOpen(!isOpen);
    },
    isOpen: isOpen
  }, React__default.createElement(BodyText, {
    variant: "body2",
    color: colors.blue[500]
  }, value, " per page"), React__default.createElement(IconContainer$4, {
    animate: {
      rotate: isOpen ? 180 : 0
    }
  }, React__default.createElement(Icon, {
    type: "caret-down",
    fill: transparentize(0.3, colors.blue[500]),
    width: 10,
    height: 10
  }))), React__default.createElement(DynamicPortal, null, React__default.createElement(AnimatePresence, null, isOpen && React__default.createElement(List, Object.assign({}, listMotion, {
    x: x,
    y: y,
    width: width
  }), PER_PAGE_OPTIONS.map(function (option) {
    return React__default.createElement(ListItem$1, {
      key: "".concat(option, "-per-page"),
      isActive: option === PER_PAGE_OPTIONS[selectionIndex],
      whileHover: {
        backgroundColor: transparentize(0.85, colors.blue[100])
      },
      onClick: function onClick() {
        setOpen(false);
        onChange(option);
      }
    }, React__default.createElement(BodyText, {
      variant: "body2",
      color: colors.blue[500]
    }, option, " per page"));
  })))));
};

var OVERFLOW_PATTERN = '...';
var createPagination = function createPagination(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages;
  var paginationPagesLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;

  if (totalPages < paginationPagesLimit) {
    return new Array(totalPages).fill(true).map(function (_, idx) {
      return idx + 1;
    });
  }

  var visiblePages = paginationPagesLimit - 1;
  var middlePage = Math.round(visiblePages / 2);
  var isWithinEndRange = currentPage > totalPages - middlePage;
  var isWithinStartRange = currentPage <= middlePage;

  if (isWithinEndRange) {
    return [1, OVERFLOW_PATTERN].concat(_toConsumableArray(new Array(visiblePages - 2).fill(totalPages).map(function (page, idx) {
      return page - idx;
    }).reverse()));
  }

  if (isWithinStartRange) {
    return [].concat(_toConsumableArray(new Array(visiblePages - 2).fill(true).map(function (_, idx) {
      return idx + 1;
    })), [OVERFLOW_PATTERN, totalPages]);
  }

  var values = new Array(visiblePages).fill(currentPage).map(function (_, idx) {
    if (idx + 1 === middlePage) return currentPage;
    return currentPage - middlePage + idx + 1;
  });
  return [1, OVERFLOW_PATTERN].concat(_toConsumableArray(values.slice(2, values.length - 2)), [OVERFLOW_PATTERN, totalPages]);
};

var Container$g = styled.div.withConfig({
  displayName: "paginationstyles__Container",
  componentId: "keen-ui-core__sc-a7r74t-0"
})(["&&&{display:flex;flex-wrap:nowrap;align-items:baseline;gap:10px;}"]);
var PageNumber = styled(motion.div).withConfig({
  displayName: "paginationstyles__PageNumber",
  componentId: "keen-ui-core__sc-a7r74t-1"
})(["&&&{display:inline-flex;align-items:center;justify-content:center;padding:5px;border-radius:1rem;color:", ";font-family:'Lato',sans-serif;font-size:14px;line-height:1;min-width:27px;height:27px;cursor:pointer;box-sizing:border-box;transition:background-color 150ms ease-in-out;", ";}&&&:hover{background-color:", ";}&&&:focus-visible{outline:1px solid ", ";}"], colors.blue[500], function (_ref) {
  var isActive = _ref.isActive;
  return isActive && css(["background-color:", ";color:", ";&:hover{background-color:", ";}"], colors.blue[500], colors.white[500], colors.blue[500]);
}, transparentize(0.9, colors.blue[500]), colors.lightBlue[500]);
var IconContainer$3 = styled.div.withConfig({
  displayName: "paginationstyles__IconContainer",
  componentId: "keen-ui-core__sc-a7r74t-2"
})(["&&&{display:flex;cursor:", ";}&&&:focus-visible{outline:1px solid ", ";}"], function (_ref2) {
  var isDisabled = _ref2.isDisabled;
  return isDisabled ? 'not-allowed' : 'pointer';
}, colors.lightBlue[500]);
var PaginationText = styled.div.withConfig({
  displayName: "paginationstyles__PaginationText",
  componentId: "keen-ui-core__sc-a7r74t-3"
})(["&&&{min-width:27px;text-align:center;}"]);

var Pagination = function Pagination(_ref) {
  var _ref$page = _ref.page,
      page = _ref$page === void 0 ? 1 : _ref$page,
      totalPages = _ref.totalPages,
      onChange = _ref.onChange;
  var items = useMemo(function () {
    return createPagination({
      currentPage: page,
      totalPages: totalPages
    });
  }, [page, totalPages]);
  return React__default.createElement(Container$g, null, React__default.createElement(IconContainer$3, {
    onClick: function onClick() {
      return page === 1 ? null : onChange(page - 1);
    },
    onKeyDown: function onKeyDown(e) {
      if (page !== 1 && e.keyCode === KEYBOARD_KEYS.ENTER) {
        onChange(page - 1);
      }
    },
    role: "button",
    tabIndex: 0,
    "data-testid": "prev-btn",
    isDisabled: page === 1
  }, React__default.createElement(Icon, {
    width: 11,
    height: 11,
    fill: colors.blue[500],
    type: "caret-left",
    opacity: page === 1 ? 0.5 : 1
  })), items.map(function (item, idx) {
    return React__default.createElement(React__default.Fragment, {
      key: "page-".concat(idx, "-").concat(item)
    }, typeof item === 'number' ? React__default.createElement(PageNumber, {
      isActive: item === page,
      onClick: function onClick() {
        return item === page ? null : onChange(item);
      },
      onKeyDown: function onKeyDown(e) {
        if (item !== page && e.keyCode === KEYBOARD_KEYS.ENTER) onChange(item);
      },
      role: "button",
      tabIndex: 0
    }, item) : React__default.createElement(PaginationText, null, React__default.createElement(BodyText, {
      variant: "body2",
      color: colors.blue[500]
    }, item)));
  }), React__default.createElement(IconContainer$3, {
    onClick: function onClick() {
      return page === totalPages ? null : onChange(page + 1);
    },
    onKeyDown: function onKeyDown(e) {
      if (page !== totalPages && e.keyCode === KEYBOARD_KEYS.ENTER) {
        onChange(page + 1);
      }
    },
    role: "button",
    tabIndex: 0,
    "data-testid": "next-btn",
    isDisabled: page === totalPages
  }, React__default.createElement(Icon, {
    width: 11,
    height: 11,
    fill: colors.blue[500],
    type: "caret-right",
    opacity: page === totalPages ? 0.5 : 1
  })));
};

var SUB_CONTAINER_WIDTH = 120;
var Container$f = styled.div.withConfig({
  displayName: "table-footerstyles__Container",
  componentId: "keen-ui-core__sc-2iovg1-0"
})(["&&&{padding:10px 20px;background-color:", ";border-top:1px solid ", ";display:flex;align-items:center;justify-content:space-between;gap:15px 10px;", ";}"], colors.white[500], transparentize(0.5, colors.gray[400]), function (_ref) {
  var isCompactView = _ref.isCompactView;
  return isCompactView && css(["flex-wrap:wrap;justify-content:center;"]);
});
var PaginationContainer = styled.div.withConfig({
  displayName: "table-footerstyles__PaginationContainer",
  componentId: "keen-ui-core__sc-2iovg1-1"
})(["&&&{margin:auto;", ";}"], function (_ref2) {
  var isCompactView = _ref2.isCompactView;
  return isCompactView && css(["display:flex;width:100%;justify-content:center;order:-1;"]);
});
var RowsContainer = styled.div.withConfig({
  displayName: "table-footerstyles__RowsContainer",
  componentId: "keen-ui-core__sc-2iovg1-2"
})(["&&&{width:", ";flex-shrink:0;}"], function (_ref3) {
  var isCompactView = _ref3.isCompactView;
  return isCompactView ? 'auto' : "".concat(SUB_CONTAINER_WIDTH, "px");
});
var PerPageContainer = styled.div.withConfig({
  displayName: "table-footerstyles__PerPageContainer",
  componentId: "keen-ui-core__sc-2iovg1-3"
})(["&&&{width:", ";display:flex;justify-content:flex-end;}"], function (_ref4) {
  var isCompactView = _ref4.isCompactView;
  return isCompactView ? 'auto' : "".concat(SUB_CONTAINER_WIDTH, "px");
});

var TableFooter = function TableFooter(_ref) {
  var rows = _ref.rows,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? 1 : _ref$page,
      totalPages = _ref.totalPages,
      itemsPerPage = _ref.itemsPerPage,
      onPageChange = _ref.onPageChange,
      onItemsPerPageChange = _ref.onItemsPerPageChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isCompactView = _useState2[0],
      setCompactView = _useState2[1];

  return React__default.createElement(Measure, {
    bounds: true,
    onResize: function onResize(_ref2) {
      var width = _ref2.bounds.width;
      setCompactView(width <= COMPACT_VIEW);
    }
  }, function (_ref3) {
    var measureRef = _ref3.measureRef;
    return React__default.createElement(Container$f, {
      isCompactView: isCompactView && totalPages > 1,
      role: "rowgroup",
      ref: measureRef
    }, React__default.createElement(RowsContainer, {
      isCompactView: isCompactView
    }, React__default.createElement(BodyText, {
      variant: "body2",
      color: transparentize(0.5, colors.black[500]),
      enableTextEllipsis: true
    }, rows.toLocaleString('en-US'), " rows")), totalPages > 1 && React__default.createElement(PaginationContainer, {
      isCompactView: isCompactView,
      "data-testid": "pagination"
    }, React__default.createElement(Pagination, {
      page: page,
      totalPages: totalPages,
      onChange: onPageChange
    })), React__default.createElement(PerPageContainer, {
      isCompactView: isCompactView,
      "data-testid": "rows-per-page"
    }, React__default.createElement(ItemsPerPage, {
      value: itemsPerPage,
      onChange: function onChange(option) {
        return onItemsPerPageChange(option);
      }
    })));
  });
};

var Brand = function Brand(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 180 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 50 : _ref$height;
  return React__default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 714 200",
    version: "1.1"
  }, React__default.createElement("g", {
    fill: "#1E485F",
    fillRule: "evenodd"
  }, React__default.createElement("polygon", {
    points: "96 115 107.308 133.914 79.038 181.2 225.808 181.2 237 200 45 200"
  }), React__default.createElement("polygon", {
    points: "0 200 22.437 200 96.111 75.496 124.331 123.355 147 123.355 96.228 37"
  }), React__default.createElement("polygon", {
    points: "118.172 0 107 18.972 180.138 143.797 123.816 143.797 112.53 163 214 163 118.173 0"
  }), React__default.createElement("path", {
    fillRule: "nonzero",
    d: "M300.365718 181.276477L303.81454 173.645485 319.645881 173.645485 323.053151 181.276477 326.585077 181.276477 313.329965 152.19621 310.255112 152.19621 297 181.276477 300.365718 181.276477zM318.357766 170.716834L305.102655 170.716834 311.750986 155.991081 318.357766 170.716834zM356.901471 181.77146C362.178584 181.77146 365.50275 179.750279 368.536052 176.697882L366.375344 174.594203C363.591355 177.234114 360.973574 178.760312 356.984575 178.760312 350.585555 178.760312 345.723963 173.521739 345.723963 166.839465L345.723963 166.756968C345.723963 160.115942 350.544003 154.918618 356.984575 154.918618 360.932022 154.918618 363.674459 156.568562 366.126031 158.878484L368.369843 156.486065C365.461198 153.763657 362.30324 151.907469 357.026127 151.907469 348.4664 151.907469 342.316693 158.672241 342.316693 166.839465L342.316693 166.921962C342.316693 175.212932 348.507952 181.77146 356.901471 181.77146zM376.339531 181.276477L376.339531 169.06689C376.339531 165.065775 379.081968 162.384615 382.780103 162.384615 386.561342 162.384615 388.72205 164.859532 388.72205 168.819398L388.72205 181.276477 391.921559 181.276477 391.921559 168.035674C391.921559 162.962096 388.888258 159.497213 383.694248 159.497213 379.996114 159.497213 377.752302 161.3534 376.339531 163.663322L376.339531 151.164994 373.140022 151.164994 373.140022 181.276477 376.339531 181.276477zM404.54508 181.730212C408.326318 181.730212 410.777891 179.99777 412.273765 178.100334L412.273765 181.276477 415.431723 181.276477 415.431723 168.241918C415.431723 165.519509 414.683786 163.457079 413.187911 161.972129 411.650484 160.445931 409.282016 159.620959 406.248715 159.620959 403.090757 159.620959 400.805393 160.363434 398.436925 161.435897L399.392622 164.03456C401.387122 163.12709 403.381621 162.508361 405.916298 162.508361 409.946849 162.508361 412.273765 164.488294 412.273765 168.283166L412.273765 168.943144C410.36237 168.406912 408.450975 168.035674 405.708538 168.035674 400.265216 168.035674 396.525529 170.428094 396.525529 175.006689L396.525529 175.089186C396.525529 179.461538 400.514528 181.730212 404.54508 181.730212zM405.168361 179.172798C402.259715 179.172798 399.766591 177.605351 399.766591 174.924192L399.766591 174.841695C399.766591 172.284281 402.051955 170.551839 406.040954 170.551839 408.658735 170.551839 410.736339 171.005574 412.315317 171.459309L412.315317 173.439242C412.315317 176.821628 409.115808 179.172798 405.168361 179.172798zM424.814182 181.276477L424.814182 172.779264C424.814182 166.344482 428.636972 163.003344 433.332357 163.003344L433.581669 163.003344 433.581669 159.57971C429.509566 159.414716 426.39316 161.972129 424.814182 165.519509L424.814182 159.950948 421.614672 159.950948 421.614672 181.276477 424.814182 181.276477zM446.496054 187.958751C449.903324 187.958751 452.770417 187.010033 454.681813 185.112598 456.427 183.380156 457.42425 180.863991 457.42425 177.564103L457.42425 159.950948 454.22474 159.950948 454.22474 163.787068C452.479553 161.477146 449.861772 159.497213 445.831221 159.497213 440.720316 159.497213 435.734067 163.333333 435.734067 169.561873L435.734067 169.64437C435.734067 175.790412 440.678764 179.626533 445.831221 179.626533 449.778668 179.626533 452.396449 177.605351 454.266292 175.130435L454.266292 177.6466C454.266292 182.637681 451.191438 185.236343 446.454502 185.236343 443.379648 185.236343 440.637212 184.287625 438.185639 182.513935L436.731317 184.988852C439.59841 186.968785 442.922576 187.958751 446.496054 187.958751zM446.454502 176.821628C442.465503 176.821628 439.016681 173.851728 439.016681 169.561873L439.016681 169.479376C439.016681 165.107023 442.382399 162.302118 446.454502 162.302118 450.526605 162.302118 454.349396 165.148272 454.349396 169.520624L454.349396 169.603122C454.349396 173.892977 450.526605 176.821628 446.454502 176.821628zM467.720854 155.289855L467.720854 151.783724 464.064271 151.783724 464.064271 155.289855 467.720854 155.289855zM467.471541 181.276477L467.471541 159.950948 464.272032 159.950948 464.272032 181.276477 467.471541 181.276477zM478.723843 181.276477L478.723843 162.755853 485.496831 162.755853 485.496831 160.033445 478.682291 160.033445 478.682291 158.301003C478.682291 155.248606 479.928853 153.763657 482.421978 153.763657 483.502332 153.763657 484.374925 153.9699 485.538383 154.299889L485.538383 151.536232C484.499581 151.164994 483.502332 151 482.006457 151 480.05351 151 478.474531 151.57748 477.394177 152.649944 476.189167 153.846154 475.524333 155.702341 475.524333 158.136009L475.524333 159.992196 472.574136 159.992196 472.574136 162.755853 475.524333 162.755853 475.524333 181.276477 478.723843 181.276477zM492.303061 188C495.544123 188 497.621727 186.391304 499.450018 181.977703L508.466818 159.950948 505.059548 159.950948 498.161904 177.729097 490.350114 159.950948 486.818187 159.950948 496.582925 181.19398C495.29481 184.205128 494.0898 185.195095 492.178405 185.195095 490.807186 185.195095 489.851489 184.947603 488.812687 184.411371L487.732333 186.927536C489.186656 187.628763 490.516322 188 492.303061 188zM538.658556 181.77146C543.935669 181.77146 547.259835 179.750279 550.293136 176.697882L548.132429 174.594203C545.34844 177.234114 542.730659 178.760312 538.74166 178.760312 532.34264 178.760312 527.481047 173.521739 527.481047 166.839465L527.481047 166.756968C527.481047 160.115942 532.301088 154.918618 538.74166 154.918618 542.689107 154.918618 545.431544 156.568562 547.883116 158.878484L550.126928 156.486065C547.218283 153.763657 544.060325 151.907469 538.783212 151.907469 530.223484 151.907469 524.073777 158.672241 524.073777 166.839465L524.073777 166.921962C524.073777 175.212932 530.265036 181.77146 538.658556 181.77146zM564.287875 181.77146C570.769999 181.77146 575.548487 176.656633 575.548487 170.634337L575.548487 170.551839C575.548487 164.529543 570.811551 159.497213 564.370979 159.497213 557.888856 159.497213 553.151919 164.61204 553.151919 170.634337L553.151919 170.716834C553.151919 176.73913 557.847304 181.77146 564.287875 181.77146zM564.370979 178.925307C559.841803 178.925307 556.434533 175.212932 556.434533 170.634337L556.434533 170.551839C556.434533 166.055741 559.634043 162.302118 564.287875 162.302118 568.817051 162.302118 572.265873 166.055741 572.265873 170.634337L572.265873 170.716834C572.265873 175.212932 569.024812 178.925307 564.370979 178.925307zM583.933696 181.276477L583.933696 169.108138C583.933696 165.189521 586.509925 162.384615 589.917195 162.384615 593.324465 162.384615 595.443621 164.735786 595.443621 168.736901L595.443621 181.276477 598.601578 181.276477 598.601578 168.984392C598.601578 164.777035 601.302463 162.384615 604.543525 162.384615 608.033899 162.384615 610.111503 164.694537 610.111503 168.819398L610.111503 181.276477 613.311013 181.276477 613.311013 168.076923C613.311013 162.797101 610.277711 159.497213 605.333014 159.497213 601.593328 159.497213 599.307964 161.394649 597.770537 163.745819 596.607079 161.3534 594.363267 159.497213 590.872893 159.497213 587.257862 159.497213 585.346467 161.435897 583.933696 163.539576L583.933696 159.950948 580.734186 159.950948 580.734186 181.276477 583.933696 181.276477zM622.85968 187.876254L622.85968 177.192865C624.521763 179.585284 627.097991 181.730212 631.08699 181.730212 636.281 181.730212 641.350353 177.605351 641.350353 170.634337L641.350353 170.551839C641.350353 163.539576 636.239448 159.497213 631.08699 159.497213 627.139543 159.497213 624.604867 161.683389 622.85968 164.240803L622.85968 159.950948 619.66017 159.950948 619.66017 187.876254 622.85968 187.876254zM630.505261 178.884058C626.516262 178.884058 622.735023 175.584169 622.735023 170.634337L622.735023 170.551839C622.735023 165.684504 626.516262 162.343367 630.505261 162.343367 634.577365 162.343367 638.067739 165.560758 638.067739 170.593088L638.067739 170.675585C638.067739 175.831661 634.660469 178.884058 630.505261 178.884058zM653.059727 181.730212C656.840966 181.730212 659.292539 179.99777 660.788413 178.100334L660.788413 181.276477 663.946371 181.276477 663.946371 168.241918C663.946371 165.519509 663.198434 163.457079 661.702559 161.972129 660.165132 160.445931 657.796664 159.620959 654.763362 159.620959 651.605405 159.620959 649.320041 160.363434 646.951572 161.435897L647.90727 164.03456C649.90177 163.12709 651.896269 162.508361 654.430946 162.508361 658.461497 162.508361 660.788413 164.488294 660.788413 168.283166L660.788413 168.943144C658.877018 168.406912 656.965622 168.035674 654.223185 168.035674 648.779864 168.035674 645.040177 170.428094 645.040177 175.006689L645.040177 175.089186C645.040177 179.461538 649.029176 181.730212 653.059727 181.730212zM653.683008 179.172798C650.774363 179.172798 648.281239 177.605351 648.281239 174.924192L648.281239 174.841695C648.281239 172.284281 650.566603 170.551839 654.555602 170.551839 657.173383 170.551839 659.250986 171.005574 660.829965 171.459309L660.829965 173.439242C660.829965 176.821628 657.630456 179.172798 653.683008 179.172798zM673.328829 181.276477L673.328829 169.06689C673.328829 165.065775 676.071266 162.384615 679.769401 162.384615 683.55064 162.384615 685.711348 164.859532 685.711348 168.819398L685.711348 181.276477 688.910857 181.276477 688.910857 168.035674C688.910857 162.962096 685.877556 159.497213 680.683547 159.497213 676.985412 159.497213 674.7416 161.3534 673.328829 163.663322L673.328829 159.950948 670.12932 159.950948 670.12932 181.276477 673.328829 181.276477zM697.836243 188C701.077305 188 703.154909 186.391304 704.9832 181.977703L714 159.950948 710.59273 159.950948 703.695085 177.729097 695.883295 159.950948 692.351369 159.950948 702.116107 181.19398C700.827992 184.205128 699.622982 185.195095 697.711587 185.195095 696.340368 185.195095 695.384671 184.947603 694.345869 184.411371L693.265515 186.927536C694.719837 187.628763 696.049504 188 697.836243 188zM309.944769 109.5L309.944769 86 328.701357 67.125 362.563924 109.5 375.026355 109.5 335.62493 60.25 373.389874 22 360.549793 22 309.944769 74.25 309.944769 22 300 22 300 109.5 309.944769 109.5zM413.492318 111C425.828867 111 433.759505 106.125 440.305428 98.875L434.263037 93.5C428.975945 99 422.681788 102.625 413.744085 102.625 402.288718 102.625 392.218066 94.75 390.833352 81.125L442.445442 81.125C442.571325 79.625 442.571325 78.625 442.571325 77.75 442.571325 58.75 431.493608 43.5 412.233487 43.5 394.232197 43.5 381.014466 58.5 381.014466 77.25 381.014466 97.375 395.616911 111 413.492318 111zM432.75244 73.375L390.833352 73.375C392.218066 60.875 400.77812 51.625 411.98172 51.625 424.821801 51.625 431.619491 61.625 432.75244 73.375zM493.134658 111C505.471207 111 513.401845 106.125 519.947769 98.875L513.905378 93.5C508.618285 99 502.324128 102.625 493.386425 102.625 481.931058 102.625 471.860407 94.75 470.475692 81.125L522.087782 81.125C522.213665 79.625 522.213665 78.625 522.213665 77.75 522.213665 58.75 511.135948 43.5 491.875827 43.5 473.874537 43.5 460.656807 58.5 460.656807 77.25 460.656807 97.375 475.259252 111 493.134658 111zM512.39478 73.375L470.475692 73.375C471.860407 60.875 480.420461 51.625 491.624061 51.625 504.464142 51.625 511.261831 61.625 512.39478 73.375zM553.79382 109.5L553.79382 72.5C553.79382 60.375 562.102108 52.25 573.305708 52.25 584.761074 52.25 591.306998 59.75 591.306998 71.75L591.306998 109.5 601 109.5 601 69.375C601 54 591.81053 43.5 576.075137 43.5 564.871537 43.5 558.073847 49.125 553.79382 56.125L553.79382 44.875 544.100818 44.875 544.100818 109.5 553.79382 109.5z"
  })));
};

var Container$e = styled.div.withConfig({
  displayName: "modal-contentstyles__Container",
  componentId: "keen-ui-core__sc-11bg2l-0"
})(["&&&{width:500px;}"]);
var Description = styled.div.withConfig({
  displayName: "modal-contentstyles__Description",
  componentId: "keen-ui-core__sc-11bg2l-1"
})(["&&&{margin:20px 0;font-family:'Lato Regular',sans-serif;font-size:16px;line-height:24px;color:", ";}"], colors.black['500']);
var Close$1 = styled.div.withConfig({
  displayName: "modal-contentstyles__Close",
  componentId: "keen-ui-core__sc-11bg2l-2"
})(["&&&{display:flex;align-items:center;cursor:pointer;}"]);
var Footer = styled.div.withConfig({
  displayName: "modal-contentstyles__Footer",
  componentId: "keen-ui-core__sc-11bg2l-3"
})(["&&&{display:flex;}&&& button{margin-right:25px;}"]);

var ModalContent = function ModalContent(_ref) {
  var children = _ref.children,
      onCancel = _ref.onCancel,
      onConfirm = _ref.onConfirm,
      _ref$confirmText = _ref.confirmText,
      confirmText = _ref$confirmText === void 0 ? 'Confirm' : _ref$confirmText,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText;
  return React__default.createElement(Container$e, null, children && React__default.createElement(Description, null, children), React__default.createElement(Footer, null, onConfirm && React__default.createElement(Button, {
    variant: "secondary",
    onClick: onConfirm
  }, confirmText), React__default.createElement(Close$1, null, React__default.createElement(Anchor, {
    onClick: onCancel
  }, cancelText))));
};

var Container$d = styled.div.withConfig({
  displayName: "modal-headerstyles__Container",
  componentId: "keen-ui-core__sc-1a831zk-0"
})(["&&&{padding:0 25px;height:50px;box-sizing:border-box;border-bottom:solid 1px ", ";display:flex;align-items:center;justify-content:space-between;}"], colors.gray[400]);
var Close = styled.div.withConfig({
  displayName: "modal-headerstyles__Close",
  componentId: "keen-ui-core__sc-1a831zk-1"
})(["&&&{display:flex;align-items:center;cursor:pointer;margin-left:10px;}"]);
var Title$2 = styled.div.withConfig({
  displayName: "modal-headerstyles__Title",
  componentId: "keen-ui-core__sc-1a831zk-2"
})(["&&&{font-family:'Gangster Grotesk Bold',sans-serif;font-size:20px;line-height:24px;color:", ";}"], colors.blue[500]);

var ModalHeader = function ModalHeader(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose;
  return React__default.createElement(Container$d, null, React__default.createElement(Title$2, null, children), onClose && React__default.createElement(Close, {
    onClick: onClose,
    "data-testid": "modal-close"
  }, React__default.createElement(Icon, {
    type: "close",
    width: 16,
    height: 16,
    fill: colors.gray[500]
  })));
};

var ModalFooter = styled.div.withConfig({
  displayName: "modal-footerstyles__ModalFooter",
  componentId: "keen-ui-core__sc-i5xq3o-0"
})(["&&&{border-top:solid 1px ", ";padding:10px 25px;}"], colors.gray[400]);

var Portal = /*#__PURE__*/function (_React$Component) {
  _inherits(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal(props) {
    var _this;

    _classCallCheck(this, Portal);

    _this = _super.call(this, props);
    _this.element = document.createElement('div');
    _this.modalRoot = document.querySelector(_this.props.modalContainer);
    return _this;
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.modalRoot.appendChild(this.element);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.modalRoot.removeChild(this.element);
    }
  }, {
    key: "render",
    value: function render() {
      return ReactDOM.createPortal(this.props.children, this.element);
    }
  }]);

  return Portal;
}(React__default.Component);

var TooltipWrapper = styled.div.withConfig({
  displayName: "mouse-positioned-tooltipstyles__TooltipWrapper",
  componentId: "keen-ui-core__sc-1tqlpq7-0"
})(["&&&{", ";}"], function (props) {
  return css(["transform:translate(", ",", ");"], props.translateX, props.translateY);
});

var getTooltipTranslation = function getTooltipTranslation(position) {
  switch (position) {
    case 'top-left':
      return {
        x: '-100%',
        y: '-100%'
      };

    case 'top-right':
      return {
        x: '0',
        y: '-100%'
      };

    case 'bottom-left':
      return {
        x: '-100%',
        y: '0'
      };

    case 'bottom-right':
      return {
        x: '0',
        y: '0'
      };
  }
};

var TOOLTIP_MOTION$1 = {
  transition: {
    duration: 0.3
  },
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
};

var TooltipContent = function TooltipContent(_ref) {
  var tooltipPosition = _ref.tooltipPosition,
      children = _ref.children,
      tooltipVisible = _ref.tooltipVisible,
      tooltipTheme = _ref.tooltipTheme,
      tooltipPinPlacement = _ref.tooltipPinPlacement,
      maxContentWidth = _ref.maxContentWidth;
  var tooltipTranslation = getTooltipTranslation(tooltipPinPlacement);
  return React__default.createElement(AnimatePresence, null, tooltipVisible && React__default.createElement(motion.div, Object.assign({}, TOOLTIP_MOTION$1, {
    initial: {
      opacity: 0,
      x: tooltipPosition.x,
      y: tooltipPosition.y,
      top: 0,
      left: 0
    },
    animate: {
      x: tooltipPosition.x,
      y: tooltipPosition.y,
      opacity: 1
    },
    style: {
      position: 'absolute',
      pointerEvents: 'none',
      zIndex: UI_LAYERS.tooltip,
      maxWidth: maxContentWidth
    }
  }), React__default.createElement(TooltipWrapper, {
    translateX: tooltipTranslation.x,
    translateY: tooltipTranslation.y
  }, React__default.createElement(Tooltip, {
    hasArrow: false,
    mode: tooltipTheme
  }, children))));
};

var MousePositionedTooltip = function MousePositionedTooltip(_ref2) {
  var children = _ref2.children,
      isActive = _ref2.isActive,
      tooltipPortal = _ref2.tooltipPortal,
      _ref2$tooltipTheme = _ref2.tooltipTheme,
      tooltipTheme = _ref2$tooltipTheme === void 0 ? 'light' : _ref2$tooltipTheme,
      _ref2$tooltipPinPlace = _ref2.tooltipPinPlacement,
      tooltipPinPlacement = _ref2$tooltipPinPlace === void 0 ? 'bottom-right' : _ref2$tooltipPinPlace,
      renderContent = _ref2.renderContent,
      onHideTooltip = _ref2.onHideTooltip,
      _ref2$maxContentWidth = _ref2.maxContentWidth,
      maxContentWidth = _ref2$maxContentWidth === void 0 ? 255 : _ref2$maxContentWidth;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      tooltipVisible = _useState2[0],
      setTooltipVisible = _useState2[1];

  var _useState3 = useState({
    x: 0,
    y: 0
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      tooltipPosition = _useState4[0],
      setTooltipPosition = _useState4[1];

  var tooltipContainerRef = useRef(null);
  var requestFrameRef = React__default.useRef(null);
  var calculateTooltipPosition = useCallback(function (e) {
    return {
      x: e.clientX,
      y: e.clientY + window.scrollY
    };
  }, [tooltipPortal]);
  var hideTooltip = useCallback(function () {
    setTooltipVisible(false);
    if (onHideTooltip) onHideTooltip();
  }, [onHideTooltip]);
  return React__default.createElement("div", Object.assign({
    ref: tooltipContainerRef
  }, isActive ? {
    onMouseEnter: function onMouseEnter(e) {
      e.persist();
      setTooltipVisible(true);
      setTooltipPosition(calculateTooltipPosition(e));
    },
    onMouseMove: function onMouseMove(e) {
      e.persist();
      if (requestFrameRef.current) cancelAnimationFrame(requestFrameRef.current);
      requestFrameRef.current = requestAnimationFrame(function () {
        setTooltipPosition(calculateTooltipPosition(e));
      });
    },
    onMouseLeave: function onMouseLeave() {
      hideTooltip();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === KEYBOARD_KEYS.ENTER) {
        var _e$currentTarget$getB = e.currentTarget.getBoundingClientRect(),
            x = _e$currentTarget$getB.x,
            y = _e$currentTarget$getB.y,
            width = _e$currentTarget$getB.width;

        setTooltipPosition({
          x: x + width,
          y: y
        });
        setTooltipVisible(true);
      }

      if (e.keyCode === KEYBOARD_KEYS.ESCAPE) hideTooltip();
    },
    onBlur: function onBlur() {
      return hideTooltip();
    }
  } : {}), children, isActive && React__default.createElement(React__default.Fragment, null, tooltipPortal ? React__default.createElement(Portal, {
    modalContainer: tooltipPortal
  }, React__default.createElement(TooltipContent, {
    maxContentWidth: maxContentWidth,
    tooltipPosition: tooltipPosition,
    tooltipVisible: tooltipVisible,
    tooltipTheme: tooltipTheme,
    tooltipPinPlacement: tooltipPinPlacement
  }, renderContent())) : tooltipVisible && React__default.createElement(DynamicPortal, null, React__default.createElement(TooltipContent, {
    maxContentWidth: maxContentWidth,
    tooltipPosition: tooltipPosition,
    tooltipVisible: true,
    tooltipTheme: tooltipTheme,
    tooltipPinPlacement: tooltipPinPlacement
  }, renderContent()))));
};

var Container$c = styled.div.withConfig({
  displayName: "loading-screenstyles__Container",
  componentId: "keen-ui-core__sc-5i5fe3-0"
})(["&&&{display:flex;align-items:center;flex-direction:column;}"]);
var Heading$2 = styled.div.withConfig({
  displayName: "loading-screenstyles__Heading",
  componentId: "keen-ui-core__sc-5i5fe3-1"
})(["&&&{margin:20px 0 10px 0;}"]);

var LoadingScreen = function LoadingScreen(_ref) {
  var title = _ref.title;
  return React__default.createElement(Container$c, null, React__default.createElement(Loader, {
    width: 90,
    height: 90,
    fill: colors.blue['500']
  }), title && React__default.createElement(Heading$2, null, React__default.createElement(Title$3, {
    variant: "h3",
    color: colors.black['500']
  }, title)));
};

var Container$b = styled.div.withConfig({
  displayName: "success-notificationstyles__Container",
  componentId: "keen-ui-core__sc-nzwwyp-0"
})(["&&&{display:flex;align-items:center;flex-direction:column;text-align:center;}"]);
var Heading$1 = styled.div.withConfig({
  displayName: "success-notificationstyles__Heading",
  componentId: "keen-ui-core__sc-nzwwyp-1"
})(["&&&{margin:20px 0 10px 0;}&&& h3{line-height:30px;}"]);

var iconMotion$1 = {
  initial: {
    opacity: 0,
    scale: 0.3
  },
  animate: {
    opacity: 1,
    scale: 1
  },
  exit: {
    opacity: 0
  },
  transition: {
    delay: 0.4,
    ease: 'easeInOut'
  }
};

var SuccessNotification = function SuccessNotification(_ref) {
  var children = _ref.children;
  return React__default.createElement(Container$b, null, React__default.createElement(AnimatePresence, null, React__default.createElement(motion.div, Object.assign({}, iconMotion$1), React__default.createElement(Icon, {
    type: "check",
    width: 55,
    height: 55,
    fill: colors.green['400']
  }))), children && React__default.createElement(Heading$1, null, React__default.createElement(Title$3, {
    variant: "h3",
    color: colors.green['400']
  }, children)));
};

var GitHubIcon = function GitHubIcon() {
  return React__default.createElement("svg", {
    width: "21px",
    height: "21px",
    viewBox: "0 0 33 33",
    version: "1.1"
  }, React__default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    id: "GitHub-Mark",
    transform: "translate(-136.000000, -55.000000)",
    fill: "#161514"
  }, React__default.createElement("path", {
    d: "M152.608,55.455 C143.614,55.455 136.32,62.748 136.32,71.745 C136.32,78.942 140.987,85.047 147.46,87.201 C148.275,87.351 148.572,86.848 148.572,86.416 C148.572,86.03 148.558,85.005 148.55,83.646 C144.019,84.63 143.063,81.462 143.063,81.462 C142.322,79.58 141.254,79.079 141.254,79.079 C139.775,78.069 141.366,78.089 141.366,78.089 C143.001,78.204 143.861,79.768 143.861,79.768 C145.314,82.257 147.674,81.538 148.602,81.121 C148.75,80.069 149.171,79.351 149.636,78.944 C146.019,78.533 142.216,77.135 142.216,70.893 C142.216,69.115 142.851,67.66 143.893,66.522 C143.725,66.11 143.166,64.453 144.053,62.211 C144.053,62.211 145.42,61.773 148.532,63.881 C149.831,63.519 151.225,63.339 152.61,63.332 C153.994,63.339 155.387,63.519 156.688,63.881 C159.798,61.773 161.163,62.211 161.163,62.211 C162.052,64.453 161.493,66.11 161.326,66.522 C162.37,67.66 163,69.115 163,70.893 C163,77.151 159.191,78.528 155.563,78.931 C156.147,79.434 156.668,80.428 156.668,81.948 C156.668,84.125 156.648,85.882 156.648,86.416 C156.648,86.852 156.942,87.359 157.768,87.2 C164.236,85.041 168.899,78.94 168.899,71.745 C168.899,62.748 161.605,55.455 152.608,55.455",
    id: "Fill-4"
  }))));
};

var GoogleIcon = function GoogleIcon() {
  return React__default.createElement("svg", {
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    version: "1.1"
  }, React__default.createElement("g", {
    id: "Google-Button",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    id: "btn_google_light_normal",
    transform: "translate(-15.000000, -15.000000)"
  }, React__default.createElement("g", {
    id: "logo_googleg_48dp",
    transform: "translate(15.000000, 15.000000)"
  }, React__default.createElement("path", {
    d: "M17.64,9.20454545 C17.64,8.56636364 17.5827273,7.95272727 17.4763636,7.36363636 L9,7.36363636 L9,10.845 L13.8436364,10.845 C13.635,11.97 13.0009091,12.9231818 12.0477273,13.5613636 L12.0477273,15.8195455 L14.9563636,15.8195455 C16.6581818,14.2527273 17.64,11.9454545 17.64,9.20454545 L17.64,9.20454545 Z",
    id: "Shape",
    fill: "#4285F4"
  }), React__default.createElement("path", {
    d: "M9,18 C11.43,18 13.4672727,17.1940909 14.9563636,15.8195455 L12.0477273,13.5613636 C11.2418182,14.1013636 10.2109091,14.4204545 9,14.4204545 C6.65590909,14.4204545 4.67181818,12.8372727 3.96409091,10.71 L0.957272727,10.71 L0.957272727,13.0418182 C2.43818182,15.9831818 5.48181818,18 9,18 L9,18 Z",
    id: "Shape",
    fill: "#34A853"
  }), React__default.createElement("path", {
    d: "M3.96409091,10.71 C3.78409091,10.17 3.68181818,9.59318182 3.68181818,9 C3.68181818,8.40681818 3.78409091,7.83 3.96409091,7.29 L3.96409091,4.95818182 L0.957272727,4.95818182 C0.347727273,6.17318182 0,7.54772727 0,9 C0,10.4522727 0.347727273,11.8268182 0.957272727,13.0418182 L3.96409091,10.71 L3.96409091,10.71 Z",
    id: "Shape",
    fill: "#FBBC05"
  }), React__default.createElement("path", {
    d: "M9,3.57954545 C10.3213636,3.57954545 11.5077273,4.03363636 12.4404545,4.92545455 L15.0218182,2.34409091 C13.4631818,0.891818182 11.4259091,0 9,0 C5.48181818,0 2.43818182,2.01681818 0.957272727,4.95818182 L3.96409091,7.29 C4.67181818,5.16272727 6.65590909,3.57954545 9,3.57954545 L9,3.57954545 Z",
    id: "Shape",
    fill: "#EA4335"
  }), React__default.createElement("polygon", {
    id: "Shape",
    points: "0 0 18 0 18 18 0 18"
  })))));
};

var Container$a = styled.div.withConfig({
  displayName: "oauth-providersstyles__Container",
  componentId: "keen-ui-core__sc-y6voto-0"
})(["&&&{display:flex;justify-content:center;}"]);
var Separator = styled.div.withConfig({
  displayName: "oauth-providersstyles__Separator",
  componentId: "keen-ui-core__sc-y6voto-1"
})(["&&&{width:20px;flex-shrink:0;}"]);
var IconContainer$2 = styled.div.withConfig({
  displayName: "oauth-providersstyles__IconContainer",
  componentId: "keen-ui-core__sc-y6voto-2"
})(["&&&{padding-top:2px;margin-right:10px;}"]);

var ButtonInverse = styled.div.withConfig({
  displayName: "button-inversecomponent__ButtonInverse",
  componentId: "keen-ui-core__sc-yae0qm-0"
})(["&&&{display:flex;flex-shrink:0;align-items:center;justify-content:center;border-radius:5rem;border:1px solid ", ";cursor:pointer;font-family:'Lato Regular',sans-serif;box-shadow:0 1px 4px 0 ", ";padding:12px 16px;font-weight:400;font-size:14px;line-height:17px;background:transparent;color:", ";transition:background 0.2s linear;}&&&:hover{background:#f2f2f2;box-shadow:none;}"], colors.white['300'], transparentize(0.85, colors.black['500']), colors.blue['500']);

var serializeToQuery = function serializeToQuery(payload) {
  var acc = [];

  for (var property in payload) {
    if (payload.hasOwnProperty(property)) {
      acc.push("".concat(encodeURIComponent(property), "=").concat(encodeURIComponent(payload[property])));
    }
  }

  return acc.join('&');
};

var OAuthUserAction;

(function (OAuthUserAction) {
  OAuthUserAction["REGISTER"] = "signup";
  OAuthUserAction["LOGIN"] = "login";
  OAuthUserAction["ACCEPT_INVITE"] = "invite";
})(OAuthUserAction || (OAuthUserAction = {}));

var OAuthProviders = function OAuthProviders(_ref) {
  var config = _ref.config,
      requestInitiatorUrl = _ref.requestInitiatorUrl,
      callbackHandlerHost = _ref.callbackHandlerHost,
      _ref$action = _ref.action,
      action = _ref$action === void 0 ? OAuthUserAction.REGISTER : _ref$action;
  var googleOAuth = config.googleOAuth,
      googleLabel = config.googleOAuth.label,
      gitHubOAuth = config.gitHubOAuth,
      githubLabel = config.gitHubOAuth.label;
  return React__default.createElement(Container$a, null, React__default.createElement(ButtonInverse, {
    "data-testid": "google-oauth",
    onClick: function onClick() {
      var googleOauthParams = serializeToQuery({
        scope: googleOAuth.scope,
        include_granted_scopes: true,
        response_type: 'code',
        state: JSON.stringify({
          action: action,
          request_initiator_url: requestInitiatorUrl
        }),
        client_id: googleOAuth.clientId,
        redirect_uri: "".concat(callbackHandlerHost, "/").concat(googleOAuth.redirectUri)
      });
      window.location.replace("".concat(googleOAuth.url, "?").concat(googleOauthParams));
    }
  }, React__default.createElement(IconContainer$2, null, React__default.createElement(GoogleIcon, null)), googleLabel), React__default.createElement(Separator, null), React__default.createElement(ButtonInverse, {
    "data-testid": "github-oauth",
    onClick: function onClick() {
      var gitHubOauthParams = serializeToQuery({
        scope: gitHubOAuth.scope,
        client_id: gitHubOAuth.clientId,
        state: JSON.stringify({
          action: action,
          request_initiator_url: requestInitiatorUrl
        })
      });
      window.location.replace("".concat(gitHubOAuth.url, "?").concat(gitHubOauthParams));
    }
  }, React__default.createElement(IconContainer$2, null, React__default.createElement(GitHubIcon, null)), githubLabel));
};

var Wrapper = styled.div.withConfig({
  displayName: "scroll-wrapperstyles__Wrapper",
  componentId: "keen-ui-core__sc-u0fc7p-0"
})(["&&&{position:relative;", ";}"], function (props) {
  return props.maxHeight && css(["overflow-y:scroll;max-height:", "px;"], props.maxHeight);
});

var ScrollWrapper = function ScrollWrapper(_ref) {
  var children = _ref.children;
  var wrapper = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      maxHeight = _useState2[0],
      setMaxHeight = _useState2[1];

  useEffect(function () {
    var offsetHeight = document.body.offsetHeight;
    var _window = window,
        scrollY = _window.scrollY,
        innerHeight = _window.innerHeight;

    var _ref2 = wrapper.current && wrapper.current.getBoundingClientRect(),
        top = _ref2.top,
        height = _ref2.height;

    var topPosition = top + scrollY;
    var fullHeight = offsetHeight > innerHeight ? offsetHeight : innerHeight;
    if (height > fullHeight - topPosition) setMaxHeight(fullHeight - topPosition);
  }, [wrapper]);
  return React__default.createElement(Wrapper, {
    ref: wrapper,
    maxHeight: maxHeight
  }, children);
};

var TabsContainer = styled.div.withConfig({
  displayName: "tabsstyles__TabsContainer",
  componentId: "keen-ui-core__sc-1lbdgqh-0"
})(["&&&{display:grid;grid-auto-flow:column;grid-auto-columns:1fr;width:100%;position:relative;color:", ";}"], colors.green[500]);
var Tab = styled.div.withConfig({
  displayName: "tabsstyles__Tab",
  componentId: "keen-ui-core__sc-1lbdgqh-1"
})(["&&&{padding:10px 20px;min-width:0;text-align:center;cursor:pointer;background:linear-gradient(currentColor 0 0) bottom / var(--d,0) 2px no-repeat;transition:background 150ms ease-out;", ";}&&&:hover{background-color:", ";}&&&:focus-visible{outline:1px solid ", ";}"], function (props) {
  return props.isActive && css(["--d:100%;"]);
}, transparentize(0.9, colors.green[100]), colors.lightBlue[500]);

var TOOLTIP_MOTION = {
  transition: {
    duration: 0.3,
    delay: 0.5
  },
  exit: {
    opacity: 0
  }
};

var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs,
      activeTab = _ref.activeTab,
      _onClick = _ref.onClick;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      overflowedTabs = _useState2[0],
      setOverflowedTabs = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      tooltipLabel = _useState4[0],
      setTooltipLabel = _useState4[1];

  var containerRef = useRef(null);

  var _useTooltip = useTooltip(containerRef),
      tooltipVisible = _useTooltip.tooltipVisible,
      tooltipPosition = _useTooltip.tooltipPosition,
      updateTooltipPosition = _useTooltip.updateTooltipPosition,
      hideTooltip = _useTooltip.hideTooltip;

  useEffect(function () {
    if (containerRef.current) {
      var textNodes = Array.from(containerRef.current.getElementsByTagName('p'));
      textNodes.forEach(function (node, idx) {
        var scrollWidth = node.scrollWidth;
        var offsetWidth = node.offsetWidth;
        if (scrollWidth > offsetWidth) setOverflowedTabs(function (state) {
          return [].concat(_toConsumableArray(state), [idx]);
        });
      });
    }
  }, [containerRef]);
  return React__default.createElement(TabsContainer, {
    role: "tablist",
    ref: containerRef
  }, React__default.createElement(AnimatePresence, null, tooltipVisible && tooltipLabel && React__default.createElement(motion.div, Object.assign({}, TOOLTIP_MOTION, {
    initial: {
      opacity: 0,
      x: tooltipPosition.x,
      y: tooltipPosition.y
    },
    animate: {
      x: tooltipPosition.x,
      y: tooltipPosition.y,
      opacity: 1
    },
    style: {
      position: 'absolute',
      pointerEvents: 'none'
    }
  }), React__default.createElement(Tooltip, {
    mode: "light",
    hasArrow: false
  }, React__default.createElement(BodyText, {
    variant: "body3",
    fontWeight: 400,
    color: colors.black[500]
  }, tooltipLabel)))), tabs.map(function (_ref2, idx) {
    var label = _ref2.label,
        id = _ref2.id;
    return React__default.createElement(Tab, {
      role: "tab",
      key: id,
      onClick: function onClick() {
        return _onClick(id);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.keyCode === KEYBOARD_KEYS.ENTER) {
          _onClick(id);
        }
      },
      isActive: id === activeTab,
      tabIndex: 0,
      onMouseEnter: function onMouseEnter(e) {
        if (overflowedTabs.includes(idx)) {
          updateTooltipPosition(e);
          setTooltipLabel(label);
        }
      },
      onMouseLeave: function onMouseLeave() {
        hideTooltip();
      }
    }, React__default.createElement(BodyText, {
      variant: "body2",
      fontWeight: "bold",
      color: colors.green[500],
      enableTextEllipsis: true
    }, label));
  }));
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var utc = {exports: {}};

(function (module, exports) {
!function(t,i){module.exports=i();}(commonjsGlobal,(function(){var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var o=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),o.call(this,t);};var r=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds();}else r.call(this);};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&null===(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s)))return this;var u=Math.abs(s)<=16?60*s:s,o=this;if(f)return o.$offset=u,o.$u=0===s,o;if(0!==s){var r=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();(o=this.local().add(u+r,t)).$offset=u,o.$x.$localOffset=r;}else o=this.utc();return o};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||(new Date).getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return !!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return "s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)};}}));
}(utc));

var utcPlugin = utc.exports;

var timezone = {exports: {}};

(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,a=function(t,n,i){void 0===i&&(i={});var o=new Date(t);return function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i).formatToParts(o)},u=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10));}var d=r[3],l=24===d?0:d,v=r[0]+"-"+r[1]+"-"+r[2]+" "+l+":"+r[4]+":"+r[5]+":000",h=+e;return (o.utc(v).valueOf()-(h-=h%1e3))/6e4},f=i.prototype;f.tz=function(t,e){void 0===t&&(t=r);var n=this.utcOffset(),i=this.toDate(),a=i.toLocaleString("en-US",{timeZone:t}),u=Math.round((i-new Date(a))/1e3/60),f=o(a).$set("millisecond",this.$ms).utcOffset(15*-Math.round(i.getTimezoneOffset()/15)-u,!0);if(e){var s=f.utcOffset();f=f.add(n-s,"minute");}return f.$x.$timezone=t,f},f.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return "timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=o(this.format("YYYY-MM-DD HH:mm:ss:SSS"));return s.call(n,t,e).tz(this.$x.$timezone,!0)},o.tz=function(t,e,n){var i=n&&e,a=n||e||r,f=u(+o(),a);if("string"!=typeof t)return o(t).tz(a);var s=function(t,e,n){var i=t-60*e*1e3,o=u(i,n);if(e===o)return [i,e];var r=u(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),f,a),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=a,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t;};}}));
}(timezone));

var timezonePlugin = timezone.exports;

var TimeRow = styled.div.withConfig({
  displayName: "absolute-timestyles__TimeRow",
  componentId: "keen-ui-core__sc-pzerll-0"
})(["&&&{display:flex;align-items:center;}"]);
var Container$9 = styled.div.withConfig({
  displayName: "absolute-timestyles__Container",
  componentId: "keen-ui-core__sc-pzerll-1"
})(["&&&{display:flex;flex-direction:column;}&&& ", " + ", "{margin-top:10px;}"], TimeRow, TimeRow);
var TimeLabel$1 = styled.div.withConfig({
  displayName: "absolute-timestyles__TimeLabel",
  componentId: "keen-ui-core__sc-pzerll-2"
})(["&&&{font-size:14px;line-height:17px;font-family:Lato Regular,sans-serif;color:", ";display:flex;flex-shrink:0;align-items:center;margin-right:10px;width:35px;}"], colors.blue[500]);

var Container$8 = styled.div.withConfig({
  displayName: "dropdown-list-containerstyles__Container",
  componentId: "keen-ui-core__sc-1xk6idr-0"
})(["&&&{max-height:100px;overflow-y:scroll;", ";}"], function (_ref) {
  var overflowTop = _ref.overflowTop,
      overflowBottom = _ref.overflowBottom;
  var boxShadow = "";
  if (overflowTop) boxShadow += "inset 0px 6px 4px -4px ".concat(transparentize(0.85, colors.black[500]));
  if (overflowTop && overflowBottom) boxShadow += ',';
  if (overflowBottom) boxShadow += "inset 0 -6px 4px -4px ".concat(transparentize(0.85, colors.black[500]));
  return css(["box-shadow:", ";"], boxShadow);
});

var DropdownListContainer = function DropdownListContainer(_ref) {
  var children = _ref.children,
      scrollToActive = _ref.scrollToActive,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? 200 : _ref$maxHeight,
      _ref$scrollShadow = _ref.scrollShadow,
      scrollShadow = _ref$scrollShadow === void 0 ? false : _ref$scrollShadow;
  var containerRef = useRef(null);
  var itemRef = useRef(null);

  var _useInView = useInView(),
      _useInView2 = _slicedToArray(_useInView, 2),
      inViewRefTop = _useInView2[0],
      inViewTop = _useInView2[1];

  var _useInView3 = useInView(),
      _useInView4 = _slicedToArray(_useInView3, 2),
      inViewRefBottom = _useInView4[0],
      inViewBottom = _useInView4[1];

  useEffect(function () {
    if (scrollToActive && itemRef.current) {
      var containerOffsetTop = containerRef.current.offsetTop;
      var _itemRef$current = itemRef.current,
          offsetTop = _itemRef$current.offsetTop,
          offsetHeight = _itemRef$current.offsetHeight;
      containerRef.current.scrollTop = offsetTop - offsetHeight - containerOffsetTop;
    }
  }, []);
  return React__default.createElement(Container$8, {
    ref: containerRef,
    style: {
      maxHeight: "".concat(maxHeight, "px")
    },
    overflowTop: scrollShadow && !inViewTop,
    overflowBottom: scrollShadow && !inViewBottom
  }, React__default.createElement("div", {
    ref: inViewRefTop
  }), children(itemRef), React__default.createElement("div", {
    ref: inViewRefBottom
  }));
};

var getEventPath = function getEventPath(event) {
  return event.path || event.composedPath && event.composedPath();
};

var getTimeOptions = function getTimeOptions(length) {
  return Array.from({
    length: length
  }, function (_, idx) {
    return {
      label: idx < 10 ? "0".concat(idx) : "".concat(idx),
      value: idx < 10 ? "0".concat(idx) : "".concat(idx)
    };
  });
};

var DATE_FORMAT$1 = 'YYYY-MM-DD';
var TIME_FORMAT = 'HH:mm';

var validateDate = function validateDate(date) {
  var regex = /^\d{4}-\d{2}-\d{2}$/g;
  var isFormatValid = regex.test(date);
  if (!isFormatValid) return false;
  return dayjs(date, DATE_FORMAT$1).format(DATE_FORMAT$1) === date;
};

var validateTime = function validateTime(time) {
  var regex = /^\d{2}:\d{2}$/g;
  var isFormatValid = regex.test(time);
  if (!isFormatValid) return false;

  var _time$split = time.split(':'),
      _time$split2 = _slicedToArray(_time$split, 2),
      hours = _time$split2[0],
      minutes = _time$split2[1];

  var isHoursValid = Number(hours) >= 0 && Number(hours) < 24;
  var isMinutesValid = Number(minutes) >= 0 && Number(minutes) < 60;
  return isHoursValid && isMinutesValid;
};

var GlobalStyle = createGlobalStyle([".react-calendar{width:320px;max-width:100%;background:white;border:none;font-family:'Lato',sans-serif;line-height:1.125em;}.react-calendar--doubleView{width:700px;}.react-calendar--doubleView .react-calendar__viewContainer{display:flex;margin:-0.5em;}.react-calendar--doubleView .react-calendar__viewContainer > *{width:50%;margin:0.5em;}.react-calendar,.react-calendar *,.react-calendar *:before,.react-calendar *:after{box-sizing:border-box;}.react-calendar button{margin:0;border:0;outline:none;font-family:'Lato',sans-serif;}.react-calendar button:enabled:hover{cursor:pointer;}.react-calendar__navigation{display:flex;height:auto;padding:10px 20px;border-bottom:1px solid ", ";column-gap:20px;}.react-calendar__navigation button{background:none;padding:0;min-width:20px;}.react-calendar__navigation button:enabled:hover,.react-calendar__navigation button:enabled:focus-visible{background-color:#e6e6e6;}.react-calendar__navigation button[disabled]{background-color:#f0f0f0;}.react-calendar__month-view__weekdays{text-align:center;color:", ";font-size:0.75rem;font-weight:400;text-transform:none;abbr{text-decoration:none;border:none;cursor:default;&[aria-label=\"Saturday\"],&[aria-label=\"Sunday\"]{color:", ";}}}.react-calendar__month-view__weekdays__weekday{padding:10px 5px;}.react-calendar__month-view__weekNumbers .react-calendar__tile{display:flex;align-items:center;justify-content:center;font-size:0.75em;font-weight:bold;padding:calc(0.75em / 0.75) calc(0.5em / 0.75);}.react-calendar__month-view__days__day.react-calendar__month-view__days__day--weekend{color:", ";}.react-calendar__month-view__days__day--neighboringMonth{opacity:0.3;}.react-calendar__year-view .react-calendar__tile,.react-calendar__decade-view .react-calendar__tile,.react-calendar__century-view .react-calendar__tile{padding:10px 5px;border-radius:5px;font-size:14px;border:2px solid ", ";}.react-calendar__century-view .react-calendar__tile{font-size:13px;}.react-calendar__tile{max-width:100%;text-align:center;padding:0.75em 0.5em;background:none;}.react-calendar__tile:disabled{background-color:#f0f0f0;}.react-calendar__tile:enabled:hover,.react-calendar__tile:enabled:focus-visible{background-color:#e6e6e6;}.react-calendar__tile--now{background:#ffff76;}.react-calendar__tile--now:enabled:hover,.react-calendar__tile--now:enabled:focus-visible{background:#ffffa9;}.react-calendar__tile--hasActive{background:#76baff;}.react-calendar__tile--hasActive:enabled:hover,.react-calendar__tile--hasActive:enabled:focus-visible{background:#a9d4ff;}.react-calendar--selectRange .react-calendar__tile--hover{background-color:#e6e6e6;}.react-calendar__month-view__days__day abbr{font-size:14px;border-radius:50%;width:37px;height:37px;display:flex;align-items:center;justify-content:center;}.react-calendar__tile.react-calendar__month-view__days__day{padding:0;}.react-calendar__month-view{padding:10px 20px 20px 20px;}.react-calendar__tile--now,.react-calendar__tile:enabled:hover,.react-calendar__tile:enabled:focus-visible,.react-calendar__navigation__label:enabled:hover,.react-calendar__navigation__label:enabled:focus-visible,.react-calendar__navigation button:enabled:hover,.react-calendar__navigation button:enabled:focus-visible,.react-calendar__navigation button[disabled]{background:", ";}button.react-calendar__tile--active abbr,button.react-calendar__tile--active:enabled:hover abbr,button.react-calendar__tile--active:enabled:focus-visible abbr button.react-calendar__tile--active.react-calendar__month-view__days__day--weekend abbr,button.react-calendar__tile--active.react-calendar__month-view__days__day--weekend:enabled:hover abbr,button.react-calendar__tile--active.react-calendar__month-view__days__day--weekend:enabled:focus-visible abbr,.react-calendar__tile.react-calendar__tile--active.react-calendar__month-view__days__day:hover abbr,.react-calendar__tile.react-calendar__tile--active.react-calendar__month-view__days__day:focus-visible abbr,.react-calendar__tile--hasActive,.react-calendar__tile--hasActive:enabled:hover,.react-calendar__tile--hasActive:enabled:focus-visible,button.react-calendar__tile--hasActive.react-calendar__year-view__months__month,button.react-calendar__tile--hasActive.react-calendar__year-view__months__month:enabled:hover,button.react-calendar__tile--hasActive.react-calendar__year-view__months__month:enabled:focus-visible,button.react-calendar__tile--hasActive.react-calendar__decade-view__years__year,button.react-calendar__tile--hasActive.react-calendar__decade-view__years__year:enabled:hover,button.react-calendar__tile--hasActive.react-calendar__decade-view__years__year:enabled:focus-visible{background:", ";color:", ";}button.react-calendar__tile--hasActive.react-calendar__year-view__months__month,button.react-calendar__tile--hasActive.react-calendar__year-view__months__month:enabled:hover,button.react-calendar__tile--hasActive.react-calendar__year-view__months__month:enabled:focus-visible,button.react-calendar__tile--hasActive.react-calendar__decade-view__years__year,button.react-calendar__tile--hasActive.react-calendar__decade-view__years__year:enabled:hover,button.react-calendar__tile--hasActive.react-calendar__decade-view__years__year:enabled:focus-visible{border:2px solid ", ";}.react-calendar__navigation__label__labelText{font-size:1rem;color:", ";}button.react-calendar__navigation__arrow:enabled:hover,button.react-calendar__navigation__arrow:enabled:focus-visible{background:none;}button.react-calendar__navigation__arrow:enabled:focus-visible{outline:1px solid ", ";}button.react-calendar__navigation__label{padding:10px;border-radius:4px;transition:background-color 250ms ease-in-out;}.react-calendar__year-view__months,.react-calendar__decade-view__years,.react-calendar__century-view__decades{padding:20px;}.react-calendar__viewContainer{min-height:205px;}.react-calendar__tile.react-calendar__month-view__days__day:hover,.react-calendar__tile.react-calendar__month-view__days__day:focus-visible{background:none;abbr{background:", ";}}.react-calendar__tile--now.react-calendar__month-view__days__day{background:none;abbr{border:1px solid ", ";}&:hover,&:focus-visible{abbr{background:", ";}}}.react-calendar__tile--now.react-calendar__year-view__months__month:not(.react-calendar__tile--hasActive),.react-calendar__tile--now.react-calendar__century-view__decades__decade:not(.react-calendar__tile--hasActive),.react-calendar__tile--now.react-calendar__decade-view__years__year:not(.react-calendar__tile--hasActive){background:none;outline:1px solid ", ";outline-offset:-2px;&:hover,&:focus-visible{background:", ";}}.react-calendar__tile--now.react-calendar__tile--active{abbr{background:", ";}}"], colors.white[300], transparentize(0.3, colors.black[500]), colors.blue[500], colors.blue[500], colors.white[500], transparentize(0.9, colors.blue[500]), colors.blue[500], colors.white[500], colors.white[500], colors.blue[500], transparentize(0.5, colors.blue[500]), transparentize(0.9, colors.blue[500]), transparentize(0.5, colors.blue[500]), transparentize(0.9, colors.blue[500]), transparentize(0.5, colors.blue[500]), transparentize(0.9, colors.blue[500]), colors.blue[500]);
var IconContainer$1 = styled(motion.div).withConfig({
  displayName: "date-pickerstyles__IconContainer",
  componentId: "keen-ui-core__sc-15z590m-0"
})(["&&&{padding:2px;}"]);
var CalendarContainer = styled.div.withConfig({
  displayName: "date-pickerstyles__CalendarContainer",
  componentId: "keen-ui-core__sc-15z590m-1"
})(["&&&{background:", ";}"], colors.white[500]);
var Container$7 = styled.div.withConfig({
  displayName: "date-pickerstyles__Container",
  componentId: "keen-ui-core__sc-15z590m-2"
})(["&&&{display:flex;column-gap:5px;}"]);
var TimePickerContainer = styled.div.withConfig({
  displayName: "date-pickerstyles__TimePickerContainer",
  componentId: "keen-ui-core__sc-15z590m-3"
})(["&&&{background:", ";display:flex;}"], colors.white[500]);
var TimePickerList = styled.div.withConfig({
  displayName: "date-pickerstyles__TimePickerList",
  componentId: "keen-ui-core__sc-15z590m-4"
})(["&&&{flex:1;}"]);
var PickerInput = styled.div.withConfig({
  displayName: "date-pickerstyles__PickerInput",
  componentId: "keen-ui-core__sc-15z590m-5"
})(["&&&{max-width:180px;}"]);

var hoursOptions = getTimeOptions(24);
var minutesOptions = getTimeOptions(60);

var ReactCalendar = function ReactCalendar(_ref) {
  var date = _ref.date,
      id = _ref.id,
      _onChange = _ref.onChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDatePickerOpen = _useState2[0],
      setDatePickerOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isTimePickerOpen = _useState4[0],
      setTimePickerOpen = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      inputTime = _useState6[0],
      setInputTime = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      inputDate = _useState8[0],
      setInputDate = _useState8[1];

  var datePickerRef = useRef(null);
  var timePickerRef = useRef(null);
  var hour = date.getHours();
  var minute = date.getMinutes();
  var outsideClick = useCallback(function (event) {
    var path = getEventPath(event);

    if (isDatePickerOpen && !(path === null || path === void 0 ? void 0 : path.includes(datePickerRef.current))) {
      setDatePickerOpen(false);
    }

    if (isTimePickerOpen && !(path === null || path === void 0 ? void 0 : path.includes(timePickerRef.current))) {
      setTimePickerOpen(false);
    }
  }, [isDatePickerOpen, isTimePickerOpen, datePickerRef, timePickerRef]);
  useEffect(function () {
    document.addEventListener('click', outsideClick);
    return function () {
      return document.removeEventListener('click', outsideClick);
    };
  }, [isDatePickerOpen, isTimePickerOpen, datePickerRef, timePickerRef, outsideClick]);
  useEffect(function () {
    var inputTime = dayjs(date).format(TIME_FORMAT);
    var inputDate = dayjs(date).format(DATE_FORMAT$1);
    setInputTime(inputTime);
    setInputDate(inputDate);
  }, [date]);
  return React__default.createElement(Container$7, null, React__default.createElement(GlobalStyle, null), React__default.createElement(PickerInput, null, React__default.createElement(Input$1, {
    type: "text",
    variant: "solid",
    placeholder: DATE_FORMAT$1,
    pattern: "\\d{4}-\\d{2}-\\d{2}",
    maxLength: 10,
    autoComplete: "off",
    value: inputDate,
    hasError: !validateDate(inputDate),
    onBlur: function onBlur() {
      return !validateDate(inputTime) && setInputDate(dayjs(date).format(DATE_FORMAT$1));
    },
    onInput: function onInput() {
      !isDatePickerOpen && setDatePickerOpen(true);
      isTimePickerOpen && setTimePickerOpen(false);
    },
    onKeyDown: function onKeyDown(e) {
      return isDatePickerOpen && (e.key === 'Enter' || e.key === 'Escape') && setDatePickerOpen(false);
    },
    onClick: function onClick() {
      return !isDatePickerOpen && setDatePickerOpen(true);
    },
    onChange: function onChange(e) {
      e.persist();
      var value = e.currentTarget.value;
      var formattedValue = value;
      var isDeleting = value.length < inputDate.length;

      if (!isDeleting && /^\d{4,5}$/.test(value)) {
        var arr = formattedValue.split('');
        arr.splice(4, 0, '-');
        formattedValue = arr.join('');
      }

      if (!isDeleting && /^\d{4}-\d{2,3}$/.test(value)) {
        var _arr = formattedValue.split('');

        _arr.splice(7, 0, '-');

        formattedValue = _arr.join('');
      }

      var regex = /(^\d{0,4}$)|(^\d{0,4}-$)|(^\d{0,4}-\d{1,2}$)|(^\d{0,4}-\d{1,2}-$)|(^\d{0,4}-\d{1,2}-\d{1,2}$)/g;

      if (regex.test(formattedValue)) {
        setInputDate(formattedValue);
      }

      if (validateDate(formattedValue)) {
        var updatedDate = dayjs(formattedValue).hour(hour).minute(minute).toDate();

        _onChange(updatedDate, e);
      }
    }
  }), React__default.createElement(Dropdown, {
    isOpen: isDatePickerOpen,
    fullWidth: false
  }, React__default.createElement(CalendarContainer, {
    ref: datePickerRef,
    "data-testid": id
  }, React__default.createElement(Calendar, {
    locale: "en-EN",
    onChange: function onChange(date, event) {
      var updatedDate = dayjs(date).hour(hour).minute(minute).toDate();
      setDatePickerOpen(false);

      _onChange(updatedDate, event);
    },
    value: date,
    nextLabel: React__default.createElement(IconContainer$1, {
      whileHover: {
        x: 5
      }
    }, React__default.createElement(Icon, {
      width: 19,
      height: 19,
      type: "button-arrow",
      fill: transparentize(0.3, colors.blue[500])
    })),
    next2Label: null,
    prevLabel: React__default.createElement(IconContainer$1, {
      whileHover: {
        x: -5
      }
    }, React__default.createElement(Icon, {
      width: 19,
      height: 19,
      type: "button-arrow-left",
      fill: transparentize(0.3, colors.blue[500])
    })),
    prev2Label: null
  })))), React__default.createElement(PickerInput, null, React__default.createElement(Input$1, {
    type: "text",
    variant: "solid",
    placeholder: TIME_FORMAT,
    pattern: "\\d{2}:\\d{2}",
    maxLength: 5,
    hasError: !validateTime(inputTime),
    autoComplete: "off",
    value: inputTime,
    onBlur: function onBlur() {
      return !validateTime(inputTime) && setInputTime("".concat(hour < 10 ? "0".concat(hour) : hour, ":").concat(minute < 10 ? "0".concat(minute) : minute));
    },
    onInput: function onInput() {
      !isTimePickerOpen && setTimePickerOpen(true);
      isDatePickerOpen && setDatePickerOpen(false);
    },
    onKeyDown: function onKeyDown(e) {
      return isTimePickerOpen && (e.key === 'Enter' || e.key === 'Escape') && setTimePickerOpen(false);
    },
    onClick: function onClick() {
      return !isTimePickerOpen && setTimePickerOpen(true);
    },
    onChange: function onChange(e) {
      e.persist();
      var value = e.currentTarget.value;
      var formattedValue = value;
      var isDeleting = value.length < inputTime.length;

      if (!isDeleting && /^\d{2,3}$/.test(value)) {
        var arr = formattedValue.split('');
        arr.splice(2, 0, ':');
        formattedValue = arr.join('');
      }

      var regex = /(^\d{0,2}$)|(^\d{0,2}:$)|(^\d{0,2}:\d{0,2}$)|(^\d{2}:\d{2}$)/g;

      if (regex.test(formattedValue)) {
        setInputTime(formattedValue);
      }

      if (validateTime(formattedValue)) {
        var _formattedValue$split = formattedValue.split(':'),
            _formattedValue$split2 = _slicedToArray(_formattedValue$split, 2),
            _hour = _formattedValue$split2[0],
            _minute = _formattedValue$split2[1];

        var updatedDate = dayjs(date).hour(+_hour).minute(+_minute).toDate();

        _onChange(updatedDate, e);
      }
    }
  }), React__default.createElement(Dropdown, {
    isOpen: isTimePickerOpen
  }, React__default.createElement(TimePickerContainer, {
    ref: timePickerRef
  }, React__default.createElement(TimePickerList, null, React__default.createElement(DropdownListContainer, {
    scrollToActive: true
  }, function (activeItemRef) {
    return React__default.createElement(DropdownList, {
      ref: activeItemRef,
      debounce: 500,
      items: hoursOptions,
      setActiveItem: function setActiveItem(_ref2) {
        var value = _ref2.value;
        return hour === +value;
      },
      onClick: function onClick(_e, _ref3) {
        var hour = _ref3.value;
        var updatedDate = dayjs(date).hour(+hour).toDate();

        _onChange(updatedDate, {});
      }
    });
  })), React__default.createElement(TimePickerList, null, React__default.createElement(DropdownListContainer, {
    scrollToActive: true
  }, function (activeItemRef) {
    return React__default.createElement(DropdownList, {
      ref: activeItemRef,
      debounce: 1000,
      items: minutesOptions,
      setActiveItem: function setActiveItem(_ref4) {
        var value = _ref4.value;
        return minute === +value;
      },
      onClick: function onClick(_e, _ref5) {
        var minute = _ref5.value;
        var updatedDate = dayjs(date).minute(+minute).toDate();

        _onChange(updatedDate, {});
      }
    });
  }))))));
};

var DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);
var AbsoluteTime = memo(function (_ref) {
  var id = _ref.id,
      start = _ref.start,
      end = _ref.end,
      startDateLabel = _ref.startDateLabel,
      endDateLabel = _ref.endDateLabel,
      _onChange = _ref.onChange;
  var startDate = new Date(start.substring(0, 19));
  var endDate = new Date(end.substring(0, 19));
  return React__default.createElement(Container$9, {
    "data-testid": "absolute-time"
  }, React__default.createElement(TimeRow, null, React__default.createElement(TimeLabel$1, null, startDateLabel), React__default.createElement(ReactCalendar, {
    id: "".concat(id, "-start"),
    date: startDate,
    onChange: function onChange(date) {
      return _onChange({
        start: dayjs(date.toString()).format(DATE_FORMAT),
        end: end
      });
    }
  })), React__default.createElement(TimeRow, null, React__default.createElement(TimeLabel$1, null, endDateLabel), React__default.createElement(ReactCalendar, {
    id: "".concat(id, "-end"),
    date: endDate,
    onChange: function onChange(date) {
      return _onChange({
        start: start,
        end: dayjs(date.toString()).format(DATE_FORMAT)
      });
    }
  })));
});
AbsoluteTime.displayName = 'AbsoluteTime';

var placeholderMixin = function placeholderMixin() {
  return css(["font-size:14px;line-height:17px;font-family:'Lato Regular',sans-serif;color:", ";"], transparentize(0.5, colors.black[300]));
};

var containerVariants = {
  prop: 'variant',
  variants: {
    primary: {
      background: colors.white[500],
      borderColor: colors.white[500],
      color: colors.blue['500']
    },
    secondary: {
      background: transparentize(0.85, colors.blue[100]),
      borderColor: transparentize(0.85, colors.blue[100]),
      color: colors.blue['500']
    },
    transparent: {
      background: 'none',
      color: colors.blue['500']
    }
  }
};
var Container$6 = styled.div.withConfig({
  displayName: "dropable-containerstyles__Container",
  componentId: "keen-ui-core__sc-90horr-0"
})(["&&&{", ";display:flex;padding:10px 14px;height:37px;box-sizing:border-box;border-radius:4px;font-size:14px;line-height:17px;font-family:'Lato Regular',sans-serif;position:relative;", ";", ";transition:box-shadow 0.2s;", ";}&&&:focus-visible{box-shadow:0 0 3px 1px rgba(29,39,41,0.15);outline:1px solid ", ";}"], variant(containerVariants), function (props) {
  return props.isActive && css(["box-shadow:0 0 3px 1px rgba(29,39,41,0.15);"]);
}, function (props) {
  return props.borderRadius && css(["border-radius:", ";"], props.borderRadius);
}, function (props) {
  return props.hasError && css(["border:1px solid ", ";"], transparentize(0.5, colors.red[500]));
}, colors.lightBlue[500]);
var SearchIcon = styled.div.withConfig({
  displayName: "dropable-containerstyles__SearchIcon",
  componentId: "keen-ui-core__sc-90horr-1"
})(["&&&{margin-right:5px;}"]);
var DropIndicator = styled.div.withConfig({
  displayName: "dropable-containerstyles__DropIndicator",
  componentId: "keen-ui-core__sc-90horr-2"
})(["&&&{display:flex;align-items:center;margin-left:auto;padding-left:5px;cursor:pointer;}"]);
var Placeholder = styled.div.withConfig({
  displayName: "dropable-containerstyles__Placeholder",
  componentId: "keen-ui-core__sc-90horr-3"
})(["&&&{", ";}"], placeholderMixin());
var Input = styled.input.withConfig({
  displayName: "dropable-containerstyles__Input",
  componentId: "keen-ui-core__sc-90horr-4"
})(["&&&{outline:none;padding:0;border:none;background:transparent;color:", ";font-size:14px;line-height:17px;font-family:'Lato Regular',sans-serif;width:100%;}&&&::placeholder,&&&::-webkit-input-placeholder{", ";}&&&:-ms-input-placeholder{", ";}"], colors.blue[500], placeholderMixin(), placeholderMixin());

var DropableContainer = function DropableContainer(_ref) {
  var onClick = _ref.onClick,
      value = _ref.value,
      placeholder = _ref.placeholder,
      children = _ref.children,
      isActive = _ref.isActive,
      onDefocus = _ref.onDefocus,
      onSearch = _ref.onSearch,
      searchable = _ref.searchable,
      searchPlaceholder = _ref.searchPlaceholder,
      dropIndicator = _ref.dropIndicator,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      borderRadius = _ref.borderRadius;
  var containerRef = useRef(null);
  var outsideClick = useCallback(function (e) {
    if (isActive && containerRef.current && !containerRef.current.contains(e.target)) {
      if (onDefocus) onDefocus(e);
    }
  }, [isActive, containerRef, onDefocus]);
  useEffect(function () {
    document.addEventListener('click', outsideClick);
    return function () {
      return document.removeEventListener('click', outsideClick);
    };
  }, [isActive, containerRef]);

  var PlaceholderContent = function PlaceholderContent() {
    if (typeof placeholder === 'function') {
      return placeholder();
    }

    return React__default.createElement(Placeholder, null, placeholder);
  };

  var onKeyDown = function onKeyDown(e) {
    if (e.keyCode === KEYBOARD_KEYS.ENTER) {
      onClick(e);
    }
  };

  return React__default.createElement(Container$6, {
    role: "button",
    "data-testid": "dropable-container",
    isActive: isActive,
    variant: variant,
    hasError: hasError,
    onClick: onClick,
    onKeyDown: onKeyDown,
    ref: containerRef,
    tabIndex: 0,
    borderRadius: borderRadius
  }, searchable && isActive ? React__default.createElement(React__default.Fragment, null, React__default.createElement(SearchIcon, null, React__default.createElement(Icon, {
    type: "search",
    fill: transparentize(0.3, colors.blue[500]),
    width: 15,
    height: 15
  })), React__default.createElement(Input, {
    type: "text",
    autoFocus: true,
    "data-testid": "dropable-container-input",
    placeholder: typeof value === 'string' ? value : searchPlaceholder,
    onChange: onSearch
  })) : React__default.createElement(React__default.Fragment, null, value && React__default.createElement(React__default.Fragment, null, children), placeholder && !value && React__default.createElement(PlaceholderContent, null)), dropIndicator && React__default.createElement(DropIndicator, {
    "data-testid": "drop-indicator"
  }, React__default.createElement(Icon, {
    type: "caret-down",
    fill: transparentize(0.3, colors.blue[500]),
    width: 10,
    height: 10
  })));
};

var Container$5 = styled.div.withConfig({
  displayName: "time-periodstyles__Container",
  componentId: "keen-ui-core__sc-ox1fm6-0"
})(["&&&{display:flex;}"]);
var TimeLabel = styled.div.withConfig({
  displayName: "time-periodstyles__TimeLabel",
  componentId: "keen-ui-core__sc-ox1fm6-1"
})(["&&&{font-size:14px;line-height:17px;font-family:Lato Regular,sans-serif;color:", ";display:flex;align-items:center;margin-right:10px;}"], colors.blue[500]);
var TimeValue = styled.div.withConfig({
  displayName: "time-periodstyles__TimeValue",
  componentId: "keen-ui-core__sc-ox1fm6-2"
})(["&&&{position:relative;flex-basis:50%;margin-right:5px;}"]);
var UnitsContainer = styled.div.withConfig({
  displayName: "time-periodstyles__UnitsContainer",
  componentId: "keen-ui-core__sc-ox1fm6-3"
})(["&&&{position:relative;flex-basis:50%;}"]);

var TimePeriod = function TimePeriod(_ref) {
  var relativity = _ref.relativity,
      value = _ref.value,
      units = _ref.units,
      label = _ref.label,
      unitsPlaceholder = _ref.unitsPlaceholder,
      _ref$disableAutoFocus = _ref.disableAutoFocus,
      disableAutoFocus = _ref$disableAutoFocus === void 0 ? false : _ref$disableAutoFocus,
      onChange = _ref.onChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isUnitsOpen = _useState2[0],
      setUnitsOpen = _useState2[1];

  var _useState3 = useState(value),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var changeValueHandler = useCallback(function (eventValue) {
    if (eventValue) {
      var updatedValue = parseInt(eventValue);
      onChange("".concat(relativity, "_").concat(updatedValue, "_").concat(units));
    }

    setInputValue(eventValue);
  }, [onChange]);
  var unitsOptions = useMemo(function () {
    return Object.values(TIME_UNITS).map(function (unit) {
      return {
        label: unit,
        value: unit
      };
    });
  }, []);

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectionIndex = _useState6[0],
      setIndex = _useState6[1];

  useEffect(function () {
    if (isUnitsOpen) {
      var index = unitsOptions.findIndex(function (u) {
        return units === u.value;
      });
      setIndex(index);
    }

    return function () {
      setIndex(null);
    };
  }, [isUnitsOpen]);
  var keyboardHandler = useCallback(function (_e, keyCode) {
    switch (keyCode) {
      case KEYBOARD_KEYS.ENTER:
        var updatedUnits = unitsOptions[selectionIndex].value;
        onChange("".concat(relativity, "_").concat(value, "_").concat(updatedUnits));
        setUnitsOpen(false);
        break;

      case KEYBOARD_KEYS.UP:
        if (selectionIndex > 0) {
          setIndex(selectionIndex - 1);
        }

        break;

      case KEYBOARD_KEYS.DOWN:
        if (selectionIndex === null) {
          setIndex(0);
        } else if (selectionIndex < unitsOptions.length - 1) {
          setIndex(selectionIndex + 1);
        }

        break;

      case KEYBOARD_KEYS.ESCAPE:
        setUnitsOpen(false);
        break;
    }
  }, [selectionIndex, unitsOptions]);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ENTER, KEYBOARD_KEYS.ESCAPE, KEYBOARD_KEYS.UP, KEYBOARD_KEYS.DOWN],
    addEventListenerCondition: isUnitsOpen,
    eventListenerDependencies: [selectionIndex, unitsOptions, isUnitsOpen]
  });
  return React__default.createElement(Container$5, null, React__default.createElement(TimeLabel, null, label), React__default.createElement(TimeValue, null, React__default.createElement(Input$1, {
    variant: "solid",
    "data-testid": "relative-time-input",
    autoFocus: !disableAutoFocus,
    type: "number",
    value: inputValue,
    hasError: !inputValue,
    min: 1,
    onChange: function onChange(e) {
      return changeValueHandler(e.target.value);
    }
  })), React__default.createElement(UnitsContainer, null, React__default.createElement(DropableContainer, {
    variant: "secondary",
    placeholder: unitsPlaceholder,
    onClick: function onClick() {
      return !isUnitsOpen && setUnitsOpen(true);
    },
    isActive: isUnitsOpen,
    value: units,
    dropIndicator: true,
    onDefocus: function onDefocus() {
      setUnitsOpen(false);
    }
  }, units), React__default.createElement(Dropdown, {
    isOpen: isUnitsOpen
  }, React__default.createElement(DropdownListContainer, {
    scrollToActive: true
  }, function (activeItemRef) {
    return React__default.createElement(DropdownList, {
      ref: activeItemRef,
      items: unitsOptions,
      setActiveItem: function setActiveItem(_ref2) {
        var value = _ref2.value;
        return typeof selectionIndex === 'number' && unitsOptions[selectionIndex].value === value;
      },
      onClick: function onClick(_e, _ref3) {
        var updatedUnits = _ref3.value;
        onChange("".concat(relativity, "_").concat(value, "_").concat(updatedUnits));
      }
    });
  }))));
};

var Container$4 = styled.div.withConfig({
  displayName: "titlestyles__Container",
  componentId: "keen-ui-core__sc-1dgni7l-0"
})(["&&&{margin-bottom:3px;color:", ";font-family:'Lato Bold',sans-serif;font-size:14px;line-height:17px;cursor:pointer;", ";", ";}"], colors.black[100], function (props) {
  return props.isDisabled && css(["cursor:not-allowed;color:", ";"], transparentize(0.5, colors.black[100]));
}, function (props) {
  return props.hasError && css(["color:", ";"], colors.red[500]);
});

var Title$1 = function Title(_ref) {
  var children = _ref.children,
      _onClick = _ref.onClick,
      isDisabled = _ref.isDisabled,
      hasError = _ref.hasError;
  return React__default.createElement(Container$4, {
    onClick: function onClick(e) {
      if (_onClick && !isDisabled) _onClick(e);
    },
    isDisabled: isDisabled,
    hasError: hasError
  }, children);
};

var RelativityContainer = styled.div.withConfig({
  displayName: "relative-timestyles__RelativityContainer",
  componentId: "keen-ui-core__sc-v5s2x9-0"
})(["&&&{margin-top:15px;display:inline-flex;align-items:center;}"]);
var CheckboxLabel = styled.div.withConfig({
  displayName: "relative-timestyles__CheckboxLabel",
  componentId: "keen-ui-core__sc-v5s2x9-1"
})(["&&&{margin-left:5px;}"]);

var getInterval = function getInterval(units) {
  return Object.keys(TIME_UNITS).find(function (key) {
    return TIME_UNITS[key] === units;
  });
};

var TIME_SEPARATOR = '_';
var TODAY = {
  relativity: 'this',
  value: 1,
  units: 'days'
};
var YESTERDAY = {
  relativity: 'previous',
  value: 1,
  units: 'days'
};
var convertRelativeTime = function convertRelativeTime(time) {
  var timeChunks = time.split(TIME_SEPARATOR);
  var chunksLength = timeChunks.length;

  if (chunksLength === 1) {
    if (time === 'today') return TODAY;
    if (time === 'yesterday') return YESTERDAY;
  }

  if (chunksLength === 2) {
    var _timeChunks = _slicedToArray(timeChunks, 2),
        _relativity = _timeChunks[0],
        unit = _timeChunks[1];

    return {
      relativity: _relativity,
      value: 1,
      units: TIME_UNITS[unit]
    };
  }

  var _timeChunks2 = _slicedToArray(timeChunks, 3),
      relativity = _timeChunks2[0],
      value = _timeChunks2[1],
      units = _timeChunks2[2];

  return {
    relativity: relativity,
    value: Number(value),
    units: units
  };
};

var THIS_RELATIVITY = 'this';
var PREVIOUS_RELATIVITY = 'previous';

var RelativeTime = function RelativeTime(_ref) {
  var relativity = _ref.relativity,
      value = _ref.value,
      units = _ref.units,
      timeLabel = _ref.timeLabel,
      unitsPlaceholderLabel = _ref.unitsPlaceholderLabel,
      relativityTitleForTodayLabel = _ref.relativityTitleForTodayLabel,
      relativityTitleLabel = _ref.relativityTitleLabel,
      _ref$disableAutoFocus = _ref.disableAutoFocus,
      disableAutoFocus = _ref$disableAutoFocus === void 0 ? false : _ref$disableAutoFocus,
      onChange = _ref.onChange;
  var interval = getInterval(units);

  var updateRelativity = function updateRelativity() {
    var updatedRelativity = relativity === THIS_RELATIVITY ? PREVIOUS_RELATIVITY : THIS_RELATIVITY;
    onChange("".concat(updatedRelativity, "_").concat(value, "_").concat(units));
  };

  return React__default.createElement("div", {
    "data-testid": "relative-time"
  }, React__default.createElement(TimePeriod, {
    label: timeLabel,
    unitsPlaceholder: unitsPlaceholderLabel,
    relativity: relativity,
    value: value,
    units: units,
    disableAutoFocus: disableAutoFocus,
    onChange: onChange
  }), React__default.createElement(RelativityContainer, {
    onClick: function onClick() {
      return updateRelativity();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === KEYBOARD_KEYS.ENTER) {
        updateRelativity();
      }
    }
  }, React__default.createElement(Checkbox, {
    id: "relativity",
    checked: relativity === THIS_RELATIVITY
  }), React__default.createElement(CheckboxLabel, null, React__default.createElement(Title$1, null, interval === 'day' ? relativityTitleForTodayLabel : "".concat(relativityTitleLabel, " ").concat(interval)))));
};

var Container$3 = styled.div.withConfig({
  displayName: "empty-searchstyles__Container",
  componentId: "keen-ui-core__sc-1u1juxj-0"
})(["&&&{padding:20px 10px;display:flex;flex-direction:column;align-items:center;justify-content:center;}"]);
var Message = styled.div.withConfig({
  displayName: "empty-searchstyles__Message",
  componentId: "keen-ui-core__sc-1u1juxj-1"
})(["&&&{margin-top:10px;font-family:Lato,sans-serif;font-weight:400;font-size:14px;color:", ";line-height:30px;}"], colors.blue[500]);

var EmptySearch = function EmptySearch(_ref) {
  var message = _ref.message;
  return React__default.createElement(Container$3, null, React__default.createElement("svg", {
    width: "185",
    height: "94",
    viewBox: "0 0 185 94"
  }, React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("circle", {
    cx: "52",
    cy: "73",
    r: "10",
    fill: "#4F5B5F",
    opacity: ".1"
  }), React__default.createElement("circle", {
    cx: "138",
    cy: "62",
    r: "11",
    fill: "#85B4C3",
    opacity: ".15"
  }), React__default.createElement("circle", {
    cx: "59",
    cy: "16",
    r: "8",
    fill: "#85B4C3",
    opacity: ".15"
  }), React__default.createElement("circle", {
    cx: "27.5",
    cy: "36.5",
    r: "16.5",
    fill: "#85B4C3",
    opacity: ".15"
  }), React__default.createElement("circle", {
    cx: "126",
    cy: "24",
    r: "9",
    fill: "#85B4C3",
    opacity: ".15"
  }), React__default.createElement("circle", {
    cx: "90",
    cy: "89",
    r: "5",
    fill: "#85B4C3",
    opacity: ".15"
  }), React__default.createElement("circle", {
    cx: "11",
    cy: "70",
    r: "5",
    fill: "#85B4C3",
    opacity: ".15"
  }), React__default.createElement("circle", {
    cx: "95",
    cy: "5",
    r: "5",
    fill: "#4F5B5F",
    opacity: ".1"
  }), React__default.createElement("circle", {
    cx: "180",
    cy: "62",
    r: "5",
    fill: "#85B4C3",
    opacity: ".15"
  }), React__default.createElement("circle", {
    cx: "5",
    cy: "9",
    r: "5",
    fill: "#4F5B5F",
    opacity: ".1"
  }), React__default.createElement("circle", {
    cx: "162",
    cy: "31",
    r: "12",
    fill: "#4F5B5F",
    opacity: ".1"
  }), React__default.createElement("circle", {
    cx: "94",
    cy: "53",
    r: "23",
    fill: "#4F5B5F",
    opacity: ".1"
  }), React__default.createElement("g", {
    fill: "#27566D",
    fillRule: "nonzero",
    opacity: ".5",
    transform: "translate(63 25)"
  }, React__default.createElement("path", {
    d: "M24,0 C37.254834,0 48,10.745166 48,24 C48,37.254834 37.254834,48 24,48 C10.745166,48 0,37.254834 0,24 C0,10.745166 10.745166,0 24,0 Z M24,5.33333333 C13.6906847,5.33333333 5.33333333,13.6906847 5.33333333,24 C5.33333333,34.3093153 13.6906847,42.6666667 24,42.6666667 C34.3093153,42.6666667 42.6666667,34.3093153 42.6666667,24 C42.6666667,13.6906847 34.3093153,5.33333333 24,5.33333333 Z"
  }), React__default.createElement("polygon", {
    points: "42.846 38 59 54.154 54.154 59 38 42.846"
  })))), React__default.createElement(Message, null, message));
};

var TextEllipsis = styled.div.withConfig({
  displayName: "text-ellipsiscomponent__TextEllipsis",
  componentId: "keen-ui-core__sc-1hdp19a-0"
})(["&&&{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;}"]);

var Container$2 = styled.div.withConfig({
  displayName: "list-rowstyles__Container",
  componentId: "keen-ui-core__sc-etv0zb-0"
})(["&&&:focus-visible{outline:1px solid ", ";}"], colors.lightBlue[500]);
var ListItem = styled.div.withConfig({
  displayName: "list-rowstyles__ListItem",
  componentId: "keen-ui-core__sc-etv0zb-1"
})(["&&&{padding:7px 10px;display:flex;align-items:center;justify-content:space-between;column-gap:10px;cursor:pointer;transition:background 0.2s linear;", ";}&&&:hover{background:", ";}"], function (props) {
  return props.isActive && css(["background:", ";"], transparentize(0.8, colors.green[100]));
}, transparentize(0.8, colors.green[100]));

var ListRow = function ListRow(_ref) {
  var data = _ref.data,
      index = _ref.index,
      style = _ref.style;
  var timezones = data.timezones,
      timezone = data.timezone,
      onChange = data.onChange,
      onCancel = data.onCancel;
  var _timezones$index = timezones[index],
      name = _timezones$index.name,
      utcOffset = _timezones$index.utcOffset;
  return React__default.createElement(Container$2, {
    style: style,
    role: "listitem",
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === KEYBOARD_KEYS.ENTER) {
        onChange(name);
        onCancel();
      }
    }
  }, React__default.createElement(ListItem, {
    isActive: timezone && name === timezone.name,
    onClick: function onClick() {
      onChange(name);
    }
  }, React__default.createElement(TextEllipsis, null, React__default.createElement(BodyText, {
    variant: "body3",
    fontWeight: 400,
    color: colors.blue[500]
  }, name)), utcOffset && React__default.createElement(BodyText, {
    variant: "body3",
    fontWeight: 400,
    color: colors.blue[200]
  }, utcOffset)));
};

var FixedList = forwardRef(function (_ref, ref) {
  var itemData = _ref.itemData,
      itemCount = _ref.itemCount,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 150 : _ref$height;
  return React__default.createElement(FixedSizeList, {
    ref: ref,
    height: height,
    "data-testid": "fixed-list",
    itemData: itemData,
    itemCount: itemCount,
    itemSize: 28,
    width: "100%"
  }, ListRow);
});
FixedList.displayName = 'FixedList';

var NoWrap = styled.div.withConfig({
  displayName: "no-wrapcomponent__NoWrap",
  componentId: "keen-ui-core__sc-uptwg8-0"
})(["&&&{white-space:nowrap;}"]);

var Heading = styled.div.withConfig({
  displayName: "timezone-errorstyles__Heading",
  componentId: "keen-ui-core__sc-13k3j97-0"
})(["&&&{margin-bottom:5px;display:inline-flex;}"]);
var Title = styled.div.withConfig({
  displayName: "timezone-errorstyles__Title",
  componentId: "keen-ui-core__sc-13k3j97-1"
})(["&&&{display:flex;align-items:center;}"]);
var Warning = styled.div.withConfig({
  displayName: "timezone-errorstyles__Warning",
  componentId: "keen-ui-core__sc-13k3j97-2"
})(["&&&{display:flex;align-items:center;margin-left:5px;}"]);
var DisabledContainer = styled.div.withConfig({
  displayName: "timezone-errorstyles__DisabledContainer",
  componentId: "keen-ui-core__sc-13k3j97-3"
})(["&&&{opacity:0.5;cursor:not-allowed;}"]);

var TimezoneError = function TimezoneError(_ref) {
  var label = _ref.label,
      placeholder = _ref.placeholder,
      tooltipPortal = _ref.tooltipPortal,
      tooltipMessage = _ref.tooltipMessage;
  return React__default.createElement("div", null, React__default.createElement(Heading, null, React__default.createElement(MousePositionedTooltip, {
    isActive: true,
    tooltipPortal: tooltipPortal,
    tooltipTheme: "dark",
    renderContent: function renderContent() {
      return React__default.createElement(BodyText, {
        variant: "body3",
        color: colors.white[500],
        fontWeight: "normal"
      }, tooltipMessage);
    }
  }, React__default.createElement(Title, null, React__default.createElement(BodyText, {
    color: transparentize(0.5, colors.black[100]),
    fontWeight: "bold",
    variant: "body2"
  }, label), React__default.createElement(Warning, null, React__default.createElement(Icon, {
    type: "warning",
    fill: colors.red[500],
    width: 15,
    height: 15
  }))))), React__default.createElement(DisabledContainer, null, React__default.createElement(DropableContainer, {
    variant: "secondary",
    isActive: false,
    value: null,
    placeholder: placeholder,
    dropIndicator: true
  })));
};

var Container$1 = styled.div.withConfig({
  displayName: "timezonestyles__Container",
  componentId: "keen-ui-core__sc-155sgy0-0"
})(["&&&{padding:10px 15px;display:flex;flex-direction:column;", ";}"], function (props) {
  return props.isDisabled && css(["opacity:0.5;"]);
});
var SelectContainer = styled.div.withConfig({
  displayName: "timezonestyles__SelectContainer",
  componentId: "keen-ui-core__sc-155sgy0-1"
})(["&&&{position:relative;}"]);
var CustomDropdown = styled(motion.div).withConfig({
  displayName: "timezonestyles__CustomDropdown",
  componentId: "keen-ui-core__sc-155sgy0-2"
})(["&&&{width:100%;min-width:280px;background:", ";border:solid 1px ", ";box-shadow:0 10px 24px 0 rgba(29,39,41,0.15);position:absolute;left:50%;top:auto;bottom:auto;z-index:", ";", ";}"], colors.white[500], colors.gray[200], UI_LAYERS.dropdown, function (_ref) {
  var position = _ref.position;
  return position === 'bottom' ? css(["top:100%;"]) : css(["bottom:100%;"]);
});
var DropableContent = styled.div.withConfig({
  displayName: "timezonestyles__DropableContent",
  componentId: "keen-ui-core__sc-155sgy0-3"
})(["&&&{display:flex;justify-content:space-between;align-items:center;column-gap:10px;flex:1;min-width:0;}"]);

var dropdownMotion = {
  bottom: {
    initial: {
      opacity: 0,
      y: 20,
      x: '-50%'
    },
    animate: {
      opacity: 1,
      y: 2
    },
    exit: {
      opacity: 0,
      y: 30
    }
  },
  top: {
    initial: {
      opacity: 0,
      y: -20,
      x: '-50%'
    },
    animate: {
      opacity: 1,
      y: -2
    },
    exit: {
      opacity: 0,
      y: -30
    }
  }
};

var Timezone = function Timezone(_ref) {
  var timezone = _ref.timezone,
      timezones = _ref.timezones,
      _ref$disableSelection = _ref.disableSelection,
      disableSelection = _ref$disableSelection === void 0 ? false : _ref$disableSelection,
      timezoneLabel = _ref.timezoneLabel,
      timezonePlaceholderLabel = _ref.timezonePlaceholderLabel,
      emptySearchLabel = _ref.emptySearchLabel,
      dropdownHeight = _ref.dropdownHeight,
      onChange = _ref.onChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      searchPhrase = _useState4[0],
      setSearchPhrase = _useState4[1];

  var _useState5 = useState('bottom'),
      _useState6 = _slicedToArray(_useState5, 2),
      dropdownPosition = _useState6[0],
      setDropdownPosition = _useState6[1];

  var listRef = useRef(null);
  var customDropdownRef = useRef(null);

  var availableTimezones = function availableTimezones() {
    if (searchPhrase !== '') {
      return timezones.filter(function (_ref2) {
        var name = _ref2.name,
            utcOffset = _ref2.utcOffset;
        return "".concat(name).concat(utcOffset).toLowerCase().includes(searchPhrase.toLowerCase());
      });
    }

    return timezones;
  };

  var availableTimezonesLength = availableTimezones().length;
  useEffect(function () {
    if (!timezone) return;
    setSearchPhrase('');
    var index = timezones.findIndex(function (tz) {
      return tz.name === timezone;
    });
    if (index && (listRef === null || listRef === void 0 ? void 0 : listRef.current)) listRef.current.scrollToItem(index, 'smart');
  }, [timezone, isOpen]);
  useEffect(function () {
    if (isOpen && disableSelection) setOpen(false);
  }, [disableSelection]);
  useLayoutEffect(function () {
    if (!customDropdownRef.current) return;

    var _customDropdownRef$cu = customDropdownRef.current.getBoundingClientRect(),
        bottom = _customDropdownRef$cu.bottom;

    var position = bottom > window.innerHeight ? 'top' : 'bottom';
    setDropdownPosition(position);
  }, [isOpen]);

  var searchHandler = function searchHandler(e) {
    return setSearchPhrase(e.target.value);
  };

  var _useMemo = useMemo(function () {
    if (timezones.length === 0) {
      return {
        name: timezone,
        utcOffset: null
      };
    }

    var selectedTimezone = timezones.find(function (tz) {
      return tz.name === timezone;
    });

    if (!selectedTimezone) {
      return {
        name: timezone,
        utcOffset: null
      };
    }

    var name = selectedTimezone.name,
        utcOffset = selectedTimezone.utcOffset;
    return {
      name: name,
      utcOffset: utcOffset
    };
  }, [timezone, timezones]),
      name = _useMemo.name,
      utcOffset = _useMemo.utcOffset;

  var options = {
    timezones: availableTimezones(),
    timezone: {
      name: name,
      utcOffset: utcOffset
    },
    onChange: onChange,
    onCancel: function onCancel() {
      return setOpen(false);
    }
  };
  var keyboardHandler = useCallback(function (_e, keyCode) {
    if (keyCode === KEYBOARD_KEYS.ESCAPE) {
      setOpen(false);
    }
  }, []);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ESCAPE],
    addEventListenerCondition: isOpen,
    eventListenerDependencies: [isOpen]
  });
  return React__default.createElement(Container$1, {
    isDisabled: disableSelection,
    "data-testid": "timezone"
  }, React__default.createElement(Title$1, {
    onClick: function onClick() {
      return disableSelection ? null : setOpen(true);
    }
  }, timezoneLabel), React__default.createElement(SelectContainer, null, React__default.createElement(DropableContainer, {
    variant: "secondary",
    dropIndicator: true,
    searchable: true,
    onClick: function onClick() {
      return !isOpen && !disableSelection && setOpen(true);
    },
    placeholder: timezonePlaceholderLabel,
    isActive: isOpen,
    value: timezone,
    onSearch: searchHandler,
    onDefocus: function onDefocus() {
      setOpen(false);
    }
  }, timezone && React__default.createElement(DropableContent, null, React__default.createElement(TextEllipsis, null, name), utcOffset && React__default.createElement(NoWrap, null, React__default.createElement(BodyText, {
    variant: "body3",
    fontWeight: 400,
    color: colors.blue[200]
  }, utcOffset)))), React__default.createElement(AnimatePresence, null, isOpen && React__default.createElement(CustomDropdown, Object.assign({
    ref: customDropdownRef,
    position: dropdownPosition
  }, dropdownMotion[dropdownPosition]), availableTimezonesLength ? React__default.createElement(FixedList, {
    ref: listRef,
    itemData: options,
    itemCount: availableTimezonesLength,
    height: dropdownHeight
  }) : React__default.createElement(EmptySearch, {
    message: emptySearchLabel
  })))));
};

var TitleContainer = styled(motion.div).withConfig({
  displayName: "accordionstyles__TitleContainer",
  componentId: "keen-ui-core__sc-1g2vi1m-0"
})(["&&&{margin-bottom:5px;padding:10px;background-color:", ";display:flex;align-items:center;column-gap:10px;cursor:pointer;}"], transparentize(0.8, colors.green[100]));
var IconContainer = styled(motion.div).withConfig({
  displayName: "accordionstyles__IconContainer",
  componentId: "keen-ui-core__sc-1g2vi1m-1"
})(["&&&{flex-shrink:0;display:flex;transform-origin:50% 50%;}"]);
var ContentContainer = styled(motion.div).withConfig({
  displayName: "accordionstyles__ContentContainer",
  componentId: "keen-ui-core__sc-1g2vi1m-2"
})(["&&&{will-change:height;overflow:hidden;}"]);
var Content = styled.div.withConfig({
  displayName: "accordionstyles__Content",
  componentId: "keen-ui-core__sc-1g2vi1m-3"
})(["&&&{margin:15px 10px 10px 10px;", ";}"], function (_ref) {
  var maxHeight = _ref.maxHeight;
  return maxHeight && css(["max-height:", "px;overflow:scroll;"], maxHeight);
});

var iconMotion = {
  open: {
    rotate: 90
  },
  close: {
    rotate: 0
  }
};
var contentMotion = {
  open: {
    height: 'auto',
    opacity: 1,
    transition: {
      ease: 'easeInOut',
      duration: 0.25,
      delay: 0
    }
  },
  close: {
    height: 0,
    opacity: 0
  }
};

var Accordion = function Accordion(_ref) {
  var title = _ref.title,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      onChange = _ref.onChange,
      maxHeight = _ref.maxHeight,
      children = _ref.children;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(TitleContainer, {
    onClick: function onClick() {
      if (onChange) onChange(!isOpen);
    },
    whileHover: {
      backgroundColor: transparentize(0.5, colors.green[100])
    }
  }, React__default.createElement(Headline, {
    variant: "h3",
    enableTextEllipsis: true
  }, title), React__default.createElement(IconContainer, {
    variants: iconMotion,
    initial: "close",
    animate: isOpen ? 'open' : 'close'
  }, React__default.createElement(Icon, {
    width: 14,
    fill: colors.green[500],
    opacity: 0.7,
    type: "caret-right"
  }))), React__default.createElement(AnimatePresence, {
    initial: false
  }, isOpen && React__default.createElement(ContentContainer, {
    variants: contentMotion,
    initial: "close",
    animate: "open",
    exit: "close"
  }, React__default.createElement(Content, {
    maxHeight: maxHeight
  }, children))));
};

var ELEMENT_HEIGHT = 36;
var LIST_HEIGHT = 200;

var Container = styled.div.withConfig({
  displayName: "tree-leafstyles__Container",
  componentId: "keen-ui-core__sc-o11tk3-0"
})(["&&&{position:relative;display:flex;height:", "px;padding-right:15px;padding-top:10px;padding-bottom:10px;width:100%;box-sizing:border-box;cursor:pointer;transition:background 0.2s linear;", ";}&&&:hover{background:", ";}&&&:focus-visible{outline:1px solid ", ";}"], ELEMENT_HEIGHT, function (props) {
  return props.isActive && css(["background:", ";"], transparentize(0.8, colors.green[100]));
}, transparentize(0.8, colors.green[100]), colors.lightBlue[500]);
var Type = styled.div.withConfig({
  displayName: "tree-leafstyles__Type",
  componentId: "keen-ui-core__sc-o11tk3-1"
})(["&&&{padding-left:5px;margin-left:auto;flex-shrink:0;}"]);

var SEPARATOR = '.';
var PADDING$1 = 15;

var tooltipMotion = {
  transition: {
    duration: 0.3
  },
  exit: {
    opacity: 0
  }
};

var TreeLeaf = function TreeLeaf(_ref) {
  var _onClick = _ref.onClick,
      propertyName = _ref.propertyName,
      propertyType = _ref.propertyType,
      propertyPath = _ref.propertyPath,
      isActive = _ref.isActive,
      deepnessLevel = _ref.deepnessLevel,
      modalContainer = _ref.modalContainer;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isEllipsisActive = _useState2[0],
      setEllipsis = _useState2[1];

  var nameRef = useRef(null);

  var _useState3 = useState({
    visible: false,
    x: 0,
    y: 0
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      tooltip = _useState4[0],
      setTooltip = _useState4[1];

  useEffect(function () {
    var element = nameRef.current;
    var contentOverflow = element.offsetWidth < element.scrollWidth;
    setEllipsis(contentOverflow);
  }, [propertyPath]);
  return React__default.createElement(Container, {
    style: {
      paddingLeft: PADDING$1 + deepnessLevel * PADDING$1
    },
    isActive: isActive,
    onMouseMove: function onMouseMove(e) {
      if (isEllipsisActive) {
        setTooltip({
          x: e.pageX,
          y: e.pageY,
          visible: true
        });
      }
    },
    onMouseLeave: function onMouseLeave() {
      if (isEllipsisActive) setTooltip({
        x: 0,
        y: 0,
        visible: false
      });
    },
    onClick: function onClick(e) {
      return _onClick(e, propertyPath);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === KEYBOARD_KEYS.ENTER) {
        _onClick(e, propertyPath);
      }
    },
    tabIndex: 0
  }, React__default.createElement(BodyText, {
    ref: nameRef,
    variant: "body2",
    lineHeight: 1,
    color: colors.blue[500],
    enableTextEllipsis: true
  }, propertyName), React__default.createElement(Type, null, React__default.createElement(BodyText, {
    variant: "body2",
    lineHeight: 1,
    color: transparentize(0.5, colors.black[500])
  }, propertyType)), React__default.createElement(AnimatePresence, null, tooltip.visible && React__default.createElement(Portal, {
    modalContainer: modalContainer
  }, React__default.createElement(motion.div, Object.assign({}, tooltipMotion, {
    "data-testid": "property-tooltip",
    initial: {
      opacity: 0,
      x: tooltip.x,
      y: tooltip.y
    },
    animate: {
      x: tooltip.x,
      y: tooltip.y,
      opacity: 1
    },
    style: {
      zIndex: 2,
      position: 'absolute',
      pointerEvents: 'none'
    }
  }), React__default.createElement(Tooltip, {
    mode: "dark",
    hasArrow: false
  }, propertyPath.split(SEPARATOR).map(function (path, idx, collection) {
    return React__default.createElement(BodyText, {
      key: idx,
      variant: "body2",
      color: colors.white[500],
      fontWeight: idx + 1 === collection.length ? 'bold' : 'normal'
    }, idx > 0 ? '.' : '', path);
  }))))));
};

var Header = styled.div.withConfig({
  displayName: "tree-nodestyles__Header",
  componentId: "keen-ui-core__sc-y1cvbf-0"
})(["&&&{height:", "px;display:flex;align-items:center;cursor:pointer;}&&&:focus-visible{outline:1px solid ", ";}"], ELEMENT_HEIGHT, colors.lightBlue[500]);
var MotionIcon = styled(motion.div).withConfig({
  displayName: "tree-nodestyles__MotionIcon",
  componentId: "keen-ui-core__sc-y1cvbf-1"
})(["&&&{display:flex;flex-shrink:0;align-items:center;margin-left:4px;}"]);

var PADDING = 15;

var TreeNode = function TreeNode(_ref) {
  var name = _ref.name,
      deepnessLevel = _ref.deepnessLevel,
      isOpen = _ref.isOpen,
      onClick = _ref.onClick;
  return React__default.createElement(Header, {
    style: {
      paddingLeft: PADDING + deepnessLevel * PADDING
    },
    onClick: onClick,
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === KEYBOARD_KEYS.ENTER) onClick();
    },
    tabIndex: 0
  }, React__default.createElement(BodyText, {
    variant: "body2",
    color: colors.blue[500],
    fontWeight: "bold",
    lineHeight: 1,
    enableTextEllipsis: true
  }, name), React__default.createElement(MotionIcon, {
    initial: false,
    animate: isOpen ? {
      rotate: 90
    } : {
      rotate: 0
    }
  }, React__default.createElement(Icon, {
    type: "caret-right",
    fill: colors.blue[500],
    width: 10,
    height: 10
  })));
};

var getPropertyType = function getPropertyType(property) {
  var _property = _slicedToArray(property, 2),
      type = _property[1];

  return type;
};

var getPropertyPath = function getPropertyPath(property) {
  var _property = _slicedToArray(property, 1),
      path = _property[0];

  return path;
};

var createTreeWalker = function createTreeWalker(properties, isOpenByDefault) {
  return function* treeWalker(refreshTree) {
    var stack = [];
    Object.keys(properties).forEach(function (propertyKey) {
      stack.push({
        deepnessLevel: 0,
        node: {
          id: propertyKey,
          name: propertyKey,
          children: properties[propertyKey]
        }
      });
    });

    var _loop = function* _loop() {
      var _stack$pop = stack.pop(),
          _stack$pop$node = _stack$pop.node,
          children = _stack$pop$node.children,
          id = _stack$pop$node.id,
          name = _stack$pop$node.name,
          deepnessLevel = _stack$pop.deepnessLevel;

      var isOpened = yield refreshTree ? {
        id: id,
        isLeaf: Array.isArray(children),
        schemaMeta: Array.isArray(children) ? children : null,
        isOpenByDefault: isOpenByDefault,
        deepnessLevel: deepnessLevel,
        name: name
      } : id;

      if (!Array.isArray(children) && Object.keys(children).length !== 0 && isOpened) {
        Object.keys(children).forEach(function (key) {
          stack.push({
            deepnessLevel: deepnessLevel + 1,
            node: {
              name: key,
              id: "".concat(id, ".").concat(key),
              children: children[key]
            }
          });
        });
      }
    };

    while (stack.length !== 0) {
      yield* _loop();
    }
  };
};

var getFromPath = function getFromPath(dataObject, selector) {
  return selector.reduce(function (acc, key) {
    if (acc === null) return dataObject[key];
    if (_typeof(acc) === 'object' && acc !== null) return acc[key];
    return acc;
  }, null);
};

var setValue = function setValue(obj, path, value) {
  var keys = path.split('.');
  var objectCopy = obj;
  var isPathExist = getFromPath(objectCopy, keys);

  while (keys.length - 1) {
    var _key = keys.shift();

    if (!(_key in objectCopy)) objectCopy[_key] = {};
    objectCopy = objectCopy[_key];
  }

  var key = isPathExist ? "".concat(keys[0], " (node)") : keys[0];
  objectCopy[key] = [path, value];
};

var createTree = function createTree(properties) {
  return Object.keys(properties).sort().reverse().reduce(function (acc, key) {
    var propertyType = properties[key];
    setValue(acc, key, propertyType);
    return acc;
  }, {});
};

var PropertiesTreeContext = React__default.createContext({
  modalContainer: ''
});

var Node = function Node(_ref) {
  var _ref$data = _ref.data,
      name = _ref$data.name,
      isLeaf = _ref$data.isLeaf,
      schemaMeta = _ref$data.schemaMeta,
      deepnessLevel = _ref$data.deepnessLevel,
      isOpen = _ref.isOpen,
      style = _ref.style,
      toggle = _ref.toggle,
      treeData = _ref.treeData;

  var _useContext = useContext(PropertiesTreeContext),
      modalContainer = _useContext.modalContainer;

  var activeProperty = treeData.activeProperty,
      onSelectProperty = treeData.onSelectProperty;
  return React__default.createElement("div", {
    style: style
  }, isLeaf ? React__default.createElement(TreeLeaf, {
    isActive: activeProperty === getPropertyPath(schemaMeta),
    propertyName: name,
    onClick: onSelectProperty,
    deepnessLevel: deepnessLevel,
    propertyType: getPropertyType(schemaMeta),
    propertyPath: getPropertyPath(schemaMeta),
    modalContainer: modalContainer
  }) : React__default.createElement(TreeNode, {
    name: name,
    isOpen: isOpen,
    deepnessLevel: deepnessLevel,
    onClick: toggle
  }));
};

var PropertiesTree = function PropertiesTree(_ref2) {
  var expanded = _ref2.expanded,
      onClick = _ref2.onClick,
      activeProperty = _ref2.activeProperty,
      properties = _ref2.properties,
      modalContainer = _ref2.modalContainer;
  var treeRef = useRef(null);
  var expandTrigger = useRef(null);
  useEffect(function () {
    if (expandTrigger.current) clearTimeout(expandTrigger.current);

    if (treeRef.current) {
      treeRef.current.recomputeTree({
        refreshNodes: true,
        useDefaultOpenness: true
      });
    }
  }, [expanded, treeRef]);
  return React__default.createElement(PropertiesTreeContext.Provider, {
    value: {
      modalContainer: modalContainer
    }
  }, React__default.createElement("div", {
    "data-testid": "properties-tree"
  }, React__default.createElement(FixedSizeTree, {
    ref: treeRef,
    treeWalker: createTreeWalker(properties, expanded),
    itemData: {
      activeProperty: activeProperty,
      onSelectProperty: onClick
    },
    itemSize: ELEMENT_HEIGHT,
    height: LIST_HEIGHT,
    width: "100%"
  }, Node)));
};

var Menu = styled.ul.withConfig({
  displayName: "side-menustyles__Menu",
  componentId: "keen-ui-core__sc-1lkzxik-0"
})(["&&&{padding:0;margin:0;}"]);
var MenuItem = styled.li.withConfig({
  displayName: "side-menustyles__MenuItem",
  componentId: "keen-ui-core__sc-1lkzxik-1"
})(["&&&{height:37px;padding-left:20px;margin-bottom:5px;display:flex;align-items:center;cursor:pointer;border-radius:0 4px 4px 0;transition:background 150ms ease-out;", ";", ";}&&&:last-child{margin-bottom:0;}&&&:focus-visible{outline:1px solid ", ";}"], function (props) {
  return props.isActive && css(["background:", ";border-left:4px solid;padding-left:16px;border-color:", ";box-shadow:0 4px 8px 0 ", ";"], transparentize(0.7, colors.green[100]), colors.green[500], transparentize(0.85, colors.black[500]));
}, function (props) {
  return !props.isActive && css(["&:hover{background:", ";}"], transparentize(0.9, colors.green[100]));
}, colors.lightBlue[500]);

var SideMenu = function SideMenu(_ref) {
  var menuItems = _ref.menuItems,
      onChange = _ref.onChange,
      activeItemId = _ref.activeItemId;

  var onActiveItemChange = function onActiveItemChange(activeItem) {
    onChange(activeItem.id);
  };

  return React__default.createElement(Menu, {
    role: "tablist"
  }, menuItems.map(function (item) {
    return React__default.createElement(MenuItem, {
      isActive: item.id === activeItemId,
      onClick: function onClick() {
        return onActiveItemChange(item);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.keyCode === KEYBOARD_KEYS.ENTER) {
          onActiveItemChange(item);
        }
      },
      key: item.id,
      role: "tab",
      tabIndex: 0
    }, React__default.createElement(BodyText, {
      variant: "body2",
      fontWeight: "bold",
      color: colors.black[300]
    }, item.label));
  }));
};

export { ARROW_SIZE, AbsoluteTime, Accordion, ActionButton, Alert, Anchor, Badge, Brand, BulletList, Button, CDNContext, Card, Checkbox, CircleButton, Color, ColorAdjuster, ColorPalette, ColorPicker, ColorScale, ContentSeparator, ReactCalendar as DatePicker, DropableContainer, Dropdown, DropdownList, DropdownListContainer, DropdownMenu, DynamicPortal, EmptySearch, Error$1 as Error, FadeLoader, FakeInput, Filters, FontLoaderInstance as FontLoader, Group, Image, Input$1 as Input, IntervalSlider, KEYBOARD_KEYS, Label$3 as Label, Loader, LoadingScreen, Modal, ModalContent, ModalFooter, ModalHeader, MousePositionedTooltip, OAuthProviders, OAuthUserAction, PER_PAGE_OPTIONS, PasswordInput, PasswordValidator, Portal, PropertiesTree, Radio, RadioGroup$1 as RadioGroup, RadioGroup as RadioSelect, RangeSlider, RefText, RelativeTime, Ruler, ScrollWrapper, Select, SideMenu, SuccessNotification, TIME_UNITS, TableCell, TableFooter, TableHeader, TableRow, Tabs, TagManagement, TagManager, Text$1 as Text, TimePeriod, Timezone, TimezoneError, Title$3 as Title, Title$1 as TitleComponent, Toggle, Tooltip, TypographySettings, UI_LAYERS, calculateIntervalValue, convertRelativeTime, createTree, exportToHtml, getIndex, getInterval, isElementInViewport, mutateArray, screenBreakpoints, useFontLoader };
//# sourceMappingURL=index.esm.js.map
